{
  "afjall": {
    "coverProducts": null,
    "covers": [
      {
        "name": "white"
      }
    ],
    "displayName": "ÅFJÄLL",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": [
      {
        "itemNo": "10568638",
        "name": "afjall-foam-mattress-firm-white"
      },
      {
        "itemNo": "50568641",
        "name": "afjall-foam-mattress-firm-white"
      },
      {
        "itemNo": "70568640",
        "name": "afjall-foam-mattress-firm-white"
      },
      {
        "itemNo": "70569885",
        "name": "afjall-foam-mattress-medium-firm-white"
      },
      {
        "itemNo": "90568639",
        "name": "afjall-foam-mattress-firm-white"
      }
    ],
    "sofas": []
  },
  "alvdalen": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "knisa-grey-beige",
        "dotOverride": "#8B8883"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "knisa-dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "ÄLVDALEN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "63383",
        "cover": "knisa-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "10530669",
        "rangeId": "alvdalen",
        "widthInMillimeters": 1960
      },
      {
        "code": "63383",
        "cover": "knisa-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "20530664",
        "rangeId": "alvdalen",
        "widthInMillimeters": 1960
      },
      {
        "code": "63382",
        "cover": "knisa-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "50530648",
        "rangeId": "alvdalen",
        "widthInMillimeters": 1940
      },
      {
        "code": "63382",
        "cover": "knisa-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "80462596",
        "rangeId": "alvdalen",
        "widthInMillimeters": 1940
      }
    ]
  },
  "angersby": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "knisa-light-grey"
      }
    ],
    "displayName": "ANGERSBY",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "45980",
        "cover": "knisa-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10469186",
        "rangeId": "angersby",
        "widthInMillimeters": 1370
      },
      {
        "cover": "knisa-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "60499077",
        "rangeId": "angersby",
        "widthInMillimeters": 1960
      },
      {
        "code": "53405",
        "cover": "knisa-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "90499066",
        "rangeId": "angersby",
        "widthInMillimeters": 1960
      }
    ]
  },
  "applaryd": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "djuparp-red-brown",
        "dotOverride": "#692925"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-blue",
        "dotOverride": "#293046"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "lejde-light-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "lejde-grey-black",
        "dotOverride": "#787878"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00023.jpg",
        "name": "gunnared-light-blue",
        "dotOverride": "#83A4B0"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "gunnared-black-grey",
        "dotOverride": "#464849"
      }
    ],
    "displayName": "ÄPPLARYD",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "54825",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "00504307",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54840",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10504279",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54840",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10504284",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54825",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10504302",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54840",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20506225",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54840",
        "cover": "gunnared-light-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20575068",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54840",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "30504278",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54825",
        "cover": "lejde-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30506239",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54825",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "40504305",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54840",
        "cover": "gunnared-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40575029",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54825",
        "cover": "gunnared-light-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50575081",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54840",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "60504286",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54825",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "70506237",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54825",
        "cover": "gunnared-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "70575075",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "code": "54840",
        "cover": "lejde-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "80506227",
        "rangeId": "applaryd",
        "widthInMillimeters": 1990
      },
      {
        "code": "54825",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "90504303",
        "rangeId": "applaryd",
        "widthInMillimeters": 2310
      },
      {
        "childItems": [
          "20506268",
          "80506227"
        ],
        "code": "54830",
        "cover": "lejde-light-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09418051",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "90504303",
          "60504314"
        ],
        "code": "54831",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09429530",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "30575138",
          "40575029"
        ],
        "code": "54828",
        "cover": "gunnared-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09528158",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "70575075",
          "80575089"
        ],
        "code": "54831",
        "cover": "gunnared-black-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09528177",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "60504314",
          "30504278"
        ],
        "code": "54830",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19418041",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "00504307",
          "30504320"
        ],
        "code": "54831",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19429520",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "40575029",
          "80575089"
        ],
        "code": "54830",
        "cover": "gunnared-black-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19528167",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "20575068",
          "20575134"
        ],
        "code": "54830",
        "cover": "gunnared-light-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19528172",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "30504320",
          "10504284"
        ],
        "code": "54830",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29418045",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "10504321",
          "60504286"
        ],
        "code": "54830",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29418069",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "50575081",
          "20575134"
        ],
        "code": "54831",
        "cover": "gunnared-light-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49528180",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "50506281",
          "20506225"
        ],
        "code": "54828",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59418015",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "60506266",
          "20506225"
        ],
        "code": "54830",
        "cover": "lejde-grey-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69418067",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "50575142",
          "20575068"
        ],
        "code": "54828",
        "cover": "gunnared-light-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69528160",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "10506283",
          "80506227"
        ],
        "code": "54828",
        "cover": "lejde-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79418024",
        "rangeId": "applaryd"
      },
      {
        "childItems": [
          "40504305",
          "70504323"
        ],
        "code": "54831",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89429526",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "70504323",
          "10504279"
        ],
        "code": "54830",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99418061",
        "rangeId": "applaryd",
        "widthInMillimeters": 2900
      },
      {
        "childItems": [
          "10504302",
          "10504321"
        ],
        "code": "54831",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99429521",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "70506237",
          "60506266"
        ],
        "code": "54831",
        "cover": "lejde-grey-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99429535",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "30506239",
          "20506268"
        ],
        "code": "54831",
        "cover": "lejde-light-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99429540",
        "rangeId": "applaryd",
        "widthInMillimeters": 3220
      }
    ]
  },
  "asvang": {
    "coverProducts": null,
    "covers": [
      {
        "name": "white"
      }
    ],
    "displayName": "ÅSVANG",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": [
      {
        "itemNo": "20481404",
        "name": "asvang-foam-mattress-medium-firm-white"
      },
      {
        "itemNo": "40481403",
        "name": "asvang-foam-mattress-medium-firm-white"
      }
    ],
    "sofas": []
  },
  "balkarp": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "knisa-black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "vissle-grey"
      }
    ],
    "displayName": "BALKARP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "29005",
        "cover": "knisa-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40387311",
        "rangeId": "balkarp",
        "widthInMillimeters": 1700
      },
      {
        "code": "29005",
        "cover": "vissle-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50307936",
        "rangeId": "balkarp",
        "widthInMillimeters": 840
      }
    ]
  },
  "barslov": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00102.jpg",
        "name": "tibbleby-light-grey-turquoise"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tibbleby-beige-grey"
      }
    ],
    "displayName": "BÅRSLÖV",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "64733",
        "cover": "tibbleby-light-grey-turquoise",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30541582",
        "rangeId": "barslov",
        "widthInMillimeters": 2360
      },
      {
        "code": "64643",
        "cover": "tibbleby-light-grey-turquoise",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "80530816",
        "rangeId": "barslov",
        "widthInMillimeters": 2360
      },
      {
        "code": "64733",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "80541589",
        "rangeId": "barslov",
        "widthInMillimeters": 2360
      },
      {
        "code": "64643",
        "cover": "tibbleby-beige-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "80541594",
        "rangeId": "barslov",
        "widthInMillimeters": 2360
      }
    ]
  },
  "billesholm": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "light-beige"
      }
    ],
    "displayName": "BILLESHOLM",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "61714",
        "cover": "grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10489882",
        "rangeId": "billesholm",
        "widthInMillimeters": 1450
      },
      {
        "code": "61714",
        "cover": "light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "60542702",
        "rangeId": "billesholm",
        "widthInMillimeters": 1450
      }
    ]
  },
  "brissund": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00148.jpg",
        "name": "hakebo-light-turquoise"
      }
    ],
    "displayName": "BRISSUND",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "66037",
        "cover": "hakebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30580856",
        "rangeId": "brissund",
        "widthInMillimeters": 2300
      },
      {
        "code": "66037",
        "cover": "hakebo-light-turquoise",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50580860",
        "rangeId": "brissund",
        "widthInMillimeters": 2300
      },
      {
        "code": "66038",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "60580869",
        "rangeId": "brissund",
        "widthInMillimeters": 2300
      },
      {
        "code": "66038",
        "cover": "hakebo-light-turquoise",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90580957",
        "rangeId": "brissund",
        "widthInMillimeters": 2300
      }
    ]
  },
  "danhult": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00149.jpg",
        "name": "kelinge-grey-turquoise",
        "dotOverride": "#54736E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "silkeryd-dark-grey-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00193.jpg",
        "name": "silkeryd-brown-red",
        "dotOverride": "#B15B50"
      }
    ],
    "displayName": "DÅNHULT",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "63680",
        "cover": "grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00572462",
        "rangeId": "danhult",
        "widthInMillimeters": 2220
      },
      {
        "code": "63680",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20572461",
        "rangeId": "danhult",
        "widthInMillimeters": 2220
      },
      {
        "code": "63680",
        "cover": "silkeryd-dark-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50629951",
        "rangeId": "danhult",
        "widthInMillimeters": 2220
      },
      {
        "code": "63680",
        "cover": "silkeryd-brown-red",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "70629950",
        "rangeId": "danhult",
        "widthInMillimeters": 2220
      }
    ]
  },
  "daretorp": {
    "coverProducts": null,
    "covers": [],
    "displayName": "DARETORP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "duvholmen": {
    "coverProducts": null,
    "covers": [
      {
        "name": "grey"
      }
    ],
    "displayName": "DUVHOLMEN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "ekholma": {
    "coverProducts": [
      {
        "itemNo": "00572179",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "00572301",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "00603717",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "00603722",
        "name": "kilanda-brown-red"
      },
      {
        "itemNo": "10572145",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "10572287",
        "name": "hemmesta-grey-beige"
      },
      {
        "itemNo": "10572305",
        "name": "hemmesta-grey-beige"
      },
      {
        "itemNo": "10618619",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "20572197",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "20572324",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "20603721",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "30618623",
        "name": "kilanda-grey-brown"
      },
      {
        "itemNo": "40572196",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "40572281",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "40572323",
        "name": "hemmesta-grey-beige"
      },
      {
        "itemNo": "40618627",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "50572148",
        "name": "kilanda-brown-red"
      },
      {
        "itemNo": "50572172",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "50572285",
        "name": "kilanda-grey-brown"
      },
      {
        "itemNo": "60572181",
        "name": "kilanda-brown-red"
      },
      {
        "itemNo": "60572195",
        "name": "hakebo-beige"
      },
      {
        "itemNo": "60572303",
        "name": "kilanda-grey-brown"
      },
      {
        "itemNo": "60618631",
        "name": "hemmesta-grey-beige"
      },
      {
        "itemNo": "70572147",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "80572180",
        "name": "hakebo-beige"
      },
      {
        "itemNo": "80572302",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "80572321",
        "name": "kilanda-grey-brown"
      },
      {
        "itemNo": "90572146",
        "name": "hakebo-beige"
      },
      {
        "itemNo": "90572194",
        "name": "kilanda-brown-red"
      },
      {
        "itemNo": "90572288",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "90572325",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "90603727",
        "name": "hakebo-dark-grey"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "hemmesta-grey-green",
        "dotOverride": "#7F8F83"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "kilanda-brown-red",
        "dotOverride": "#7A5248"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "hemmesta-grey-beige",
        "dotOverride": "#81796A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00023.jpg",
        "name": "kilanda-pale-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "kilanda-grey-brown",
        "dotOverride": "#6C6252"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hakebo-beige"
      }
    ],
    "displayName": "EKHOLMA",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60572138",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "50572134",
          "00572179"
        ],
        "code": "67063",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09535597",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "10572131",
          "40572295"
        ],
        "code": "66940",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09579925",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "80572137",
          "30572314"
        ],
        "code": "67063",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09579949",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "80572137",
          "60572317"
        ],
        "code": "67063",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09579954",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "50572129",
          "90572146"
        ],
        "code": "66940",
        "cover": "hakebo-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19535587",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "60572138",
          "90572325"
        ],
        "code": "66941",
        "cover": "kilanda-pale-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19562967",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "60572138",
          "40572323"
        ],
        "code": "66941",
        "cover": "hemmesta-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19562972",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "10572131",
          "70572289"
        ],
        "code": "66940",
        "cover": "hemmesta-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19579915",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "10572131",
          "20572282"
        ],
        "code": "66940",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19579920",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "80572137",
          "50572308"
        ],
        "code": "67063",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19579944",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "50572134",
          "60572181"
        ],
        "code": "67063",
        "cover": "kilanda-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29535596",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "60572138",
          "20572197"
        ],
        "code": "66941",
        "cover": "kilanda-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29562976",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "50572129",
          "90572288"
        ],
        "code": "66940",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29579929",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "70572133",
          "70572294"
        ],
        "code": "66940",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29579934",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "00603699",
          "60618631"
        ],
        "code": "73332",
        "cover": "hemmesta-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29598541",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "50572129",
          "40572281"
        ],
        "code": "66940",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39579919",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "50572129",
          "50572285"
        ],
        "code": "66940",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39579924",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "00603699",
          "40618627"
        ],
        "code": "73332",
        "cover": "hemmesta-grey-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39598545",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "00603699",
          "30618623"
        ],
        "code": "73332",
        "cover": "kilanda-grey-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39598550",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "50572134",
          "50572172"
        ],
        "code": "67063",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49535595",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "60572138",
          "20572324"
        ],
        "code": "66941",
        "cover": "hemmesta-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49562975",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "50572129",
          "10572287"
        ],
        "code": "66940",
        "cover": "hemmesta-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49579914",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "70572133",
          "00572297"
        ],
        "code": "66940",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49579928",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "50572129",
          "50572148"
        ],
        "code": "66940",
        "cover": "kilanda-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59535590",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "60572138",
          "60572195"
        ],
        "code": "66941",
        "cover": "hakebo-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59562970",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "70572133",
          "80572284"
        ],
        "code": "66940",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59579923",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "00603699",
          "10618619"
        ],
        "code": "73332",
        "cover": "kilanda-pale-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59598554",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "20572135",
          "70572312"
        ],
        "code": "67063",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69579946",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "20572135",
          "00572315"
        ],
        "code": "67063",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69579951",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "00603699",
          "00603722"
        ],
        "code": "73332",
        "cover": "kilanda-brown-red",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69598558",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "00603699",
          "20603721"
        ],
        "code": "73332",
        "cover": "kilanda-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69598563",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "50572129",
          "10572145"
        ],
        "code": "66940",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79535589",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "50572134",
          "80572180"
        ],
        "code": "67063",
        "cover": "hakebo-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79535594",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "60572138",
          "90572194"
        ],
        "code": "66941",
        "cover": "kilanda-brown-red",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79562974",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "20572135",
          "30572309"
        ],
        "code": "67063",
        "cover": "hemmesta-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79579936",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "20572135",
          "90572306"
        ],
        "code": "67063",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79579941",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "80603704",
          "00603717"
        ],
        "code": "73332",
        "cover": "hakebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79598534",
        "rangeId": "ekholma",
        "widthInMillimeters": 1890
      },
      {
        "childItems": [
          "10572131",
          "10572292"
        ],
        "code": "66940",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89579931",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "50572134",
          "80572302"
        ],
        "code": "67063",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89579945",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "50572134",
          "60572303"
        ],
        "code": "67063",
        "cover": "kilanda-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89579950",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "50572129",
          "70572147"
        ],
        "code": "66940",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99535588",
        "rangeId": "ekholma",
        "widthInMillimeters": 1670
      },
      {
        "childItems": [
          "60572138",
          "80572321"
        ],
        "code": "66941",
        "cover": "kilanda-grey-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99562968",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "60572138",
          "40572196"
        ],
        "code": "66941",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99562973",
        "rangeId": "ekholma",
        "widthInMillimeters": 2360
      },
      {
        "childItems": [
          "50572134",
          "10572305"
        ],
        "code": "67063",
        "cover": "hemmesta-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99579935",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "50572134",
          "00572301"
        ],
        "code": "67063",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99579940",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      },
      {
        "childItems": [
          "00603699",
          "90603727"
        ],
        "cover": "hakebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99598533",
        "rangeId": "ekholma",
        "widthInMillimeters": 2070
      }
    ]
  },
  "ektorp": {
    "coverProducts": [
      {
        "itemNo": "00517060",
        "name": "tallmyra-beige"
      },
      {
        "itemNo": "00517098",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "00525215",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "00525220",
        "name": "tallmyra-beige"
      },
      {
        "itemNo": "00565211",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "00565268",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "00565348",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "00565796",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "00565862",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "00565876",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "10517069",
        "name": "with-chaise-longue-tallmyra-blue"
      },
      {
        "itemNo": "10517093",
        "name": "hillared-beige"
      },
      {
        "itemNo": "10517106",
        "name": "with-chaise-longue-hillared-beige"
      },
      {
        "itemNo": "10517111",
        "name": "with-chaise-longue-tallmyra-light-green"
      },
      {
        "itemNo": "10565215",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10565277",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "10565357",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "10565362",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "10565729",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "10565786",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "10565791",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10565866",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10565871",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "20439735",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "20517064",
        "name": "tallmyra-beige"
      },
      {
        "itemNo": "20517097",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "20525224",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "20565205",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "20565272",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "20565861",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "30517068",
        "name": "with-chaise-longue-tallmyra-beige"
      },
      {
        "itemNo": "30517087",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "30517092",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "30517105",
        "name": "with-chaise-longue-hillared-anthracite"
      },
      {
        "itemNo": "30565262",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "40525223",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "40565799",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "50517086",
        "name": "hillared-beige"
      },
      {
        "itemNo": "50517091",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "50517109",
        "name": "with-chaise-longue-tallmyra-dark-green"
      },
      {
        "itemNo": "60517062",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "60525217",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "60525222",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "70517066",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "70517085",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "70517090",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "80517061",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "80517099",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "80525216",
        "name": "hillared-beige"
      },
      {
        "itemNo": "80525221",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "90517065",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "90517070",
        "name": "with-chaise-longue-tallmyra-white-black"
      },
      {
        "itemNo": "90517089",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "90517094",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "90517107",
        "name": "with-chaise-longue-hillared-dark-blue"
      },
      {
        "itemNo": "90517112",
        "name": "with-chaise-longue-tallmyra-medium-grey"
      },
      {
        "itemNo": "90525225",
        "name": "tallmyra-white-black"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "tallmyra-beige",
        "dotOverride": "#989896"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "tallmyra-light-green",
        "dotOverride": "#97AEA1"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "hakebo-grey-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "karlshov-beige-multicolour",
        "dotOverride": [
          "#AF9F92",
          "#4B4746",
          "#EFEAE9",
          "#878381"
        ]
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "kilanda-dark-blue",
        "dotOverride": "#47525F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "tallmyra-blue",
        "dotOverride": "#305E7E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hillared-beige",
        "dotOverride": "#D4C8B5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-white-black",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "tallmyra-dark-green",
        "dotOverride": "#27392E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "tallmyra-medium-grey",
        "dotOverride": "#61626A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "hillared-dark-blue",
        "dotOverride": "#3E5564"
      }
    ],
    "displayName": "EKTORP",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "00185032",
          "70517085"
        ],
        "code": "01465",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430519",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "00185032",
          "00517060"
        ],
        "code": "01465",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430524",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "00517098"
        ],
        "code": "01471",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430538",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "90517107"
        ],
        "code": "17956",
        "cover": "hillared-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430543",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "00525215"
        ],
        "code": "01475",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09436229",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "40230221",
          "80525216"
        ],
        "code": "01475",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09436234",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "40230221",
          "20565861"
        ],
        "code": "01475",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09508985",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "00185032",
          "20565272"
        ],
        "code": "01465",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09509013",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "00185032",
          "50517091"
        ],
        "code": "01465",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430528",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "10185041",
          "10517069"
        ],
        "code": "17956",
        "cover": "tallmyra-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430547",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "60525217"
        ],
        "code": "01475",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19436238",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "00185032",
          "00565348"
        ],
        "code": "01465",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19509022",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "20517097"
        ],
        "code": "01471",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430537",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "10517106"
        ],
        "code": "17956",
        "cover": "hillared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430542",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "10565866"
        ],
        "code": "01475",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29508989",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "20185031",
          "10565215"
        ],
        "code": "01471",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29509007",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "10565786"
        ],
        "code": "17956",
        "cover": "hakebo-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29509031",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "00185032",
          "70517090"
        ],
        "code": "01465",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430527",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "90517094"
        ],
        "code": "01471",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430532",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "30517068"
        ],
        "code": "17956",
        "cover": "tallmyra-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430546",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "10185041",
          "90517070"
        ],
        "code": "17956",
        "cover": "tallmyra-white-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430551",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20185031",
          "20565205"
        ],
        "code": "01471",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39508998",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "00185032",
          "10565277"
        ],
        "code": "01465",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39509016",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "10185041",
          "00565796"
        ],
        "code": "17956",
        "cover": "kilanda-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39509040",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "90185037",
          "00439835"
        ],
        "code": "17956",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49305052",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20185031",
          "90517065"
        ],
        "code": "01471",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430536",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "30517105"
        ],
        "code": "17956",
        "cover": "hillared-anthracite",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430541",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "90525225"
        ],
        "code": "01475",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49436232",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "00185032",
          "10565357"
        ],
        "code": "01465",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49509025",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "00185032",
          "90517089"
        ],
        "code": "01465",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430526",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "10517093"
        ],
        "code": "01471",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430531",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "90517112"
        ],
        "code": "17956",
        "cover": "tallmyra-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430550",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "80525221"
        ],
        "code": "01475",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59436236",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "40230221",
          "00565862"
        ],
        "code": "01475",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59508983",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "20185031",
          "00565211"
        ],
        "code": "01471",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59509001",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "90185037",
          "40439744"
        ],
        "code": "17956",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69305046",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "00185032",
          "30517087"
        ],
        "code": "01465",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430521",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "20517064"
        ],
        "code": "01471",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430535",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "20185031",
          "70517066"
        ],
        "code": "01471",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430540",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "40230221",
          "60525222"
        ],
        "code": "01475",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69436231",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "40230221",
          "10565871"
        ],
        "code": "01475",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69508992",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "20185031",
          "30565262"
        ],
        "code": "01471",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69509010",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "40565799"
        ],
        "code": "17956",
        "cover": "karlshov-beige-multicolour",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69509034",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "00185032",
          "80517061"
        ],
        "code": "01465",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430525",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "30517092"
        ],
        "code": "01471",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430530",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "10517111"
        ],
        "code": "17956",
        "cover": "tallmyra-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430549",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "40525223"
        ],
        "code": "01475",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79436235",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "00185032",
          "10565362"
        ],
        "code": "01465",
        "cover": "karlshov-beige-multicolour",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79509019",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "90185037",
          "20439735"
        ],
        "code": "17956",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89305045",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "00185032",
          "50517086"
        ],
        "code": "01465",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430520",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "20185031",
          "80517099"
        ],
        "code": "01471",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430539",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "40230221",
          "20525224"
        ],
        "code": "01475",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89436230",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "10185041",
          "10565729"
        ],
        "code": "17956",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89509028",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "00185032",
          "60517062"
        ],
        "code": "01465",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430529",
        "rangeId": "ektorp",
        "widthInMillimeters": 1790
      },
      {
        "childItems": [
          "10185041",
          "50517109"
        ],
        "code": "17956",
        "cover": "tallmyra-dark-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430548",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "40230221",
          "00525220"
        ],
        "code": "01475",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99436239",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "40230221",
          "00565876"
        ],
        "code": "01475",
        "cover": "karlshov-beige-multicolour",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99508995",
        "rangeId": "ektorp"
      },
      {
        "childItems": [
          "20185031",
          "00565268"
        ],
        "code": "01471",
        "cover": "karlshov-beige-multicolour",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99509004",
        "rangeId": "ektorp",
        "widthInMillimeters": 2180
      },
      {
        "childItems": [
          "10185041",
          "10565791"
        ],
        "code": "17956",
        "cover": "kilanda-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99509037",
        "rangeId": "ektorp",
        "widthInMillimeters": 2520
      }
    ]
  },
  "eskilstuna": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-white-black",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00051.jpg",
        "name": "gunnared-blue",
        "dotOverride": "#617E91"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hillared-beige",
        "dotOverride": "#D4C8B5"
      }
    ],
    "displayName": "ESKILSTUNA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "00539590",
          "80539591"
        ],
        "code": "46789",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19520185",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "80539586",
          "40539588"
        ],
        "code": "46790",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39520189",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "90574664",
          "60574670"
        ],
        "code": "46790",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39537397",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "00539590",
          "80539591"
        ],
        "code": "46790",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59520188",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "80539586",
          "40539588",
          "60539587"
        ],
        "code": "42251",
        "cover": "hillared-anthracite",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59520193",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "90574664",
          "60574670"
        ],
        "code": "46789",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537396",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "80539586",
          "40539588"
        ],
        "code": "46789",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69520183",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "20552175",
          "70552173"
        ],
        "code": "46790",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79520187",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "00539590",
          "80539591",
          "20539589"
        ],
        "code": "42251",
        "cover": "tallmyra-white-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79520192",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "90574664",
          "60574670",
          "40574671"
        ],
        "code": "42251",
        "cover": "hillared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79537395",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      },
      {
        "childItems": [
          "20552175",
          "70552173"
        ],
        "code": "46789",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99520186",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "20552175",
          "70552173",
          "50552174"
        ],
        "code": "42251",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99520191",
        "rangeId": "eskilstuna",
        "widthInMillimeters": 2680
      }
    ]
  },
  "esseboda": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tallmyra-medium-grey",
        "dotOverride": "#61626A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "knaback-anthracite",
        "dotOverride": "#424146"
      },
      {
        "name": "tallmyra-blue",
        "dotOverride": "#305E7E"
      },
      {
        "name": "knaback-light-beige"
      }
    ],
    "displayName": "ESSEBODA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "20525549",
        "name": "birch"
      },
      {
        "itemNo": "60525547",
        "name": "brown"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10366956",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220
      },
      {
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "20525605",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220
      },
      {
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30525600",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920
      },
      {
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60525420",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "90525579",
          "60525547"
        ],
        "code": "59894",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443499",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "brown"
      },
      {
        "childItems": [
          "30525600",
          "20525549"
        ],
        "code": "59893",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443488",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "birch"
      },
      {
        "childItems": [
          "20525945",
          "20525549"
        ],
        "code": "59893",
        "cover": "knaback-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443493",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "birch"
      },
      {
        "childItems": [
          "30525600",
          "60525547"
        ],
        "code": "59893",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443478",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "brown"
      },
      {
        "childItems": [
          "20525605",
          "20525549"
        ],
        "code": "59894",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443529",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "birch"
      },
      {
        "childItems": [
          "00525574",
          "20525549"
        ],
        "code": "59893",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59443468",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "birch"
      },
      {
        "childItems": [
          "60525420",
          "20525549"
        ],
        "code": "59893",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59443473",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "birch"
      },
      {
        "childItems": [
          "20525605",
          "60525547"
        ],
        "code": "59894",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59443519",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "brown"
      },
      {
        "childItems": [
          "00525574",
          "60525547"
        ],
        "code": "59893",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443458",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "brown"
      },
      {
        "childItems": [
          "60525420",
          "60525547"
        ],
        "code": "59893",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443463",
        "rangeId": "esseboda",
        "widthInMillimeters": 1920,
        "legs": "brown"
      },
      {
        "childItems": [
          "90525579",
          "20525549"
        ],
        "code": "59894",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443509",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "birch"
      },
      {
        "childItems": [
          "10366956",
          "20525549"
        ],
        "code": "59894",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443514",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "birch"
      },
      {
        "childItems": [
          "10366956",
          "60525547"
        ],
        "code": "59894",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79443504",
        "rangeId": "esseboda",
        "widthInMillimeters": 2220,
        "legs": "brown"
      }
    ]
  },
  "fammarp": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-green-blue",
        "dotOverride": "#063754"
      },
      {
        "name": "tallmyra-black-grey"
      }
    ],
    "displayName": "FAMMARP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "20495991",
        "name": "wood-clear"
      },
      {
        "itemNo": "40495990",
        "name": "metal-silver-colour"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80495988",
        "rangeId": "fammarp"
      },
      {
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "90500239",
        "rangeId": "fammarp"
      },
      {
        "childItems": [
          "40500246",
          "60500250",
          "00500234",
          "80500225",
          "40495990"
        ],
        "code": "54836",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09424839",
        "rangeId": "fammarp",
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40500246",
          "00500234",
          "80500225",
          "60500250",
          "20495991"
        ],
        "code": "54836",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09424844",
        "rangeId": "fammarp",
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "60500226",
          "20500247",
          "40495990"
        ],
        "code": "54845",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19423009",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "60500226",
          "80500249",
          "40495990"
        ],
        "code": "54851",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19423014",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40495985",
          "00495987",
          "80495988",
          "20495991"
        ],
        "code": "58361",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19424589",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "00500234",
          "40500246",
          "40495990"
        ],
        "code": "54829",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19428912",
        "rangeId": "fammarp",
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "60500250",
          "00500234",
          "80500225",
          "40495990"
        ],
        "code": "54841",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19429365",
        "rangeId": "fammarp",
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40495985",
          "20491851",
          "20495991"
        ],
        "code": "54851",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29423018",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "40500246",
          "20495991"
        ],
        "code": "54845",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39423008",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "60500250",
          "40495990"
        ],
        "code": "54851",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39423013",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "20500247",
          "90500239",
          "60500226",
          "20495991"
        ],
        "code": "58361",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39424588",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "00500234",
          "40500246",
          "20495991"
        ],
        "code": "54829",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39428911",
        "rangeId": "fammarp",
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "60500226",
          "80500249",
          "20495991"
        ],
        "code": "54851",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49423017",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "40500246",
          "40495990"
        ],
        "code": "54845",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59423007",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40495985",
          "00495987",
          "40495990"
        ],
        "code": "54845",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59423012",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "00500234",
          "80500225",
          "60500250",
          "20495991"
        ],
        "code": "54841",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59429368",
        "rangeId": "fammarp",
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "80500225",
          "60500250",
          "20495991"
        ],
        "code": "54851",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69423016",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "60500226",
          "20500247",
          "20495991"
        ],
        "code": "54845",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79423011",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "40495985",
          "00495987",
          "80495988",
          "40495990"
        ],
        "code": "58361",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79424586",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40495985",
          "20491851",
          "40495990"
        ],
        "code": "54851",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89423015",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "metal-silver-colour"
      },
      {
        "childItems": [
          "40495985",
          "00495987",
          "20495991"
        ],
        "code": "54845",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99423010",
        "rangeId": "fammarp",
        "widthInMillimeters": 1980,
        "legs": "wood-clear"
      },
      {
        "childItems": [
          "20500247",
          "90500239",
          "60500226",
          "40495990"
        ],
        "code": "58361",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99424585",
        "rangeId": "fammarp",
        "widthInMillimeters": 2740,
        "legs": "metal-silver-colour"
      }
    ]
  },
  "finnala": {
    "coverProducts": [
      {
        "itemNo": "00454859",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "00454864",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "00454915",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00454939",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00454996",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10454849",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10454854",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10454873",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "10454986",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "10482668",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "10482673",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20454839",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20454844",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20454858",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "20454863",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "20454877",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "20454919",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "20454943",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "20454995",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30454848",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30454853",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30454867",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "30454914",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "30454933",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "30454990",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "30482672",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "40454838",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "40454843",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "40454857",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "40454862",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "40454999",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "50454847",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "50454852",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "50454927",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "60454842",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "70454926",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "70454931",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "80454916",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "80454940",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "90454874",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "90454925",
        "name": "tallmyra-black-grey"
      },
      {
        "itemNo": "90454930",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "90454987",
        "name": "gunnared-medium-grey"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "grann-bomstad-golden-brown",
        "dotOverride": "#AB7150"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "tallmyra-black-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      }
    ],
    "displayName": "FINNALA",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "20456433",
          "40456432"
        ],
        "code": "48135",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09319070",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "50454994",
          "60454842",
          "50454852",
          "20454877"
        ],
        "code": "48296",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09319094",
        "rangeId": "finnala",
        "widthInMillimeters": 2270
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "60454842",
          "50454852",
          "30454867"
        ],
        "code": "66167",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09319107",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "00455019",
          "30454848",
          "40454838",
          "30454853",
          "40454843"
        ],
        "code": "48311",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09319254",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "10454849",
          "20454839",
          "10454854",
          "00454864"
        ],
        "code": "48312",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09319268",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455006",
          "90455005",
          "90455010"
        ],
        "code": "48299",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09336116",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "30454848",
          "40454838",
          "20454863",
          "10482668"
        ],
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "09336121",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "70455006",
          "20481404"
        ],
        "code": "48313",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09542828",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "10454991",
          "40455017",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "40455036",
          "10454986",
          "30454848",
          "20454858"
        ],
        "code": "48251",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09542866",
        "rangeId": "finnala",
        "widthInMillimeters": 2740
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "90454987",
          "10454849",
          "00454864"
        ],
        "code": "48252",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09542885",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "90454987",
          "10454849",
          "20454839",
          "10454854",
          "00454864"
        ],
        "code": "66156",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09575673",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "10454986",
          "30454848",
          "20454863"
        ],
        "code": "66159",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09575692",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "20454839",
          "10454849",
          "00454864"
        ],
        "code": "66167",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09575705",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "50455007"
        ],
        "code": "66167",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09575734",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "30454848",
          "40454843"
        ],
        "code": "48135",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19319060",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "40455017",
          "80456821",
          "90454992",
          "50454994",
          "20454839",
          "10454849",
          "10454854",
          "00454859",
          "90454874"
        ],
        "code": "48306",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19319244",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455004",
          "30455008",
          "50455007",
          "70455006"
        ],
        "code": "48312",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19319263",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "50455007",
          "90455010"
        ],
        "code": "66166",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19336130",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "50455007",
          "70455006",
          "40481403"
        ],
        "code": "50414",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "19542875",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "60456431",
          "70456435",
          "00456434",
          "20456433"
        ],
        "code": "66171",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19575601",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "30454933",
          "30454914",
          "90454925",
          "20454943"
        ],
        "code": "66171",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "19575658",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "70454931",
          "80454916",
          "50454927",
          "80454940"
        ],
        "code": "66171",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "19575663",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "70455025",
          "90454992",
          "70454993",
          "60455035",
          "30454914",
          "30454933",
          "20454943"
        ],
        "code": "66167",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19575700",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "70455006",
          "90455005"
        ],
        "code": "48135",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29319069",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "50454994",
          "20454839",
          "10454849",
          "90454874"
        ],
        "code": "48296",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29319088",
        "rangeId": "finnala",
        "widthInMillimeters": 2270
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "30454848",
          "40454838",
          "30454853"
        ],
        "code": "48305",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29319229",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "00454878",
          "50454847",
          "50454852",
          "30482672"
        ],
        "code": "48299",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29336115",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "40455017",
          "90454992",
          "50454994",
          "00454878",
          "20454839",
          "10454849",
          "10454854",
          "00454859",
          "90454874",
          "10482673"
        ],
        "code": "48300",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29336139",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "70456435"
        ],
        "code": "48305",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29409178",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455011",
          "20455004",
          "30455008",
          "30417931",
          "50455007",
          "70455006",
          "20481404"
        ],
        "code": "48236",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29542808",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "90454992",
          "20481404",
          "10454986",
          "30454848"
        ],
        "code": "48313",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29542832",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "40481403",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "00454996",
          "70454931",
          "80454916",
          "50454927",
          "80454940"
        ],
        "code": "66156",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "29575672",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10456438",
          "30417931",
          "00456434",
          "20456433",
          "20481404"
        ],
        "code": "66159",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29575686",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "40481403",
          "20454995",
          "90454930",
          "00454939"
        ],
        "code": "66159",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "29575691",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "60454842",
          "50454852",
          "30454867",
          "30482672"
        ],
        "code": "66166",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29575733",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "20454839",
          "10454849"
        ],
        "code": "48372",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39319021",
        "rangeId": "finnala",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "20454839",
          "10454849",
          "00454864"
        ],
        "code": "66167",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39319101",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20456433",
          "40456432",
          "00456434"
        ],
        "code": "66165",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39319224",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "00455019",
          "60454842",
          "50454847",
          "50454852",
          "40454857"
        ],
        "code": "48311",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39319262",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "60454842",
          "50454852",
          "30454867",
          "30482672"
        ],
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "39336129",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "30454848",
          "40454838",
          "30454853",
          "20454863"
        ],
        "code": "66171",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39575662",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "40481403",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "40454999",
          "30454933",
          "30454914",
          "90454925",
          "20454943"
        ],
        "code": "66156",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "39575676",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "70455025",
          "90454992",
          "70454993",
          "60455035",
          "80454916",
          "70454931",
          "80454940"
        ],
        "code": "66167",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39575704",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "30454848",
          "40454838",
          "20454863",
          "10482668"
        ],
        "code": "66166",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39575723",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20456433",
          "40456432",
          "00456434"
        ],
        "code": "66165",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39575737",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "60456431",
          "20456433"
        ],
        "code": "48372",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49319025",
        "rangeId": "finnala",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "50454847",
          "50454852"
        ],
        "code": "48135",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49319068",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "70454993",
          "30454848",
          "40454843",
          "20454863"
        ],
        "code": "66165",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49319214",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "70456435",
          "40456432"
        ],
        "code": "48311",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49319252",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "30454848",
          "40454838",
          "30454853",
          "20454863"
        ],
        "code": "48312",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49319266",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "30455008"
        ],
        "code": "48305",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49409177",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455011",
          "20455004",
          "30455008",
          "30417931",
          "50455007",
          "70455006",
          "40481403"
        ],
        "code": "50417",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "49542807",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "30454990",
          "50454852",
          "60454842",
          "40454857",
          "30454867"
        ],
        "code": "66156",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49542812",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "70455006",
          "40481403"
        ],
        "code": "50416",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49542826",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "10454991",
          "40455017",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "40455036",
          "30454990",
          "50454852",
          "40454862"
        ],
        "code": "48251",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49542874",
        "rangeId": "finnala",
        "widthInMillimeters": 2740
      },
      {
        "childItems": [
          "10456438",
          "60456431",
          "70456435",
          "30417931",
          "00456434",
          "20456433",
          "20481404"
        ],
        "code": "66156",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49575671",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "50455007",
          "70455006",
          "20481404"
        ],
        "code": "66159",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49575685",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "30454990",
          "50454852",
          "30454867"
        ],
        "code": "66159",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49575690",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "70454993",
          "50454847",
          "50454852",
          "30454867"
        ],
        "code": "66165",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49575713",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "70455006",
          "90455005",
          "50455007"
        ],
        "code": "66165",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59319223",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "60454842",
          "50454852",
          "40454857"
        ],
        "code": "48305",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59319237",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "40455017",
          "80456821",
          "90454992",
          "50454994",
          "30454848",
          "40454838",
          "30454853",
          "20454858",
          "10454873"
        ],
        "code": "48306",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59319242",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "00455019",
          "20454839",
          "10454849",
          "10454854",
          "20454844"
        ],
        "code": "48311",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59319256",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "00454878",
          "10454849",
          "20454844",
          "10482673"
        ],
        "code": "48299",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59336109",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "10454986",
          "30454848",
          "40454838",
          "30454853",
          "20454863"
        ],
        "code": "66156",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59542816",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10456438",
          "30417931",
          "00456434",
          "20456433",
          "20481404"
        ],
        "code": "48252",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59542878",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "10454986",
          "30454848",
          "20454863"
        ],
        "code": "48252",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59542883",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "90454930",
          "00454915",
          "70454926",
          "00454939"
        ],
        "code": "66171",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "59575661",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "10454986",
          "30454848",
          "40454838",
          "30454853",
          "20454863"
        ],
        "code": "66156",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59575680",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "30454848",
          "40454838",
          "20454863"
        ],
        "code": "66167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59575703",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "70455006",
          "90455005",
          "50455007"
        ],
        "code": "66165",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59575736",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "60454842",
          "50454852"
        ],
        "code": "48372",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69318925",
        "rangeId": "finnala",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "50454994",
          "30454848",
          "40454838",
          "10454873"
        ],
        "code": "48296",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69319086",
        "rangeId": "finnala",
        "widthInMillimeters": 2270
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "00456434"
        ],
        "code": "66167",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69319109",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "30455008",
          "90455005"
        ],
        "code": "48311",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69319251",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "20454839",
          "10454849",
          "00454864",
          "10482673"
        ],
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "69336123",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "40455017",
          "80456821",
          "90454992",
          "50454994",
          "00454878",
          "30454848",
          "20454839",
          "30454853",
          "20454858",
          "10454873",
          "10482668"
        ],
        "code": "48300",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69336137",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10456438",
          "30417931",
          "20456433",
          "20481404"
        ],
        "code": "48313",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69542830",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "10454991",
          "40455017",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "40455036",
          "90454987",
          "10454849",
          "00454859"
        ],
        "code": "48251",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69542868",
        "rangeId": "finnala",
        "widthInMillimeters": 2740
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "30454990",
          "50454852",
          "30454867"
        ],
        "code": "48252",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69542892",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "70455011",
          "20455004",
          "30455008",
          "30417931",
          "50455007",
          "70455006",
          "20481404"
        ],
        "code": "66156",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69575670",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "40481403",
          "40454999",
          "30454933",
          "20454943"
        ],
        "code": "66159",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "69575689",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "20481404",
          "90454987",
          "10454849",
          "00454864"
        ],
        "code": "66159",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69575694",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "70455025",
          "90454992",
          "00455019",
          "60455035",
          "70454993",
          "20454919",
          "30454933",
          "20454943"
        ],
        "code": "66165",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "69575712",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "90454992",
          "40455036",
          "40454838",
          "30454848"
        ],
        "code": "48372",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79319019",
        "rangeId": "finnala",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "20455004",
          "70455006"
        ],
        "code": "48372",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79319024",
        "rangeId": "finnala",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "10454849",
          "20454844"
        ],
        "code": "48135",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79319062",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "70454993",
          "50454847",
          "50454852",
          "30454867"
        ],
        "code": "66165",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79319222",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "40481403",
          "70455025",
          "50455026",
          "20455037",
          "60455035",
          "20454995",
          "90454930",
          "00454915",
          "70454926",
          "00454939"
        ],
        "code": "66156",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79575679",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "50455007",
          "70455006",
          "40481403"
        ],
        "code": "66161",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79575684",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455018",
          "70455025",
          "90454992",
          "60455035",
          "70454993",
          "90454930",
          "00454915",
          "00454939"
        ],
        "code": "66167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79575702",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "00456434",
          "30456437"
        ],
        "code": "66166",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79575721",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "00456434"
        ],
        "code": "66167",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79575735",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "50455007"
        ],
        "code": "66167",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89319108",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "80456821",
          "90454992",
          "20454839",
          "10454849",
          "10454854"
        ],
        "code": "48305",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89319231",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "40455017",
          "80456821",
          "90454992",
          "50454994",
          "60454842",
          "50454852",
          "40454857",
          "40454862",
          "20454877"
        ],
        "code": "48306",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89319250",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "50454852",
          "60454842",
          "40454857",
          "30454867"
        ],
        "code": "48312",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89319274",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20456433",
          "40456432",
          "30456437"
        ],
        "code": "48299",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89336117",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "10456438",
          "60456431",
          "70456435",
          "30417931",
          "00456434",
          "20456433",
          "20481404"
        ],
        "code": "48236",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89542810",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "90454992",
          "20481404",
          "90454987",
          "10454849"
        ],
        "code": "48313",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89542834",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "70455011",
          "20455004",
          "30455008",
          "30417931",
          "50455007",
          "70455006",
          "40481403"
        ],
        "code": "66160",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "89575669",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "70454993",
          "90454992",
          "40481403",
          "00454996",
          "70454931",
          "80454940"
        ],
        "code": "66159",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "89575693",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "00454878",
          "20454839",
          "10454849",
          "00454864",
          "10482673"
        ],
        "code": "66166",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89575725",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "30454848",
          "40454838",
          "20454863"
        ],
        "code": "66167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99319099",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "70454993",
          "10454849",
          "20454844",
          "00454864"
        ],
        "code": "66165",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99319216",
        "rangeId": "finnala",
        "widthInMillimeters": 3220
      },
      {
        "childItems": [
          "60456431",
          "70456435",
          "00456434",
          "20456433"
        ],
        "code": "48312",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99319264",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10455028",
          "40455036",
          "90454992",
          "00455019",
          "00454878",
          "30454848",
          "40454843",
          "10482668"
        ],
        "code": "48299",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99336107",
        "rangeId": "finnala",
        "widthInMillimeters": 2410
      },
      {
        "childItems": [
          "60456431",
          "20456433",
          "00456434",
          "30456437"
        ],
        "code": "66166",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99336131",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "30455027",
          "00455038",
          "40455017",
          "80456821",
          "90454992",
          "50454994",
          "00454878",
          "60454842",
          "50454852",
          "40454857",
          "40454862",
          "20454877",
          "30482672"
        ],
        "code": "48300",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99336145",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "90454987",
          "10454849",
          "20454839",
          "10454854",
          "00454864"
        ],
        "code": "66156",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99542819",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "30417931",
          "90454992",
          "20481404",
          "30454990",
          "50454852"
        ],
        "code": "48313",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99542857",
        "rangeId": "finnala",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "70455011",
          "30417931",
          "50455007",
          "70455006",
          "20481404"
        ],
        "code": "48252",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99542876",
        "rangeId": "finnala",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "20455004",
          "30455008",
          "50455007",
          "70455006"
        ],
        "code": "66171",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99575602",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "50454852",
          "60454842",
          "40454857",
          "30454867"
        ],
        "code": "66171",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99575659",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "80456821",
          "70454993",
          "90454992",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "10454849",
          "20454839",
          "10454854",
          "00454864"
        ],
        "code": "66171",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99575664",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "10454991",
          "20455018",
          "80456821",
          "70454993",
          "30417931",
          "90454992",
          "20481404",
          "10455028",
          "30455027",
          "00455038",
          "40455036",
          "30454990",
          "50454852",
          "60454842",
          "40454857",
          "30454867"
        ],
        "code": "66156",
        "cover": "tallmyra-black-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99575678",
        "rangeId": "finnala"
      },
      {
        "childItems": [
          "20455018",
          "10455028",
          "40455036",
          "90454992",
          "70454993",
          "60454842",
          "50454852",
          "30454867"
        ],
        "code": "66167",
        "cover": "tallmyra-black-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99575701",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      },
      {
        "childItems": [
          "20455004",
          "70455006",
          "50455007",
          "90455010"
        ],
        "code": "66166",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99575720",
        "rangeId": "finnala",
        "widthInMillimeters": 2520
      }
    ]
  },
  "fridhult": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00067.jpg",
        "name": "skiftebo-yellow"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "knisa-light-grey"
      }
    ],
    "displayName": "FRIDHULT",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "64525",
        "cover": "skiftebo-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00575446",
        "rangeId": "fridhult",
        "widthInMillimeters": 1260
      },
      {
        "code": "64525",
        "cover": "knisa-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "70351725",
        "rangeId": "fridhult",
        "widthInMillimeters": 1260
      }
    ]
  },
  "friheten": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "skiftebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "bomstad-black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "faringe-light-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00142.jpg",
        "name": "faringe-brown-orange"
      }
    ],
    "displayName": "FRIHETEN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "31187",
        "cover": "bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20341135",
        "rangeId": "friheten",
        "widthInMillimeters": 2250
      },
      {
        "code": "31187",
        "cover": "skiftebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50341148",
        "rangeId": "friheten",
        "widthInMillimeters": 2250
      },
      {
        "code": "31187",
        "cover": "faringe-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "60551225",
        "rangeId": "friheten",
        "widthInMillimeters": 2250
      },
      {
        "code": "31187",
        "cover": "faringe-brown-orange",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90551224",
        "rangeId": "friheten",
        "widthInMillimeters": 2250
      },
      {
        "childItems": [
          "80559471",
          "50551235",
          "60559486"
        ],
        "code": "35163",
        "cover": "faringe-brown-orange",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19517041",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60559472",
          "30551236",
          "40559487"
        ],
        "code": "35163",
        "cover": "faringe-light-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29517045",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "80559471",
          "50551235",
          "60559486",
          "00551167",
          "30513541"
        ],
        "code": "54856",
        "cover": "faringe-brown-orange",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29520241",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "10311737",
          "70311065",
          "50311066",
          "80586262",
          "80513548"
        ],
        "code": "54856",
        "cover": "skiftebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "29580739",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "80311060",
          "80311734",
          "00311059"
        ],
        "code": "35163",
        "cover": "skiftebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "39216754",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60559472",
          "30551236",
          "40559487",
          "30513541",
          "40551165"
        ],
        "code": "54856",
        "cover": "faringe-light-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49520235",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "80311060",
          "80311734",
          "00311059",
          "20448160"
        ],
        "code": "47739",
        "cover": "skiftebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "59326624",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60310924",
          "80310923",
          "30311722"
        ],
        "code": "35163",
        "cover": "bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "69216818",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60310924",
          "80310923",
          "30311722",
          "00448161"
        ],
        "code": "47739",
        "cover": "bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "69326628",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "80311060",
          "80311734",
          "00311059",
          "00513547",
          "30513541"
        ],
        "code": "54856",
        "cover": "skiftebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "69444330",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60559472",
          "30551236",
          "40559487",
          "60551254"
        ],
        "code": "47739",
        "cover": "faringe-light-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69517053",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "80559471",
          "50551235",
          "60559486",
          "80551253"
        ],
        "code": "47739",
        "cover": "faringe-brown-orange",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79517057",
        "rangeId": "friheten",
        "widthInMillimeters": 2300
      }
    ]
  },
  "froson": {
    "coverProducts": [
      {
        "itemNo": "00586317",
        "name": "outdoor-beige"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "beige"
      }
    ],
    "displayName": "FRÖSÖN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "fullero": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "grann-white"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      }
    ],
    "displayName": "FULLERÖ",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "40520881",
        "name": "black-metal"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50520885",
        "rangeId": "fullero",
        "widthInMillimeters": 2180
      },
      {
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60520880",
        "rangeId": "fullero",
        "widthInMillimeters": 2180
      },
      {
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80520879",
        "rangeId": "fullero",
        "widthInMillimeters": 1780
      },
      {
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80520884",
        "rangeId": "fullero",
        "widthInMillimeters": 1780
      },
      {
        "childItems": [
          "50520885",
          "40520881"
        ],
        "code": "61312",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09509602",
        "rangeId": "fullero",
        "widthInMillimeters": 2180,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "60520880",
          "40520881"
        ],
        "code": "61312",
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19509606",
        "rangeId": "fullero",
        "widthInMillimeters": 2180,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "60520880",
          "20520877",
          "40520881"
        ],
        "code": "61316",
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19509611",
        "rangeId": "fullero",
        "widthInMillimeters": 2960,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "80520884",
          "40520881"
        ],
        "code": "61310",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29509601",
        "rangeId": "fullero",
        "widthInMillimeters": 1780,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "80520879",
          "40520881"
        ],
        "code": "61310",
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39509605",
        "rangeId": "fullero",
        "widthInMillimeters": 1780,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "50520885",
          "30520886",
          "40520881"
        ],
        "code": "61316",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39509610",
        "rangeId": "fullero",
        "widthInMillimeters": 2960,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "60520880",
          "10535803",
          "40520881"
        ],
        "code": "61317",
        "cover": "grann-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79509613",
        "rangeId": "fullero",
        "widthInMillimeters": 2960,
        "legs": "black-metal"
      },
      {
        "childItems": [
          "50520885",
          "30535802",
          "40520881"
        ],
        "code": "61317",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99509612",
        "rangeId": "fullero",
        "widthInMillimeters": 2960,
        "legs": "black-metal"
      }
    ]
  },
  "gammalbyn": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00012.jpg",
        "name": "brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "blue"
      }
    ],
    "displayName": "GAMMALBYN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "61365",
        "cover": "kilanda-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00615536",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 2200
      },
      {
        "code": "48531",
        "cover": "brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "40473262",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 1460
      },
      {
        "code": "48589",
        "cover": "black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "50473252",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 2010
      },
      {
        "code": "48589",
        "cover": "brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "60473256",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 2010
      },
      {
        "code": "48531",
        "cover": "black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "60501834",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 1460
      },
      {
        "code": "61365",
        "cover": "grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "70558009",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 2200
      },
      {
        "code": "61365",
        "cover": "blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "70558028",
        "rangeId": "gammalbyn",
        "widthInMillimeters": 2200
      }
    ]
  },
  "glostad": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00051.jpg",
        "name": "knisa-medium-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "knisa-dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "GLOSTAD",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "62919",
        "cover": "knisa-medium-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "00573287",
        "rangeId": "glostad",
        "widthInMillimeters": 1710
      },
      {
        "code": "53762",
        "cover": "knisa-medium-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "10465824",
        "rangeId": "glostad",
        "widthInMillimeters": 1210
      },
      {
        "code": "62919",
        "cover": "knisa-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40573285",
        "rangeId": "glostad",
        "widthInMillimeters": 1710
      },
      {
        "code": "53762",
        "cover": "knisa-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50489012",
        "rangeId": "glostad",
        "widthInMillimeters": 1210
      },
      {
        "childItems": [
          "20573286",
          "50489012"
        ],
        "code": "60659",
        "cover": "knisa-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49543920",
        "rangeId": "glostad",
        "widthInMillimeters": 1210
      },
      {
        "childItems": [
          "00573287",
          "80573288"
        ],
        "code": "62917",
        "cover": "knisa-medium-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69542670",
        "rangeId": "glostad",
        "widthInMillimeters": 1710
      },
      {
        "childItems": [
          "90595925",
          "00488821"
        ],
        "code": "60659",
        "cover": "knisa-medium-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79618805",
        "rangeId": "glostad",
        "widthInMillimeters": 1210
      },
      {
        "childItems": [
          "40573285",
          "20573286"
        ],
        "code": "62917",
        "cover": "knisa-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89542669",
        "rangeId": "glostad",
        "widthInMillimeters": 1710
      }
    ]
  },
  "gralviken": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "dark-grey",
        "dotOverride": "#444444"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "grey"
      }
    ],
    "displayName": "GRÄLVIKEN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "43059",
        "cover": "dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40445392",
        "rangeId": "gralviken",
        "widthInMillimeters": 2250
      },
      {
        "code": "43059",
        "cover": "grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "70340567",
        "rangeId": "gralviken",
        "widthInMillimeters": 2250
      }
    ]
  },
  "grillstorp": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00152.jpg",
        "name": "gunnared-light-brown-pink",
        "dotOverride": "#DCB6B5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      }
    ],
    "displayName": "GRILLSTORP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "90566211",
        "name": "metal"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00565701",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1760
      },
      {
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00566201",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960
      },
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "10566205",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "10566210",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "20517016",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1760
      },
      {
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30566209",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50516812",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50566208",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60565703",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760
      },
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "70516811",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960
      },
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80565702",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960
      },
      {
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80566198",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "70516811",
          "90566211"
        ],
        "code": "64085",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09549962",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960,
        "legs": "metal"
      },
      {
        "childItems": [
          "50566208",
          "90566211"
        ],
        "code": "64087",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09551686",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      },
      {
        "childItems": [
          "10566210",
          "90566211"
        ],
        "code": "64087",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09551691",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      },
      {
        "childItems": [
          "00566201",
          "90566211"
        ],
        "code": "64085",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29549961",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960,
        "legs": "metal"
      },
      {
        "childItems": [
          "10566205",
          "90566211"
        ],
        "code": "64086",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29549980",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      },
      {
        "childItems": [
          "20517016",
          "90566211"
        ],
        "code": "64084",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39549951",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1560,
        "legs": "metal"
      },
      {
        "childItems": [
          "80565702",
          "90566211"
        ],
        "code": "64085",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49549960",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1960,
        "legs": "metal"
      },
      {
        "childItems": [
          "30566209",
          "90566211"
        ],
        "code": "64087",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49551689",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      },
      {
        "childItems": [
          "80566198",
          "90566211"
        ],
        "code": "64084",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59549950",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1560,
        "legs": "metal"
      },
      {
        "childItems": [
          "60565703",
          "90566211"
        ],
        "code": "64086",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69549978",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      },
      {
        "childItems": [
          "00565701",
          "90566211"
        ],
        "code": "64084",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79549949",
        "rangeId": "grillstorp",
        "widthInMillimeters": 1560,
        "legs": "metal"
      },
      {
        "childItems": [
          "50516812",
          "90566211"
        ],
        "code": "64086",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79549973",
        "rangeId": "grillstorp",
        "widthInMillimeters": 2760,
        "legs": "metal"
      }
    ]
  },
  "grillstorp-smedstorp": {
    "coverProducts": null,
    "covers": [
      {
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      },
      {
        "name": "gunnared-light-brown-pink",
        "dotOverride": "#DCB6B5"
      },
      {
        "name": "gunnared-dark-grey"
      }
    ],
    "displayName": "GRILLSTORP / SMEDSTORP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "20517016",
          "60500368"
        ],
        "code": "64084",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09549957",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "10566205",
          "40500369"
        ],
        "code": "64086",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09549981",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "20517016",
          "40500369"
        ],
        "code": "64084",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19549952",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "10566205",
          "60500368"
        ],
        "code": "64086",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19549971",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "60565703",
          "60500368"
        ],
        "code": "64086",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29549975",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "50566208",
          "60500368"
        ],
        "code": "64087",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29551685",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "30566209",
          "40500369"
        ],
        "code": "64087",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29551690",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "70516811",
          "60500368"
        ],
        "code": "64085",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39549965",
        "rangeId": "grillstorp-smedstorp"
      },
      {
        "childItems": [
          "00566201",
          "40500369"
        ],
        "code": "64085",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39549970",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1960
      },
      {
        "childItems": [
          "80566198",
          "40500369"
        ],
        "code": "64084",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49549955",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "60565703",
          "40500369"
        ],
        "code": "64086",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49549979",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "80565702",
          "40500369"
        ],
        "code": "64085",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59549969",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1960
      },
      {
        "childItems": [
          "10566210",
          "60500368"
        ],
        "code": "64087",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59551684",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "00565701",
          "40500369"
        ],
        "code": "64084",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69549959",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "50566208",
          "40500369"
        ],
        "code": "64087",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69551688",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "00566201",
          "60500368"
        ],
        "code": "64085",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79549968",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1960
      },
      {
        "childItems": [
          "00565701",
          "60500368"
        ],
        "code": "64084",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89549958",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "70516811",
          "40500369"
        ],
        "code": "64085",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89549963",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1960
      },
      {
        "childItems": [
          "50516812",
          "40500369"
        ],
        "code": "64086",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89549977",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "30566209",
          "60500368"
        ],
        "code": "64087",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89551687",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "10566210",
          "40500369"
        ],
        "code": "64087",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89551692",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      },
      {
        "childItems": [
          "80566198",
          "60500368"
        ],
        "code": "64084",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99549953",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1760
      },
      {
        "childItems": [
          "80565702",
          "60500368"
        ],
        "code": "64085",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99549967",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 1960
      },
      {
        "childItems": [
          "50516812",
          "60500368"
        ],
        "code": "64086",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99549972",
        "rangeId": "grillstorp-smedstorp",
        "widthInMillimeters": 2760
      }
    ]
  },
  "grunnarp": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00152.jpg",
        "name": "gunnared-light-brown-pink",
        "dotOverride": "#DCB6B5"
      }
    ],
    "displayName": "GRUNNARP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "43035",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00583385",
        "rangeId": "grunnarp",
        "widthInMillimeters": 2320
      },
      {
        "code": "43035",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30583384",
        "rangeId": "grunnarp",
        "widthInMillimeters": 2320
      },
      {
        "code": "43035",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50583397",
        "rangeId": "grunnarp",
        "widthInMillimeters": 2320
      }
    ]
  },
  "gruvan": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00151.jpg",
        "name": "diserod-light-pink"
      }
    ],
    "displayName": "GRUVAN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "59227",
        "cover": "diserod-light-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "90543045",
        "rangeId": "gruvan",
        "widthInMillimeters": 1280
      }
    ]
  },
  "gullvalla": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "silkeryd-dark-grey-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "silkeryd-grey-green"
      }
    ],
    "displayName": "GULLVALLA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "73755",
        "cover": "silkeryd-dark-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10618501",
        "rangeId": "gullvalla",
        "widthInMillimeters": 1820
      },
      {
        "code": "73754",
        "cover": "silkeryd-dark-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30618500",
        "rangeId": "gullvalla",
        "widthInMillimeters": 1420
      },
      {
        "code": "73754",
        "cover": "silkeryd-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "70613398",
        "rangeId": "gullvalla",
        "widthInMillimeters": 1420
      },
      {
        "code": "73755",
        "cover": "silkeryd-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80618499",
        "rangeId": "gullvalla",
        "widthInMillimeters": 1820
      }
    ]
  },
  "hammarn": {
    "coverProducts": null,
    "covers": [
      {
        "name": "knisa-dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "HAMMARN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "39215",
        "cover": "knisa-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90354327",
        "rangeId": "hammarn",
        "widthInMillimeters": 1280
      }
    ]
  },
  "hemlingby": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00143.jpg",
        "name": "bomstad-dark-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "bomstad-black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "knisa-dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "HEMLINGBY",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "35233",
        "cover": "bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10294281",
        "rangeId": "hemlingby",
        "widthInMillimeters": 1450
      },
      {
        "code": "35233",
        "cover": "bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10295025",
        "rangeId": "hemlingby",
        "widthInMillimeters": 1450
      },
      {
        "code": "44881",
        "cover": "knisa-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50435321",
        "rangeId": "hemlingby",
        "widthInMillimeters": 1450
      }
    ]
  },
  "holmsund": {
    "coverProducts": [
      {
        "itemNo": "10549230",
        "name": "borgunda-beige"
      },
      {
        "itemNo": "30549229",
        "name": "borgunda-dark-grey"
      },
      {
        "itemNo": "30552250",
        "name": "borgunda-beige"
      },
      {
        "itemNo": "50552249",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "60552239",
        "name": "borgunda-dark-grey"
      },
      {
        "itemNo": "70549232",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "70552248",
        "name": "kilanda-grey-brown"
      },
      {
        "itemNo": "90549231",
        "name": "kilanda-grey-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "borgunda-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "borgunda-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "kilanda-dark-blue",
        "dotOverride": "#47525F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "kilanda-grey-brown",
        "dotOverride": "#6C6252"
      }
    ],
    "displayName": "HOLMSUND",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "60346904",
          "50552249"
        ],
        "code": "32890",
        "cover": "kilanda-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09516928",
        "rangeId": "holmsund",
        "widthInMillimeters": 2310
      },
      {
        "childItems": [
          "60346904",
          "70552248"
        ],
        "code": "32890",
        "cover": "kilanda-grey-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19516918",
        "rangeId": "holmsund",
        "widthInMillimeters": 2310
      },
      {
        "childItems": [
          "40315692",
          "50315696",
          "50315700",
          "70549232"
        ],
        "code": "34741",
        "cover": "kilanda-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49511293",
        "rangeId": "holmsund",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "40315692",
          "50315696",
          "50315700",
          "10549230"
        ],
        "code": "34741",
        "cover": "borgunda-beige",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59516898",
        "rangeId": "holmsund",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "60346904",
          "30552250"
        ],
        "code": "32890",
        "cover": "borgunda-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59516935",
        "rangeId": "holmsund",
        "widthInMillimeters": 2310
      },
      {
        "childItems": [
          "60346904",
          "60552239"
        ],
        "code": "32890",
        "cover": "borgunda-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59516940",
        "rangeId": "holmsund",
        "widthInMillimeters": 2310
      },
      {
        "childItems": [
          "40315692",
          "50315696",
          "50315700",
          "30549229"
        ],
        "code": "34741",
        "cover": "borgunda-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69516893",
        "rangeId": "holmsund",
        "widthInMillimeters": 2300
      },
      {
        "childItems": [
          "40315692",
          "50315696",
          "50315700",
          "90549231"
        ],
        "code": "34741",
        "cover": "kilanda-grey-brown",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89516887",
        "rangeId": "holmsund",
        "widthInMillimeters": 2300
      }
    ]
  },
  "hyltarp": {
    "coverProducts": [
      {
        "itemNo": "00547298",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "00547397",
        "name": "gransel-grey-brown"
      },
      {
        "itemNo": "10547288",
        "name": "hallarp-white"
      },
      {
        "itemNo": "10547325",
        "name": "hallarp-white"
      },
      {
        "itemNo": "10547330",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "20547315",
        "name": "hallarp-white"
      },
      {
        "itemNo": "20547320",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "20547419",
        "name": "gransel-grey-brown"
      },
      {
        "itemNo": "20551005",
        "name": "hemmesta-light-beige"
      },
      {
        "itemNo": "30547305",
        "name": "hallarp-white"
      },
      {
        "itemNo": "30547310",
        "name": "kilanda-pale-blue"
      },
      {
        "itemNo": "30547386",
        "name": "gransel-natural"
      },
      {
        "itemNo": "30547414",
        "name": "gransel-natural"
      },
      {
        "itemNo": "30547447",
        "name": "gransel-natural"
      },
      {
        "itemNo": "40547442",
        "name": "gransel-grey-brown"
      },
      {
        "itemNo": "50547408",
        "name": "gransel-grey-brown"
      },
      {
        "itemNo": "50551004",
        "name": "hemmesta-light-beige"
      },
      {
        "itemNo": "50566326",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "60547403",
        "name": "gransel-natural"
      },
      {
        "itemNo": "60566279",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "60566284",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "60566298",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "60566302",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "60566316",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "60566335",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "60566509",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "60566514",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "70549915",
        "name": "gransel-grey"
      },
      {
        "itemNo": "70549920",
        "name": "gransel-grey"
      },
      {
        "itemNo": "70566274",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "70566288",
        "name": "hemmesta-grey-green"
      },
      {
        "itemNo": "70566306",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "70566311",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "70566330",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "70566518",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "70566523",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "80549910",
        "name": "gransel-grey"
      },
      {
        "itemNo": "80551007",
        "name": "hemmesta-light-beige"
      },
      {
        "itemNo": "90549900",
        "name": "gransel-grey"
      },
      {
        "itemNo": "90551002",
        "name": "hemmesta-light-beige"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00023.jpg",
        "name": "kilanda-pale-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "gransel-grey-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "hallarp-white"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hemmesta-light-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gransel-natural",
        "dotOverride": "#EFEADE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-white-black",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "hemmesta-grey-green",
        "dotOverride": "#7F8F83"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "tallmyra-blue",
        "dotOverride": "#305E7E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "tallmyra-dark-green",
        "dotOverride": "#27392E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gransel-grey",
        "dotOverride": "#646364"
      }
    ],
    "displayName": "HYLTARP",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "30540785",
          "40547442",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "gransel-grey-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09489581",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "00547397"
        ],
        "code": "63675",
        "cover": "gransel-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09489604",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "70566330"
        ],
        "code": "63676",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09514953",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "60540784",
          "20547315"
        ],
        "code": "63674",
        "cover": "hallarp-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19489566",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "60540784",
          "20547320"
        ],
        "code": "63674",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19489571",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "80540783",
          "30547310"
        ],
        "code": "63676",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19489646",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "60540784",
          "20547419"
        ],
        "code": "63674",
        "cover": "gransel-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19514820",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "30540785",
          "70566311",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "tallmyra-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19514877",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30540785",
          "70566523",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "tallmyra-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19514882",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30540785",
          "30547447",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "gransel-natural",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29489603",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "00547298"
        ],
        "code": "63675",
        "cover": "kilanda-pale-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29489622",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "60540784",
          "70566518"
        ],
        "code": "63674",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514848",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "60540784",
          "60566335"
        ],
        "code": "63674",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514853",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "80540778",
          "60566298"
        ],
        "code": "63675",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514909",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "60566514"
        ],
        "code": "63676",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514947",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "80540783",
          "60566302"
        ],
        "code": "63676",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39514942",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "80540778",
          "10547288"
        ],
        "code": "63675",
        "cover": "hallarp-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49489616",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "30547305"
        ],
        "code": "63676",
        "cover": "hallarp-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49489640",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "80540783",
          "90551002"
        ],
        "code": "63676",
        "cover": "hemmesta-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49495863",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "60540784",
          "70549915"
        ],
        "code": "63674",
        "cover": "gransel-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49514814",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "30540785",
          "80551007",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "hemmesta-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49514871",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30540785",
          "10547325",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "hallarp-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59489588",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "60540784",
          "70566306"
        ],
        "code": "63674",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59514842",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "80540778",
          "20551005"
        ],
        "code": "63675",
        "cover": "hemmesta-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59514903",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "60540784",
          "50551004"
        ],
        "code": "63674",
        "cover": "hemmesta-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69495857",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "30540785",
          "70566288",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "hemmesta-grey-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69514865",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "80549910"
        ],
        "code": "63676",
        "cover": "gransel-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514926",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "80540783",
          "60566279"
        ],
        "code": "63676",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514931",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "30540785",
          "10547330",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "kilanda-pale-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79489592",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "30547386"
        ],
        "code": "63675",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79489610",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "60547403"
        ],
        "code": "63676",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79489634",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "80540778",
          "70566274"
        ],
        "code": "63675",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79514898",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "60540784",
          "30547414"
        ],
        "code": "63674",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514826",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "60540784",
          "60566284"
        ],
        "code": "63674",
        "cover": "hemmesta-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514831",
        "rangeId": "hyltarp"
      },
      {
        "childItems": [
          "30540785",
          "60566316",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "tallmyra-white-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514888",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "90549900"
        ],
        "code": "63675",
        "cover": "gransel-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514893",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540783",
          "50547408"
        ],
        "code": "63676",
        "cover": "gransel-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99489628",
        "rangeId": "hyltarp",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "30540785",
          "70549920",
          "10568638",
          "00417621"
        ],
        "code": "63679",
        "cover": "gransel-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99514859",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "60566509"
        ],
        "code": "63675",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99514915",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "80540778",
          "50566326"
        ],
        "code": "63675",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99514920",
        "rangeId": "hyltarp",
        "widthInMillimeters": 1820
      }
    ]
  },
  "ikea-ps-2026": {
    "coverProducts": null,
    "covers": [
      {
        "name": "skiftebo-light-grey-beige"
      }
    ],
    "displayName": "IKEA PS 2026",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "73756",
        "cover": "skiftebo-light-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "20620344",
        "rangeId": "ikea-ps-2026",
        "widthInMillimeters": 2040
      }
    ]
  },
  "jattebo": {
    "coverProducts": [
      {
        "itemNo": "00528940",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "00529001",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "00539608",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "10539603",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "20528996",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "30528986",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "30528991",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "40528976",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "40528981",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "60528975",
        "name": "samsala-dark-yellow-green"
      },
      {
        "itemNo": "70528965",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "80528955",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "80528960",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "80529016",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "80539614",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "90528950",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "90529006",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "90529011",
        "name": "samsala-grey-beige"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tonerud-grey",
        "dotOverride": "#95959A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "samsala-grey-beige",
        "dotOverride": "#D8C19F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "samsala-dark-yellow-green",
        "dotOverride": "#4E5D1B"
      },
      {
        "name": "axvall-dark-grey-blue",
        "dotOverride": "#567887"
      },
      {
        "name": "johanneshov-brown-beige",
        "dotOverride": "#C5B7A2"
      },
      {
        "name": "samsala-yellow-brown",
        "dotOverride": "#B27D35"
      },
      {
        "name": "samsala-dark-blue",
        "dotOverride": "#3B596F"
      },
      {
        "name": "samsala-dark-brown",
        "dotOverride": "#775A49"
      },
      {
        "name": "johanneshov-dark-green",
        "dotOverride": "#303F29"
      },
      {
        "name": "axvall-off-white",
        "dotOverride": "#E7E7DC"
      },
      {
        "name": "samsala-brown-red",
        "dotOverride": "#A05749"
      }
    ],
    "displayName": "JÄTTEBO",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "70528913",
          "00528935",
          "90529006",
          "80529016",
          "60528918",
          "00529001"
        ],
        "code": "60265",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09485205",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "20528996",
          "90529006",
          "00529001"
        ],
        "code": "60625",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09485253",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60622384",
          "30622385",
          "00622382"
        ],
        "code": "60618",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09607645",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "20622244",
          "70622246"
        ],
        "code": "59813",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09608268",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "60622138",
          "00622141"
        ],
        "code": "60264",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09608329",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "00528935",
          "60528918",
          "40528981",
          "30528986",
          "30528991",
          "40528976"
        ],
        "code": "60619",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19485115",
        "rangeId": "jattebo",
        "widthInMillimeters": 3240
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "80528960",
          "00528940"
        ],
        "code": "60264",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19485139",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "70528965",
          "00528940",
          "60539573",
          "80539614"
        ],
        "code": "61119",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19510412",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "80528960",
          "80528955",
          "00528940",
          "80539614",
          "60539573"
        ],
        "code": "61120",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19510902",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "00622141",
          "80622142",
          "60622138",
          "40622144"
        ],
        "code": "60617",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19607635",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "50622110",
          "30622111",
          "90622108"
        ],
        "code": "60618",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19607640",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "00622382",
          "80622383",
          "90622387"
        ],
        "code": "61119",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19608324",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "20622244",
          "70622246",
          "10622254"
        ],
        "code": "61119",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19608852",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "40528981",
          "30528986",
          "00528935",
          "30528991",
          "60528918",
          "40528976"
        ],
        "code": "60258",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29469493",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00528935",
          "60528923",
          "70528913",
          "60528918",
          "90529006",
          "90529011",
          "80529016",
          "00529001"
        ],
        "code": "60258",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29471387",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60528975",
          "40528976"
        ],
        "code": "59813",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29471405",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "10368762",
          "80528960",
          "70528965",
          "80528955",
          "00528940"
        ],
        "code": "60630",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29485186",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "40528981",
          "60528975",
          "40528976"
        ],
        "code": "60625",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29485247",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "40528981",
          "30528986",
          "40528976",
          "10539603"
        ],
        "code": "60617",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29490102",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "00622382",
          "80622383"
        ],
        "code": "59813",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29608267",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "30622187",
          "90622189"
        ],
        "code": "60264",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29608328",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "50622332",
          "10622334"
        ],
        "code": "60264",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29608333",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "80528960",
          "90528950",
          "60528918",
          "00528940"
        ],
        "code": "60618",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39471358",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "40528981"
        ],
        "code": "60259",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39485096",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "70528913",
          "00528935",
          "10368762",
          "90529006",
          "20528996",
          "80529016",
          "60528918",
          "00529001"
        ],
        "code": "60630",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39485181",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "20528996",
          "00529001",
          "60539573",
          "00539608"
        ],
        "code": "61119",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39510406",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "00528935",
          "90529006",
          "80529016",
          "60528918",
          "00529001",
          "00539608",
          "60539573"
        ],
        "code": "61120",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39510897",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "30622248",
          "90622250",
          "20622244",
          "10622254"
        ],
        "code": "60617",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39607615",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "80622359",
          "60622360",
          "20622357"
        ],
        "code": "60618",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39607644",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60622138",
          "40622139"
        ],
        "code": "59813",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39608262",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "60622138",
          "40622139",
          "40622144"
        ],
        "code": "61119",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39608318",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "40622163",
          "20622164",
          "30622168"
        ],
        "code": "61119",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39608323",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "40528981",
          "30528986",
          "40528976"
        ],
        "code": "60618",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49469487",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "80528960",
          "90528950",
          "00528935",
          "80528955",
          "60528918",
          "00528940"
        ],
        "code": "60258",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49471386",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "90529006",
          "00529001"
        ],
        "code": "60264",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49485133",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "10368762",
          "40528981",
          "60528975",
          "30528991",
          "40528976"
        ],
        "code": "60630",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49485190",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60528975",
          "40528976",
          "60539573",
          "10539603"
        ],
        "code": "61119",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49510401",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "50622110",
          "70622109",
          "90622108"
        ],
        "code": "60625",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49608191",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "20622357",
          "00622358"
        ],
        "code": "59813",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49608266",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "90622108",
          "70622109",
          "70622114"
        ],
        "code": "61119",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49608290",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "40622163",
          "90622165"
        ],
        "code": "60264",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49608327",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "20622244",
          "30622248"
        ],
        "code": "60264",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49608332",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "20528996",
          "00529001"
        ],
        "code": "59813",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59471404",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "00528935",
          "40528976",
          "40528981",
          "30528991"
        ],
        "code": "60265",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59485199",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "80528960",
          "70528965",
          "00528940",
          "60539573",
          "80539614",
          "00528935",
          "80528955"
        ],
        "code": "61121",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59510617",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "00528935",
          "60539573",
          "40528976",
          "40528981",
          "30528991",
          "10539603"
        ],
        "code": "61120",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59510900",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "60622384",
          "30622385",
          "00622382",
          "90622387"
        ],
        "code": "60617",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59607619",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "90622165",
          "70622166",
          "40622163"
        ],
        "code": "60618",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59607643",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "10622188",
          "30622187"
        ],
        "code": "59813",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59608261",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "70528965",
          "00528940"
        ],
        "code": "59813",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69469504",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "90529006"
        ],
        "code": "60259",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69485085",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "40528981",
          "40528976"
        ],
        "code": "60264",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69485127",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "20528996",
          "90529006",
          "00529001",
          "60539573",
          "00539608",
          "00528935",
          "80529016"
        ],
        "code": "61121",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69510612",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "90622189",
          "70622190",
          "30622187",
          "30622192"
        ],
        "code": "60617",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69607628",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "10622334",
          "80622335",
          "50622332"
        ],
        "code": "60618",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69607647",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "40622163",
          "20622164"
        ],
        "code": "59813",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69608265",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "90622108",
          "50622110"
        ],
        "code": "60264",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69608326",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "00622382",
          "60622384"
        ],
        "code": "60264",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69608331",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "70528913",
          "00528935",
          "10368762",
          "90529006",
          "20528996",
          "80529016",
          "60528918",
          "00529001"
        ],
        "code": "60620",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79469481",
        "rangeId": "jattebo",
        "widthInMillimeters": 3300
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "10368762",
          "80528960",
          "70528965",
          "80528955",
          "00528940"
        ],
        "code": "60620",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79471403",
        "rangeId": "jattebo",
        "widthInMillimeters": 3300
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "00528935",
          "60528918",
          "80528960",
          "90528950",
          "80528955",
          "00528940"
        ],
        "code": "60619",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79485103",
        "rangeId": "jattebo",
        "widthInMillimeters": 3240
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "60528918",
          "80528960",
          "70528965",
          "00528940"
        ],
        "code": "60625",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79485259",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "90529006",
          "90529011",
          "00529001",
          "00539608"
        ],
        "code": "60617",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79490091",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "80622359",
          "60622360",
          "20622357",
          "20622362"
        ],
        "code": "60617",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79607623",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "00622141",
          "80622142",
          "60622138"
        ],
        "code": "60618",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79607642",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "70622109",
          "90622108"
        ],
        "code": "59813",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79608236",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00528935",
          "60528923",
          "70528913",
          "60528918",
          "90529006",
          "90529011",
          "80529016",
          "00529001"
        ],
        "code": "60619",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89485107",
        "rangeId": "jattebo",
        "widthInMillimeters": 3240
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "80528960",
          "80528955",
          "00528940"
        ],
        "code": "60265",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89485211",
        "rangeId": "jattebo",
        "widthInMillimeters": 3100
      },
      {
        "childItems": [
          "70528913",
          "10368762",
          "00528935",
          "60539573",
          "60528918",
          "40528976",
          "60528975",
          "40528981",
          "30528991",
          "10539603"
        ],
        "code": "61121",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89510606",
        "rangeId": "jattebo"
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "10622334",
          "80622335",
          "50622332",
          "40622337"
        ],
        "code": "60617",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89607608",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "90622165",
          "70622166",
          "40622163",
          "30622168"
        ],
        "code": "60617",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89607627",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "30622248",
          "90622250",
          "20622244"
        ],
        "code": "60618",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89607646",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "50622332",
          "30622333"
        ],
        "code": "59813",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89608269",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "30622187",
          "10622188",
          "30622192"
        ],
        "code": "61119",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89608311",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "50622332",
          "30622333",
          "40622337"
        ],
        "code": "61119",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89608325",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528918",
          "70528913",
          "20622357",
          "80622359"
        ],
        "code": "60264",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89608330",
        "rangeId": "jattebo",
        "widthInMillimeters": 2400
      },
      {
        "childItems": [
          "60528918",
          "10368762",
          "60539573",
          "20622357",
          "00622358",
          "20622362"
        ],
        "code": "61119",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621181",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "90529006",
          "90529011",
          "60528918",
          "00529001"
        ],
        "code": "60618",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99471341",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "70528913",
          "60528918",
          "00528935",
          "10368762",
          "40528981",
          "60528975",
          "30528991",
          "40528976"
        ],
        "code": "60620",
        "cover": "samsala-dark-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99471402",
        "rangeId": "jattebo",
        "widthInMillimeters": 3300
      },
      {
        "childItems": [
          "70528913",
          "80528960"
        ],
        "code": "60259",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99485084",
        "rangeId": "jattebo",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "80528960",
          "90528950",
          "00528940",
          "80539614"
        ],
        "code": "60617",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99490090",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "60539573",
          "50622110",
          "30622111",
          "90622108",
          "70622114"
        ],
        "code": "60617",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99607636",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "60528923",
          "70528913",
          "60528918",
          "90622189",
          "70622190",
          "30622187"
        ],
        "code": "60618",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99607641",
        "rangeId": "jattebo",
        "widthInMillimeters": 1900
      }
    ]
  },
  "kivik": {
    "coverProducts": [
      {
        "isIkeaPlus": true,
        "itemNo": "00517135",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517140",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517197",
        "name": "gunnared-light-brown-pink"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517201",
        "name": "gunnared-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00525282",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00526899",
        "name": "tibbleby-beige-grey"
      },
      {
        "itemNo": "00527506",
        "name": "tresund-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00539929",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00557678",
        "name": "gunnared-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00557758",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "00606278",
        "name": "gislatorp-grey-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517149",
        "name": "gunnared-light-brown-pink"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517154",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517187",
        "name": "gunnared-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517192",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10525286",
        "name": "gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10525291",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "10526907",
        "name": "tibbleby-beige-grey"
      },
      {
        "itemNo": "10526969",
        "name": "kelinge-grey-turquoise"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10539919",
        "name": "tallmyra-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517144",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517196",
        "name": "gunnared-blue"
      },
      {
        "itemNo": "20526959",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "20527505",
        "name": "tresund-anthracite"
      },
      {
        "itemNo": "20527567",
        "name": "tibbleby-beige-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20539914",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20539928",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20606277",
        "name": "gislatorp-grey-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517134",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517148",
        "name": "gunnared-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517153",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30525285",
        "name": "gunnared-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30525290",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "30526911",
        "name": "tibbleby-beige-grey"
      },
      {
        "itemNo": "30527557",
        "name": "tresund-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30539918",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30557667",
        "name": "gunnared-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517143",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517204",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "40526915",
        "name": "tibbleby-beige-grey"
      },
      {
        "itemNo": "40526958",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "40527547",
        "name": "tresund-light-beige"
      },
      {
        "itemNo": "40527552",
        "name": "tresund-light-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40539927",
        "name": "gunnared-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517133",
        "name": "tallmyra-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517147",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517190",
        "name": "gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50525289",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "50527542",
        "name": "tresund-light-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50539917",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517142",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60525284",
        "name": "gunnared-light-brown-pink"
      },
      {
        "itemNo": "60527532",
        "name": "tresund-light-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60539926",
        "name": "gunnared-blue"
      },
      {
        "itemNo": "60539969",
        "name": "tresund-light-beige"
      },
      {
        "itemNo": "60540227",
        "name": "kelinge-grey-turquoise"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517132",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517146",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517151",
        "name": "gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517189",
        "name": "gunnared-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517194",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517207",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70525288",
        "name": "tallmyra-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70525293",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "70527522",
        "name": "tresund-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70539916",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517141",
        "name": "tallmyra-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517155",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517202",
        "name": "gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80525283",
        "name": "gunnared-blue"
      },
      {
        "itemNo": "80526975",
        "name": "kelinge-grey-turquoise"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80539930",
        "name": "gunnared-light-brown-pink"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517145",
        "name": "tallmyra-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517150",
        "name": "gunnared-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517188",
        "name": "gunnared-light-brown-pink"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517193",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517206",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90525292",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "90527516",
        "name": "tresund-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90539915",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90557693",
        "name": "gunnared-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90557706",
        "name": "tallmyra-light-green"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-white-black",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00152.jpg",
        "name": "gunnared-light-brown-pink",
        "dotOverride": "#DCB6B5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "gunnared-light-green",
        "dotOverride": "#C0C5B8"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00143.jpg",
        "name": "grann-bomstad-dark-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tibbleby-beige-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "tresund-anthracite"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "gunnared-blue",
        "dotOverride": "#617E91"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "tallmyra-light-green",
        "dotOverride": "#97AEA1"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "gislatorp-grey-beige",
        "dotOverride": "#BBB4A5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "tallmyra-dark-green",
        "dotOverride": "#27392E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00116.jpg",
        "name": "kelinge-grey-turquoise",
        "dotOverride": "#54736E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "tallmyra-beige",
        "dotOverride": "#989896"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "tallmyra-blue",
        "dotOverride": "#305E7E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "tallmyra-medium-grey",
        "dotOverride": "#61626A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "tresund-light-beige"
      }
    ],
    "displayName": "KIVIK",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "18034",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00519525",
        "rangeId": "kivik",
        "widthInMillimeters": 2270
      },
      {
        "code": "18034",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40519528",
        "rangeId": "kivik",
        "widthInMillimeters": 2270
      },
      {
        "code": "18032",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50519518",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "code": "18032",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50519523",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "40526915",
          "10526907"
        ],
        "code": "29988",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09440580",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "10526907"
        ],
        "code": "18032",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09440599",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "80519376",
          "80526975",
          "40526958",
          "00519361"
        ],
        "code": "29986",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443017",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "20519505",
          "10519493",
          "50519518"
        ],
        "code": "29769",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443178",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519504",
          "40519528",
          "00519498"
        ],
        "code": "29993",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443183",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "20519505",
          "00519525"
        ],
        "code": "29989",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443201",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "20519384",
          "40527552"
        ],
        "code": "61385",
        "cover": "tresund-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09470237",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "00519361",
          "70527522"
        ],
        "code": "18034",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09482829",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "20527505",
          "90527516"
        ],
        "code": "29768",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09482853",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "80525283",
          "20517196",
          "30517148",
          "40519378"
        ],
        "code": "29993",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09484705",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "30525290",
          "10517192",
          "30517153",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09484710",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "70525293",
          "40517143"
        ],
        "code": "29768",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09484729",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "70525288",
          "80517141"
        ],
        "code": "29768",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09484734",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "30517153",
          "40517204"
        ],
        "code": "18033",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09484786",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "10525291",
          "90517193"
        ],
        "code": "29988",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09527658",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "10525286",
          "80517202"
        ],
        "code": "29989",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09527696",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "50525289",
          "70517146"
        ],
        "code": "29989",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09527700",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "90525292",
          "70517194"
        ],
        "code": "29988",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09527804",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "20519384",
          "60540227"
        ],
        "code": "61385",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19470227",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "30539918"
        ],
        "code": "61385",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19482782",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "50519354",
          "50527542"
        ],
        "code": "18032",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19482819",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "40527547",
          "60539969"
        ],
        "code": "29986",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19482862",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "70525293",
          "50517147",
          "00517135",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484696",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "50525289",
          "70517146",
          "30517134",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484700",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "90525292",
          "70517207",
          "00519361",
          "80519376"
        ],
        "code": "29986",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484719",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "10525286",
          "80517202"
        ],
        "code": "29986",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484724",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "80525283",
          "10517187"
        ],
        "code": "29768",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484738",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "70517189"
        ],
        "code": "18032",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484757",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "10517192"
        ],
        "code": "18032",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19484762",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "50517133",
          "90517145"
        ],
        "code": "18033",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19484823",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "30525285",
          "70517189"
        ],
        "code": "29988",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19527634",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "60525284",
          "90517188"
        ],
        "code": "29988",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19527714",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "40526915",
          "10526907"
        ],
        "code": "29768",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29440471",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "40519378",
          "80519376",
          "20526959",
          "40526958",
          "10526969",
          "50519354"
        ],
        "code": "29769",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443021",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "20526959",
          "80526975"
        ],
        "code": "18033",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443059",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "40526958",
          "10526969"
        ],
        "code": "29988",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443064",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519504",
          "40519528"
        ],
        "code": "29986",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443177",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519504",
          "50519523"
        ],
        "code": "29988",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443200",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "20519384",
          "80539930"
        ],
        "code": "61385",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29482753",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "90539915"
        ],
        "code": "61385",
        "cover": "tallmyra-white-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29482786",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "10525291",
          "90517193",
          "10517154",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29484709",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "30525285",
          "70517189",
          "90517150",
          "40519378"
        ],
        "code": "29769",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29484714",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "00525282",
          "20517144"
        ],
        "code": "29986",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29484728",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "50525289",
          "60517142"
        ],
        "code": "29768",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29484733",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "00517197"
        ],
        "code": "18034",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29484766",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "30517134",
          "70517146"
        ],
        "code": "18033",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29484785",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "00525282",
          "00517140"
        ],
        "code": "29988",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29527638",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "70525293",
          "40517143"
        ],
        "code": "29988",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29527662",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "30526911",
          "40526915"
        ],
        "code": "29986",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39440475",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "40519378",
          "80519376",
          "20526959",
          "40526958",
          "80526975",
          "00519361"
        ],
        "code": "29993",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443025",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "80526975"
        ],
        "code": "18034",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443049",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "20526959",
          "10526969"
        ],
        "code": "18031",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443054",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "40526958",
          "80526975"
        ],
        "code": "29989",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443068",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "20519505",
          "50519518"
        ],
        "code": "29768",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443172",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "10519493",
          "00519525"
        ],
        "code": "18033",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443191",
        "rangeId": "kivik",
        "widthInMillimeters": 3180
      },
      {
        "childItems": [
          "20519384",
          "20527567"
        ],
        "code": "61385",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39470231",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "20539914"
        ],
        "code": "61385",
        "cover": "tallmyra-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39482776",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "70527522",
          "20527505"
        ],
        "code": "29986",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39482861",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "60525284",
          "00517197",
          "10517149",
          "40519378"
        ],
        "code": "29993",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39484704",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "70525293",
          "50517147",
          "00519361",
          "80519376"
        ],
        "code": "29986",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39484718",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "70525288",
          "90517145"
        ],
        "code": "29986",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39484723",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "60525284",
          "90517188"
        ],
        "code": "29768",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39484737",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "90517188"
        ],
        "code": "18032",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39484756",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "60517142"
        ],
        "code": "18032",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39484761",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "80525283",
          "20517196"
        ],
        "code": "29989",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39527690",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "00519361",
          "30526911"
        ],
        "code": "18034",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49440597",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "50519354",
          "10526969"
        ],
        "code": "18032",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49443044",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "20519505",
          "00519525",
          "10519493"
        ],
        "code": "29993",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443181",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519498",
          "40519528"
        ],
        "code": "18033",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443195",
        "rangeId": "kivik",
        "widthInMillimeters": 3180
      },
      {
        "childItems": [
          "20519384",
          "20539928"
        ],
        "code": "61385",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49482752",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "80519376",
          "00527506",
          "20527505",
          "90527516"
        ],
        "code": "29769",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49482870",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "90525292",
          "70517194",
          "80517155",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49484708",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "10525286",
          "50517190",
          "70517151",
          "40519378"
        ],
        "code": "29769",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49484713",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "80525283",
          "20517196"
        ],
        "code": "29986",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49484727",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "30525290",
          "10517192"
        ],
        "code": "29768",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49484732",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "20517196"
        ],
        "code": "18034",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49484765",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "00519361",
          "70517146"
        ],
        "code": "18034",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49484770",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "80525283",
          "10517187"
        ],
        "code": "29988",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49527642",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "30525290",
          "40517204"
        ],
        "code": "29989",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49527703",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "60525284",
          "00517197"
        ],
        "code": "29989",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49527717",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "70525288",
          "90517145"
        ],
        "code": "29989",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49527722",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "80519376",
          "00526899",
          "40526915",
          "10526907"
        ],
        "code": "29769",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59440479",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "20519384",
          "70539916"
        ],
        "code": "61385",
        "cover": "tallmyra-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59482780",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "30525290",
          "40517204",
          "30517153",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59484699",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "30525285",
          "00517201",
          "90517150",
          "40519378"
        ],
        "code": "29993",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59484703",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "00525282",
          "00517140",
          "70517132",
          "40519378"
        ],
        "code": "29769",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59484717",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "50525289",
          "70517146"
        ],
        "code": "29986",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59484722",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "30525285",
          "70517189"
        ],
        "code": "29768",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59484736",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "00517140"
        ],
        "code": "18032",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59484755",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "80517141"
        ],
        "code": "18032",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59484760",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "10517187"
        ],
        "code": "18032",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59484802",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "60527532",
          "40527547"
        ],
        "code": "18033",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59494387",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "20527505",
          "90527516"
        ],
        "code": "29988",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59494392",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "10525286",
          "50517190"
        ],
        "code": "29988",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59527646",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "10525291",
          "90517206"
        ],
        "code": "29989",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59527707",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "90525292",
          "70517207"
        ],
        "code": "29989",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59527806",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "20519505",
          "00519525"
        ],
        "code": "29986",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443175",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519504",
          "00519498",
          "50519523"
        ],
        "code": "29769",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443180",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519504",
          "40519528"
        ],
        "code": "29989",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69443203",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "80519376",
          "60527532",
          "60539969",
          "50527542"
        ],
        "code": "29769",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69482869",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "70525293",
          "40517143",
          "00517135",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69484707",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "70525288",
          "80517141",
          "50517133",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69484712",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "60525284",
          "00517197"
        ],
        "code": "29986",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69484726",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "10525291",
          "90517193"
        ],
        "code": "29768",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69484731",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "80517155",
          "70517207"
        ],
        "code": "18033",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69484788",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "20517144"
        ],
        "code": "18034",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69484806",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "60539969",
          "50527542"
        ],
        "code": "29988",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69494396",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "20527505",
          "70527522"
        ],
        "code": "29989",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69494400",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "80519376",
          "00526899",
          "40526915",
          "30526911"
        ],
        "code": "29993",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79440483",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "20519384",
          "00539929"
        ],
        "code": "61385",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79482755",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "60539926"
        ],
        "code": "61385",
        "cover": "gunnared-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79482760",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "60527532",
          "50527542"
        ],
        "code": "18031",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79482840",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "80519376",
          "60527532",
          "60539969",
          "40527547"
        ],
        "code": "29993",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79482878",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "10525291",
          "90517206",
          "10517154",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484698",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "10525286",
          "80517202",
          "70517151",
          "40519378"
        ],
        "code": "29993",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484702",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "80525283",
          "10517187",
          "30517148",
          "40519378"
        ],
        "code": "29769",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484716",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "30525290",
          "40517204"
        ],
        "code": "29986",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484721",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "10525286",
          "50517190"
        ],
        "code": "29768",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484735",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "40517143"
        ],
        "code": "18032",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484764",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "70517151",
          "80517202"
        ],
        "code": "18033",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79484783",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "00527506",
          "70527522"
        ],
        "code": "18033",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79494386",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "60519377",
          "00557758",
          "90557706",
          "60519363"
        ],
        "code": "29986",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79499614",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "50525289",
          "60517142"
        ],
        "code": "29988",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79527650",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "30525285",
          "00517201"
        ],
        "code": "29989",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79527693",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "40526915",
          "30526911"
        ],
        "code": "29989",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89440576",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "20519505",
          "50519518"
        ],
        "code": "29988",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89443198",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "20519384",
          "30527557"
        ],
        "code": "61385",
        "cover": "tresund-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89470243",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "10539919"
        ],
        "code": "61385",
        "cover": "tallmyra-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89482774",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "00519361",
          "40527547"
        ],
        "code": "18034",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89482830",
        "rangeId": "kivik",
        "widthInMillimeters": 2280
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "60539969",
          "50527542"
        ],
        "code": "29768",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89482854",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "00525282",
          "20517144",
          "70517132",
          "40519378"
        ],
        "code": "29993",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89484706",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "50525289",
          "60517142",
          "30517134",
          "40519378"
        ],
        "code": "29769",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89484711",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "30525285",
          "00517201"
        ],
        "code": "29986",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89484725",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "90525292",
          "70517194"
        ],
        "code": "29768",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89484730",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "10517154",
          "90517206"
        ],
        "code": "18033",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89484787",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "70517194"
        ],
        "code": "18032",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89484805",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "60539969",
          "40527547"
        ],
        "code": "29989",
        "cover": "tresund-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89494404",
        "rangeId": "kivik",
        "widthInMillimeters": 3680
      },
      {
        "childItems": [
          "60519377",
          "30519350",
          "60519382",
          "30557667",
          "90557693",
          "00557678"
        ],
        "code": "29769",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89499618",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "70525288",
          "80517141"
        ],
        "code": "29988",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89527720",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "00526899",
          "30526911"
        ],
        "code": "18033",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99440585",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "00526899",
          "10526907"
        ],
        "code": "18031",
        "cover": "tibbleby-beige-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99440590",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "40526958",
          "10526969"
        ],
        "code": "29768",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99443013",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519504",
          "50519523"
        ],
        "code": "29768",
        "cover": "grann-bomstad-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99443174",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "20519384",
          "40539927"
        ],
        "code": "61385",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99482759",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "20519384",
          "50539917"
        ],
        "code": "61385",
        "cover": "tallmyra-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99482778",
        "rangeId": "kivik",
        "widthInMillimeters": 900
      },
      {
        "childItems": [
          "50519354",
          "90527516"
        ],
        "code": "18032",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99482820",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "40519378",
          "00527506",
          "90527516"
        ],
        "code": "18031",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99482839",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "80519376",
          "00527506",
          "20527505",
          "70527522"
        ],
        "code": "29993",
        "cover": "tresund-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99482877",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "90525292",
          "70517207",
          "80517155",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484697",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "00519361",
          "70525288",
          "90517145",
          "50517133",
          "40519378"
        ],
        "code": "29993",
        "cover": "tallmyra-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484701",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "60525284",
          "90517188",
          "10517149",
          "40519378"
        ],
        "code": "29769",
        "cover": "gunnared-light-brown-pink",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484715",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "10525291",
          "90517206",
          "00519361"
        ],
        "code": "29986",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484720",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "80519376",
          "50519354",
          "00525282",
          "00517140"
        ],
        "code": "29768",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484739",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "50517190"
        ],
        "code": "18032",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99484758",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "50519354",
          "90517193"
        ],
        "code": "18032",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99484763",
        "rangeId": "kivik",
        "widthInMillimeters": 1900
      },
      {
        "childItems": [
          "00519361",
          "40519378",
          "00517135",
          "50517147"
        ],
        "code": "18033",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99484824",
        "rangeId": "kivik"
      },
      {
        "childItems": [
          "50519354",
          "80519376",
          "30525290",
          "10517192"
        ],
        "code": "29988",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99527654",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "00525282",
          "20517144"
        ],
        "code": "29989",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99527687",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      },
      {
        "childItems": [
          "00519361",
          "80519376",
          "70525293",
          "50517147"
        ],
        "code": "29989",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99527710",
        "rangeId": "kivik",
        "widthInMillimeters": 3280
      }
    ]
  },
  "klagshamn": {
    "coverProducts": [
      {
        "itemNo": "00513547",
        "name": "skiftebo-dark-grey"
      },
      {
        "itemNo": "00551167",
        "name": "faringe-brown-orange"
      },
      {
        "itemNo": "40551165",
        "name": "faringe-light-grey"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "skiftebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00142.jpg",
        "name": "faringe-brown-orange"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "faringe-light-grey"
      }
    ],
    "displayName": "KLAGSHAMN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "klippan": {
    "coverProducts": [
      {
        "itemNo": "00582060",
        "name": "langban-bright-blue"
      },
      {
        "itemNo": "10454811",
        "name": "vissle-green"
      },
      {
        "itemNo": "20278855",
        "name": "vissle-grey"
      },
      {
        "itemNo": "20567266",
        "name": "vissle-green"
      },
      {
        "itemNo": "20582059",
        "name": "langban-bright-yellow"
      },
      {
        "itemNo": "70566467",
        "name": "dimmelsvik-dark-grey"
      },
      {
        "itemNo": "80582061",
        "name": "langban-bright-red"
      },
      {
        "itemNo": "90600272",
        "name": "tingetorp-yellow-white-floral-pattern"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00051.jpg",
        "name": "langban-bright-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00031.jpg",
        "name": "vissle-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "vissle-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00067.jpg",
        "name": "langban-bright-yellow"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "bomstad-black"
      },
      {
        "name": "dimmelsvik-dark-grey",
        "dotOverride": "#918f8c"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00052.jpg",
        "name": "langban-bright-red"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00101.jpg",
        "name": "tingetorp-yellow-white"
      },
      {
        "name": "flackarp-medium-grey",
        "dotOverride": "#62635e"
      },
      {
        "name": "flackarp-green",
        "dotOverride": "#1a9760"
      }
    ],
    "displayName": "KLIPPAN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "35242",
        "cover": "bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40399314",
        "rangeId": "klippan",
        "widthInMillimeters": 1770
      },
      {
        "childItems": [
          "30073194",
          "60567269"
        ],
        "code": "01486",
        "cover": "vissle-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09561666",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10072256",
          "00582060"
        ],
        "code": "01486",
        "cover": "langban-bright-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09564288",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "30073194",
          "90600272"
        ],
        "code": "01486",
        "cover": "tingetorp-yellow-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621298",
        "rangeId": "klippan"
      },
      {
        "childItems": [
          "30073194",
          "20567266"
        ],
        "code": "01486",
        "cover": "vissle-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29561665",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10160535",
          "70566467"
        ],
        "code": "01486",
        "cover": "dimmelsvik-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49554273",
        "rangeId": "klippan"
      },
      {
        "childItems": [
          "10072256",
          "20582059"
        ],
        "code": "01486",
        "cover": "langban-bright-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49564286",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10160535",
          "00567267"
        ],
        "code": "01486",
        "cover": "vissle-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59561664",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10072256",
          "80582061"
        ],
        "code": "01486",
        "cover": "langban-bright-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69564285",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10072256",
          "20278855"
        ],
        "code": "01486",
        "cover": "vissle-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79010614",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10072256",
          "20567266"
        ],
        "code": "01486",
        "cover": "vissle-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79561663",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "30072255",
          "30388759"
        ],
        "code": "01486",
        "cover": "flackarp-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89246862",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "30072255",
          "80567268"
        ],
        "code": "01486",
        "cover": "flackarp-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89561667",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      },
      {
        "childItems": [
          "10072256",
          "90600272"
        ],
        "code": "01486",
        "cover": "tingetorp-yellow-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89577753",
        "rangeId": "klippan"
      },
      {
        "childItems": [
          "10454811",
          "10160535"
        ],
        "cover": "vissle-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "99304267",
        "rangeId": "klippan",
        "widthInMillimeters": 1800
      }
    ]
  },
  "landskrona": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "grann-bomstad-golden-brown",
        "dotOverride": "#AB7150"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "gunnared-light-green",
        "dotOverride": "#C0C5B8"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "gunnared-blue",
        "dotOverride": "#617E91"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-blue",
        "dotOverride": "#293046"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "grann-bomstad-dark-beige"
      }
    ],
    "displayName": "LANDSKRONA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "30292399",
        "name": "metal"
      },
      {
        "itemNo": "60531218",
        "name": "black"
      },
      {
        "itemNo": "70292397",
        "name": "wood"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30513715",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230
      },
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40513630",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230
      },
      {
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60513714",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230
      },
      {
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80513708",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230
      },
      {
        "childItems": [
          "20413066",
          "70292397"
        ],
        "code": "30347",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09269169",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "00413406",
          "30292399"
        ],
        "code": "42167",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09270295",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "30292399"
        ],
        "code": "42169",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09270455",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "40413094",
          "70413549",
          "70292397"
        ],
        "code": "42168",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09272666",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424113",
          "90424085",
          "30292399"
        ],
        "code": "30358",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09275797",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "10493775",
          "90493776",
          "30292399"
        ],
        "code": "42168",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09393418",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "70292397"
        ],
        "code": "42170",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09393423",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "40505499",
          "40505461",
          "70292397"
        ],
        "code": "42169",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09420501",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "20522334",
          "70292397"
        ],
        "code": "42166",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09435343",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "70413549",
          "60531218"
        ],
        "code": "42166",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09444205",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "black"
      },
      {
        "childItems": [
          "30271293",
          "60531218"
        ],
        "code": "44485",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09444210",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "black"
      },
      {
        "childItems": [
          "20413066",
          "60531218"
        ],
        "code": "30347",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09491107",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "30413056",
          "60531218"
        ],
        "code": "42163",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09491112",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "90493776",
          "60531218"
        ],
        "code": "42166",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09491131",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "black"
      },
      {
        "childItems": [
          "60513714",
          "70292397"
        ],
        "code": "62491",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09491268",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "wood"
      },
      {
        "childItems": [
          "40513630",
          "30292399"
        ],
        "code": "62491",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09491273",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "metal"
      },
      {
        "childItems": [
          "50505489",
          "40505461",
          "70292397"
        ],
        "code": "64089",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09554294",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "80513708",
          "60531218"
        ],
        "code": "62491",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09578327",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "black"
      },
      {
        "childItems": [
          "30292399",
          "30271293"
        ],
        "code": "42166",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19031742",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "80271318",
          "30292399"
        ],
        "code": "30347",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19031841",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "30292399",
          "40271301",
          "00271280"
        ],
        "code": "42170",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19046201",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "70413059",
          "70292397"
        ],
        "code": "42163",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19270068",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "70413059",
          "40413094",
          "70292397"
        ],
        "code": "42164",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19270228",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "30413056",
          "80413087",
          "70292397"
        ],
        "code": "42164",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19270233",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "50413545",
          "30292399"
        ],
        "code": "42166",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19270266",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "30413099",
          "50413545",
          "30292399"
        ],
        "code": "42168",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19272637",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "70424072",
          "90424085",
          "30292399"
        ],
        "code": "30350",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19275730",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40493774",
          "10493775",
          "70292397"
        ],
        "code": "42164",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19393408",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "70505469",
          "40505461",
          "30292399"
        ],
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "itemNo": "19415797",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40505499",
          "30292399"
        ],
        "code": "42167",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19415820",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "20522334",
          "30292399"
        ],
        "code": "42166",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19435328",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "60531218"
        ],
        "code": "42169",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19444224",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "80271318",
          "40271301",
          "60531218"
        ],
        "code": "42164",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19491116",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "30413056",
          "80413087",
          "60531218"
        ],
        "code": "42164",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19491121",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "60424100",
          "90424085",
          "70292397"
        ],
        "code": "64091",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19554279",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "90493776",
          "10493775",
          "30292399"
        ],
        "code": "64089",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19554298",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "70413549",
          "40413094",
          "70292397"
        ],
        "code": "64089",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19554302",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "70292397",
          "30271293"
        ],
        "code": "42166",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29031746",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "80271318",
          "70292397"
        ],
        "code": "30347",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29031845",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "30292399",
          "40271301",
          "00271280"
        ],
        "code": "42169",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29032406",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "00413406",
          "30413099",
          "70292397"
        ],
        "code": "42170",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29269154",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "70493777",
          "70292397"
        ],
        "code": "42167",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29393417",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "30292399"
        ],
        "code": "42170",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29393422",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "70505469",
          "70292397"
        ],
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "itemNo": "29415792",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "40505461",
          "50505489",
          "70292397"
        ],
        "code": "42168",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29415829",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "90522335",
          "30292399"
        ],
        "code": "42167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29435323",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "90522335",
          "70292397"
        ],
        "code": "42167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29435337",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "30522338",
          "70292397"
        ],
        "code": "42163",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29435342",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "50413545",
          "60531218"
        ],
        "code": "44485",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29444209",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "black"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "60531218"
        ],
        "code": "42169",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29444228",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "00271280",
          "40271301",
          "60531218"
        ],
        "code": "30358",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29444233",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "70413059",
          "60531218"
        ],
        "code": "42163",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29491111",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "60531218"
        ],
        "code": "42169",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29491149",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "60531218"
        ],
        "code": "42170",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29491154",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "black"
      },
      {
        "childItems": [
          "50505489",
          "40505461",
          "30292399"
        ],
        "code": "64089",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29554293",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "30292399"
        ],
        "code": "42170",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39269988",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "70292397"
        ],
        "code": "42170",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39269993",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "70413059",
          "40413094",
          "30292399"
        ],
        "code": "42164",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39270227",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "10413552",
          "70292397"
        ],
        "code": "42166",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39270289",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "60413413",
          "70292397"
        ],
        "code": "42167",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39270326",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "70424072",
          "90424085",
          "70292397"
        ],
        "code": "30350",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39275729",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "90424113",
          "70292397"
        ],
        "code": "44010",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39275772",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424085",
          "60424100",
          "30292399"
        ],
        "code": "30356",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39275786",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "40493774",
          "70292397"
        ],
        "code": "42163",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39393407",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "40505499",
          "40505461",
          "30292399"
        ],
        "code": "42170",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39415838",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "30522338",
          "30292399"
        ],
        "code": "42163",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39435327",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "20522334",
          "40522333",
          "30292399"
        ],
        "code": "42168",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39435332",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "70413059",
          "40413094",
          "60531218"
        ],
        "code": "42164",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39491120",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "60531218"
        ],
        "code": "42169",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39491144",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "40513630",
          "70292397"
        ],
        "code": "62491",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39491276",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "wood"
      },
      {
        "childItems": [
          "80513708",
          "30292399"
        ],
        "code": "62491",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39491281",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "metal"
      },
      {
        "childItems": [
          "60424100",
          "90424085",
          "30292399"
        ],
        "code": "64091",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39554278",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "70413549",
          "40413094",
          "30292399"
        ],
        "code": "64089",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39554301",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "30292399",
          "30271293",
          "40271301"
        ],
        "code": "42168",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49031873",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "70292397",
          "40271301",
          "00271280"
        ],
        "code": "42169",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49032410",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "80271318",
          "30292399",
          "40271301"
        ],
        "code": "30350",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49046266",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "30413099",
          "00413406",
          "30292399"
        ],
        "code": "42170",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49269153",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "20413066",
          "30292399"
        ],
        "code": "30347",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49269167",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "20413066",
          "30413099",
          "70292397"
        ],
        "code": "30350",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49269172",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "70292397"
        ],
        "code": "42170",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49269983",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "70413549",
          "70292397"
        ],
        "code": "42166",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49270279",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "10413552",
          "30292399"
        ],
        "code": "42166",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49270284",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "00413406",
          "70292397"
        ],
        "code": "42167",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49270302",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "60413413",
          "30292399"
        ],
        "code": "42167",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49270321",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "00413406",
          "30413099",
          "70292397"
        ],
        "code": "42169",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49270359",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "60424100",
          "30292399"
        ],
        "code": "44485",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49275757",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "70493777",
          "30292399"
        ],
        "code": "42167",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49393416",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "70292397"
        ],
        "code": "42169",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49393421",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "20522334",
          "40522333",
          "70292397"
        ],
        "code": "42168",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49435322",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "70292397"
        ],
        "code": "42169",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49435336",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "30292399"
        ],
        "code": "42169",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49435341",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "00271280",
          "60531218"
        ],
        "code": "44010",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49444208",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "70413549",
          "40413094",
          "60531218"
        ],
        "code": "42168",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49444227",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "10413552",
          "80413087",
          "60531218"
        ],
        "code": "42168",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49444232",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "80271318",
          "60531218"
        ],
        "code": "30347",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49491105",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "40493774",
          "60531218"
        ],
        "code": "42163",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49491110",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "20522334",
          "40522333",
          "70292397"
        ],
        "code": "64089",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49554292",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "00271280",
          "30292399"
        ],
        "code": "42167",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59031698",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "00271280",
          "70292397"
        ],
        "code": "42167",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59031702",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "70292397",
          "30271293",
          "40271301"
        ],
        "code": "42168",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59031877",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "70292397",
          "40271301",
          "00271280"
        ],
        "code": "42170",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59046204",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "70413059",
          "30292399"
        ],
        "code": "42163",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270066",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "70413549",
          "30292399"
        ],
        "code": "42166",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270274",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "30292399"
        ],
        "code": "42167",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270306",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "70292397"
        ],
        "code": "42167",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270311",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "00413406",
          "30413099",
          "30292399"
        ],
        "code": "42169",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270354",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "70292397"
        ],
        "code": "42169",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59270373",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424085",
          "60424100",
          "70292397"
        ],
        "code": "30356",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59275785",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424113",
          "90424085",
          "70292397"
        ],
        "code": "30338",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59275813",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "40493774",
          "30292399"
        ],
        "code": "42163",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59393406",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "70505469",
          "40505461",
          "70292397"
        ],
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "itemNo": "59415795",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "40505499",
          "70292397"
        ],
        "code": "42167",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59415823",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "wood"
      },
      {
        "childItems": [
          "50413545",
          "30413099",
          "60531218"
        ],
        "code": "30356",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59444222",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "30513715",
          "30292399"
        ],
        "code": "62491",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59489866",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "metal"
      },
      {
        "childItems": [
          "40493774",
          "10493775",
          "60531218"
        ],
        "code": "42164",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59491119",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "20522334",
          "40522333",
          "60531218"
        ],
        "code": "42168",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59491138",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "70292397",
          "40271301",
          "30271293"
        ],
        "code": "64089",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59554277",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "90493776",
          "10493775",
          "70292397"
        ],
        "code": "64089",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59554300",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "30513715",
          "60531218"
        ],
        "code": "62490",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59578315",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "black"
      },
      {
        "childItems": [
          "80271318",
          "70292397",
          "40271301"
        ],
        "code": "30350",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69046270",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "20413066",
          "30413099",
          "30292399"
        ],
        "code": "30350",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69269171",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "30292399"
        ],
        "code": "42170",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69269982",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "50413545",
          "70292397"
        ],
        "code": "42166",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69270264",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "80413087",
          "10413552",
          "70292397"
        ],
        "code": "42168",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69272687",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "70424072",
          "70292397"
        ],
        "code": "30347",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69275704",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "90493776",
          "70292397"
        ],
        "code": "42166",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69393415",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "70493777",
          "10493775",
          "30292399"
        ],
        "code": "42169",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69393420",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "70505469",
          "30292399"
        ],
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "itemNo": "69415790",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40505499",
          "40505461",
          "30292399"
        ],
        "code": "42169",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69415832",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "30522338",
          "40522333",
          "70292397"
        ],
        "code": "42164",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69435335",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "30522338",
          "40522333",
          "30292399"
        ],
        "code": "42164",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69435340",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "60531218"
        ],
        "code": "42167",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69444207",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "60413413",
          "60531218"
        ],
        "code": "42167",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69444212",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "30271293",
          "40271301",
          "60531218"
        ],
        "code": "30356",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69444226",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "00413406",
          "30413099",
          "60531218"
        ],
        "code": "30338",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69444231",
        "rangeId": "landskrona",
        "widthInMillimeters": 3550,
        "legs": "black"
      },
      {
        "childItems": [
          "10493775",
          "90493776",
          "60531218"
        ],
        "code": "42168",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69491091",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "black"
      },
      {
        "childItems": [
          "30522338",
          "60531218"
        ],
        "code": "42163",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69491109",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "60531218"
        ],
        "code": "42170",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69491152",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "black"
      },
      {
        "childItems": [
          "60513714",
          "30292399"
        ],
        "code": "62491",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69491265",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "metal"
      },
      {
        "childItems": [
          "20522334",
          "40522333",
          "30292399"
        ],
        "code": "64089",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69554291",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "30413056",
          "30292399"
        ],
        "code": "42163",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79270070",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "30292399"
        ],
        "code": "42169",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79270372",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "metal"
      },
      {
        "childItems": [
          "80413087",
          "10413552",
          "30292399"
        ],
        "code": "42168",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79272682",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "40505499",
          "40505461",
          "70292397"
        ],
        "code": "42170",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79415841",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "70292397"
        ],
        "code": "42170",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79435325",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "40413414",
          "40413094",
          "60531218"
        ],
        "code": "42170",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79444221",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "70493777",
          "60531218"
        ],
        "code": "42167",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79491137",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "80513708",
          "70292397"
        ],
        "code": "62491",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79491284",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "wood"
      },
      {
        "childItems": [
          "30292399",
          "40271301",
          "30271293"
        ],
        "code": "64089",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79554276",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "50413545",
          "30413099",
          "70292397"
        ],
        "code": "64089",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79554281",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "10413552",
          "80413087",
          "70292397"
        ],
        "code": "64089",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79554304",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "wood"
      },
      {
        "childItems": [
          "60513714",
          "60531218"
        ],
        "code": "62490",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79578319",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "black"
      },
      {
        "childItems": [
          "50413545",
          "30413099",
          "70292397"
        ],
        "code": "42168",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89272648",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "40413094",
          "70413549",
          "30292399"
        ],
        "code": "42168",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89272667",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "70424072",
          "30292399"
        ],
        "code": "30347",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89275699",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "60424100",
          "70292397"
        ],
        "code": "44485",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89275760",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424113",
          "90424085",
          "70292397"
        ],
        "code": "30358",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89275798",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "10493775",
          "90493776",
          "70292397"
        ],
        "code": "42168",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89393419",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "wood"
      },
      {
        "childItems": [
          "50505489",
          "30292399"
        ],
        "code": "42166",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89415812",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "40505461",
          "50505489",
          "30292399"
        ],
        "code": "42168",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89415826",
        "rangeId": "landskrona",
        "widthInMillimeters": 2400,
        "legs": "metal"
      },
      {
        "childItems": [
          "90522335",
          "40522333",
          "30292399"
        ],
        "code": "42170",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89435339",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "00413406",
          "60531218"
        ],
        "code": "44010",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89444206",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "10413552",
          "60531218"
        ],
        "code": "42166",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89444211",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "black"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "60531218"
        ],
        "code": "42170",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89444225",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "00271280",
          "40271301",
          "60531218"
        ],
        "code": "30338",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89444230",
        "rangeId": "landskrona",
        "widthInMillimeters": 3550,
        "legs": "black"
      },
      {
        "childItems": [
          "30513715",
          "70292397"
        ],
        "code": "62491",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89489884",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "wood"
      },
      {
        "childItems": [
          "20522334",
          "60531218"
        ],
        "code": "42166",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89491132",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "30413056",
          "70292397"
        ],
        "code": "42163",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99270074",
        "rangeId": "landskrona",
        "legs": "wood"
      },
      {
        "childItems": [
          "30413056",
          "80413087",
          "30292399"
        ],
        "code": "42164",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99270229",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "60413413",
          "80413087",
          "70292397"
        ],
        "code": "42169",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99270465",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "wood"
      },
      {
        "childItems": [
          "90424113",
          "30292399"
        ],
        "code": "44010",
        "cover": "grann-bomstad-dark-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99275769",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "metal"
      },
      {
        "childItems": [
          "90424113",
          "90424085",
          "30292399"
        ],
        "code": "30338",
        "cover": "grann-bomstad-dark-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99275811",
        "rangeId": "landskrona",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "40493774",
          "10493775",
          "30292399"
        ],
        "code": "42164",
        "cover": "gunnared-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99393409",
        "rangeId": "landskrona",
        "legs": "metal"
      },
      {
        "childItems": [
          "90493776",
          "30292399"
        ],
        "code": "42166",
        "cover": "gunnared-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99393414",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "metal"
      },
      {
        "childItems": [
          "50505489",
          "70292397"
        ],
        "code": "42166",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99415816",
        "rangeId": "landskrona",
        "widthInMillimeters": 1640,
        "legs": "wood"
      },
      {
        "childItems": [
          "00413406",
          "30413099",
          "60531218"
        ],
        "code": "30358",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99444220",
        "rangeId": "landskrona",
        "widthInMillimeters": 2800,
        "legs": "black"
      },
      {
        "childItems": [
          "20413066",
          "30413099",
          "60531218"
        ],
        "code": "42164",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99491117",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "30522338",
          "40522333",
          "60531218"
        ],
        "code": "42164",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99491122",
        "rangeId": "landskrona",
        "legs": "black"
      },
      {
        "childItems": [
          "90522335",
          "60531218"
        ],
        "code": "42167",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99491136",
        "rangeId": "landskrona",
        "widthInMillimeters": 2040,
        "legs": "black"
      },
      {
        "childItems": [
          "30413099",
          "50413545",
          "30292399"
        ],
        "code": "64089",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99554280",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "10413552",
          "80413087",
          "30292399"
        ],
        "code": "64089",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99554303",
        "rangeId": "landskrona",
        "widthInMillimeters": 3200,
        "legs": "metal"
      },
      {
        "childItems": [
          "40513630",
          "60531218"
        ],
        "code": "62491",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99578323",
        "rangeId": "landskrona",
        "widthInMillimeters": 2230,
        "legs": "black"
      }
    ]
  },
  "langaryd": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "lejde-grey-black",
        "dotOverride": "#787878"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "lejde-light-grey"
      }
    ],
    "displayName": "LÅNGARYD",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "20509498",
        "name": "chrome-effect"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "80509730",
          "20509498"
        ],
        "code": "56446",
        "cover": "lejde-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19418140",
        "rangeId": "langaryd",
        "widthInMillimeters": 1980,
        "legs": "chrome-effect"
      },
      {
        "childItems": [
          "20509733",
          "20509498"
        ],
        "code": "56446",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49418134",
        "rangeId": "langaryd",
        "widthInMillimeters": 1980,
        "legs": "chrome-effect"
      },
      {
        "childItems": [
          "80509749",
          "20509498"
        ],
        "code": "56448",
        "cover": "lejde-light-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69418086",
        "rangeId": "langaryd",
        "widthInMillimeters": 2420,
        "legs": "chrome-effect"
      },
      {
        "childItems": [
          "50509755",
          "20509498"
        ],
        "code": "56448",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79418104",
        "rangeId": "langaryd",
        "widthInMillimeters": 2420,
        "legs": "chrome-effect"
      }
    ]
  },
  "lillehem": {
    "coverProducts": [
      {
        "itemNo": "00519587",
        "name": "vissle-beige"
      },
      {
        "itemNo": "00519592",
        "name": "gunnared-dark-grey"
      },
      {
        "itemNo": "00519605",
        "name": "vissle-beige"
      },
      {
        "itemNo": "00519667",
        "name": "vissle-beige"
      },
      {
        "itemNo": "00519672",
        "name": "gunnared-dark-grey"
      },
      {
        "itemNo": "10519596",
        "name": "gunnared-brown-red"
      },
      {
        "itemNo": "60519589",
        "name": "gunnared-brown-red"
      },
      {
        "itemNo": "60519674",
        "name": "gunnared-brown-red"
      },
      {
        "itemNo": "70519598",
        "name": "gunnared-dark-grey"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "vissle-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "gunnared-brown-red"
      }
    ],
    "displayName": "LILLEHEM",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "40518425",
        "name": "metal"
      },
      {
        "itemNo": "40518430",
        "name": "wood"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00519417",
        "rangeId": "lillehem",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "60519589",
          "10519596",
          "60519674"
        ],
        "code": "66245",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09536163",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66251",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09563849",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66251",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09568272",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "50299502",
          "60519674",
          "60519589",
          "10519596",
          "40518430"
        ],
        "code": "66252",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09569747",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "50299502",
          "60519674",
          "10519596",
          "40518430"
        ],
        "code": "66254",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09569752",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "60519589",
          "60519674",
          "10519596",
          "50299502",
          "40518430"
        ],
        "code": "66248",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09574782",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519667",
          "00519605",
          "70350189",
          "00519587"
        ],
        "code": "72268",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09617786",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66249",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19471255",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66249",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19471279",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66253",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19536025",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "00519605",
          "00519587",
          "00519667"
        ],
        "code": "66252",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19536266",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "00519605",
          "00519587",
          "00519667"
        ],
        "code": "66246",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19536285",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519592",
          "00519672",
          "70519598",
          "50299502",
          "40518430"
        ],
        "code": "66247",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19569742",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519587",
          "00519667",
          "00519605",
          "50299502",
          "40518430"
        ],
        "code": "66248",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19571047",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "00519592",
          "70519598"
        ],
        "code": "66250",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29536058",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "00519592",
          "70519598",
          "00519672"
        ],
        "code": "66245",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29536157",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66256",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29536195",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "00519605",
          "00519587",
          "00519667"
        ],
        "code": "66246",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29536280",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519587",
          "00519667",
          "00519605",
          "50299502",
          "40518425"
        ],
        "code": "66248",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29553482",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "50299502",
          "00519605",
          "00519587",
          "40518430"
        ],
        "code": "66250",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29569746",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "50299502",
          "00519605",
          "00519587",
          "00519667",
          "40518430"
        ],
        "code": "66252",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29569751",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519672",
          "70519598",
          "70350189",
          "00519592"
        ],
        "code": "72268",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29617785",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66253",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536048",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66253",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536053",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "00519605",
          "00519587",
          "00519667"
        ],
        "code": "66245",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536152",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "00519592",
          "70519598",
          "00519672"
        ],
        "code": "66252",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536265",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "00519592",
          "70519598",
          "00519672"
        ],
        "code": "66246",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536307",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "60519589",
          "60519674",
          "10519596",
          "50299502",
          "40518425"
        ],
        "code": "66247",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39553467",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "60519589",
          "60519674",
          "10519596",
          "50299502",
          "40518430"
        ],
        "code": "66247",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39569741",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519592",
          "00519672",
          "70519598",
          "50299502",
          "40518425"
        ],
        "code": "66248",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39574752",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66249",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49471273",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "40518425",
          "50299502",
          "00519605",
          "00519667"
        ],
        "code": "66254",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49536236",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "00519592",
          "70519598",
          "00519672"
        ],
        "code": "66246",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49536302",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66251",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49568294",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "50299502",
          "60519589",
          "10519596",
          "40518430"
        ],
        "code": "66250",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49569745",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "60519589",
          "10519596",
          "60519674"
        ],
        "code": "66245",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59536146",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519587",
          "00519667",
          "00519605",
          "50299502",
          "40518425"
        ],
        "code": "66247",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59553466",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519672",
          "70519598",
          "70350189",
          "00519592"
        ],
        "code": "72268",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59617784",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66249",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69471267",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "00519605",
          "00519587"
        ],
        "code": "66250",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536080",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "00519592",
          "70519598",
          "00519672"
        ],
        "code": "66245",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536141",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66256",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536216",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66256",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536221",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "40518425",
          "50299502",
          "70519598",
          "00519672"
        ],
        "code": "66254",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536235",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "60519674",
          "60519589",
          "10519596"
        ],
        "code": "66252",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536264",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66251",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69568293",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "50299502",
          "00519605",
          "00519667",
          "40518430"
        ],
        "code": "66254",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69569754",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "40518425",
          "50299502",
          "60519589",
          "10519596"
        ],
        "code": "66250",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536070",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "00519605",
          "00519587",
          "00519667"
        ],
        "code": "66245",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536169",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66256",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536206",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66256",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536211",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519592",
          "00519672",
          "70519598",
          "50299502",
          "40518425"
        ],
        "code": "66247",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79553465",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00518432",
          "50299502",
          "00519592",
          "70519598",
          "40518430"
        ],
        "code": "66250",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79569744",
        "rangeId": "lillehem",
        "widthInMillimeters": 2020,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "60519674",
          "10519596",
          "70350189",
          "60519589"
        ],
        "code": "72268",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79617783",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66249",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89471285",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66253",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89536036",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66253",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89536041",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66256",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89536201",
        "rangeId": "lillehem",
        "widthInMillimeters": 4400,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518425",
          "60519589",
          "10519596",
          "60519674"
        ],
        "code": "66246",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89536296",
        "rangeId": "lillehem",
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "00519667",
          "00519605"
        ],
        "code": "66251",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89568287",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66251",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89568292",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "50299502",
          "00519592",
          "70519598",
          "00519672",
          "40518430"
        ],
        "code": "66252",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89569748",
        "rangeId": "lillehem",
        "widthInMillimeters": 2740,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "50299502",
          "70519598",
          "00519672",
          "40518430"
        ],
        "code": "66254",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89569753",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519667",
          "00519605",
          "70350189",
          "00519587"
        ],
        "code": "72268",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89617787",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "00519672",
          "70519598"
        ],
        "code": "66249",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99471261",
        "rangeId": "lillehem",
        "widthInMillimeters": 1520,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518430",
          "00518432",
          "60519674",
          "10519596"
        ],
        "code": "66253",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99536031",
        "rangeId": "lillehem",
        "widthInMillimeters": 2960,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "00518432",
          "40518425",
          "50299502",
          "60519674",
          "10519596"
        ],
        "code": "66254",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99536234",
        "rangeId": "lillehem",
        "widthInMillimeters": 3460,
        "legs": "metal"
      },
      {
        "childItems": [
          "00519417",
          "70350189",
          "00518432",
          "40518430",
          "60519589",
          "10519596",
          "60519674"
        ],
        "code": "66246",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99536291",
        "rangeId": "lillehem",
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "60519589",
          "60519674",
          "10519596",
          "50299502",
          "40518425"
        ],
        "code": "66248",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99553488",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "metal"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519587",
          "00519667",
          "00519605",
          "50299502",
          "40518430"
        ],
        "code": "66247",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99569743",
        "rangeId": "lillehem",
        "widthInMillimeters": 4720,
        "legs": "wood"
      },
      {
        "childItems": [
          "70350189",
          "00519417",
          "00518432",
          "00519592",
          "00519672",
          "70519598",
          "50299502",
          "40518430"
        ],
        "code": "66248",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99574754",
        "rangeId": "lillehem",
        "widthInMillimeters": 3420,
        "legs": "wood"
      },
      {
        "childItems": [
          "00519417",
          "40518425",
          "00518432",
          "60519674",
          "10519596",
          "70350189",
          "60519589"
        ],
        "code": "72268",
        "cover": "gunnared-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99617782",
        "rangeId": "lillehem",
        "widthInMillimeters": 2240,
        "legs": "metal"
      }
    ]
  },
  "lillesater": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00101.jpg",
        "name": "gunnared-bright-green-yellow",
        "dotOverride": "#DCCB7C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00096.jpg",
        "name": "axvall-off-white",
        "dotOverride": "#E7E7DC"
      }
    ],
    "displayName": "LILLESÄTER",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "73130",
        "cover": "gunnared-bright-green-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30618492",
        "rangeId": "lillesater",
        "widthInMillimeters": 2010
      },
      {
        "code": "73130",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40619071",
        "rangeId": "lillesater",
        "widthInMillimeters": 2010
      },
      {
        "childItems": [
          "40621045",
          "40619071"
        ],
        "code": "73066",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614291",
        "rangeId": "lillesater",
        "widthInMillimeters": 2690
      },
      {
        "childItems": [
          "60621049",
          "30618492"
        ],
        "code": "73066",
        "cover": "gunnared-bright-green-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614271",
        "rangeId": "lillesater",
        "widthInMillimeters": 2690
      }
    ]
  },
  "linanas": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00096.jpg",
        "name": "vissle-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "vissle-dark-grey"
      }
    ],
    "displayName": "LINANÄS",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "55034",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "10512236",
        "rangeId": "linanas",
        "widthInMillimeters": 1970
      },
      {
        "code": "55034",
        "cover": "vissle-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20512245",
        "rangeId": "linanas",
        "widthInMillimeters": 1970
      },
      {
        "code": "55035",
        "cover": "vissle-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30512235",
        "rangeId": "linanas",
        "widthInMillimeters": 1970
      },
      {
        "code": "53941",
        "cover": "vissle-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40499974",
        "rangeId": "linanas",
        "widthInMillimeters": 1370
      },
      {
        "code": "53941",
        "cover": "vissle-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "80503375",
        "rangeId": "linanas",
        "widthInMillimeters": 1370
      },
      {
        "code": "55035",
        "cover": "vissle-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90512242",
        "rangeId": "linanas",
        "widthInMillimeters": 1970
      }
    ]
  },
  "lindakra": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "vissle-dark-grey"
      }
    ],
    "displayName": "LINDÅKRA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "67067",
        "cover": "vissle-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "20582610",
        "rangeId": "lindakra",
        "widthInMillimeters": 2060
      }
    ]
  },
  "lycksele": {
    "coverProducts": [
      {
        "itemNo": "10479675",
        "name": "ransta-natural"
      },
      {
        "itemNo": "50590840",
        "name": "vansbro-yellow"
      },
      {
        "itemNo": "70578639",
        "name": "grindtorp-multicolour-stripe-pattern"
      },
      {
        "itemNo": "90479737",
        "name": "knisa-light-grey"
      },
      {
        "itemNo": "90479756",
        "name": "vansbro-dark-grey"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "ransta-natural"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00101.jpg",
        "name": "vansbro-yellow"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "grindtorp-multicolour",
        "dotOverride": [
          "#E0A230",
          "#F1AFC9",
          "#FFFFFF",
          "#81B496",
          "#137BC9"
        ]
      },
      {
        "name": "black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "knisa-light-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "vansbro-dark-grey"
      }
    ],
    "displayName": "LYCKSELE",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": [
      {
        "itemNo": "00102065",
        "name": "lycksele-lovas-mattress"
      },
      {
        "itemNo": "60102067",
        "name": "lycksele-havet-mattress"
      },
      {
        "itemNo": "80102066",
        "name": "lycksele-murbo-mattress"
      }
    ],
    "sofas": [
      {
        "childItems": [
          "90032681",
          "90479737",
          "00102065"
        ],
        "code": "09377",
        "cover": "knisa-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09387035",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-lovas-mattress"
      },
      {
        "childItems": [
          "90032681",
          "90479737",
          "80102066"
        ],
        "code": "09377",
        "cover": "knisa-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09387040",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-murbo-mattress"
      },
      {
        "childItems": [
          "90032681",
          "90479737",
          "60102067"
        ],
        "code": "09377",
        "cover": "knisa-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19387030",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-havet-mattress"
      },
      {
        "childItems": [
          "90032681",
          "60102067",
          "70578639"
        ],
        "code": "09377",
        "cover": "grindtorp-multicolour",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19561699",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-havet-mattress"
      },
      {
        "childItems": [
          "90032681",
          "50590840",
          "80102066"
        ],
        "code": "09377",
        "cover": "vansbro-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29563216",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-murbo-mattress"
      },
      {
        "childItems": [
          "90032681",
          "10479675",
          "80102066"
        ],
        "code": "09377",
        "cover": "ransta-natural",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49387019",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-murbo-mattress"
      },
      {
        "childItems": [
          "90032681",
          "10479675",
          "60102067"
        ],
        "code": "09377",
        "cover": "ransta-natural",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49387024",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-havet-mattress"
      },
      {
        "childItems": [
          "90032681",
          "00102065",
          "70578639"
        ],
        "code": "09377",
        "cover": "grindtorp-multicolour",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49561706",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-lovas-mattress"
      },
      {
        "childItems": [
          "90032681",
          "50590840",
          "00102065"
        ],
        "code": "09377",
        "cover": "vansbro-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49563201",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-lovas-mattress"
      },
      {
        "childItems": [
          "90032681",
          "90479756",
          "00102065"
        ],
        "code": "09377",
        "cover": "vansbro-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59387132",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-lovas-mattress"
      },
      {
        "childItems": [
          "90032681",
          "50590840",
          "60102067"
        ],
        "code": "09377",
        "cover": "vansbro-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79563209",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-havet-mattress"
      },
      {
        "childItems": [
          "90032681",
          "90479756",
          "80102066"
        ],
        "code": "09377",
        "cover": "vansbro-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89387135",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-murbo-mattress"
      },
      {
        "childItems": [
          "90032681",
          "90479756",
          "60102067"
        ],
        "code": "09377",
        "cover": "vansbro-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89387140",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-havet-mattress"
      },
      {
        "childItems": [
          "90032681",
          "80102066",
          "70578639"
        ],
        "code": "09377",
        "cover": "grindtorp-multicolour",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89561714",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-murbo-mattress"
      },
      {
        "childItems": [
          "90032681",
          "10479675",
          "00102065"
        ],
        "code": "09377",
        "cover": "ransta-natural",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99387007",
        "rangeId": "lycksele",
        "widthInMillimeters": 1420,
        "mattress": "lycksele-lovas-mattress"
      }
    ]
  },
  "mannarp": {
    "coverProducts": [
      {
        "itemNo": "00611425",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "10611613",
        "name": "saxemara-grey-beige"
      },
      {
        "itemNo": "50611324",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "60611328",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "60611333",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "60611597",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "60611601",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "70611605",
        "name": "saxemara-grey-beige"
      },
      {
        "itemNo": "90611609",
        "name": "saxemara-grey-beige"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "saxemara-grey-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "saxemara-black-blue",
        "dotOverride": "#3C3F44"
      }
    ],
    "displayName": "MANNARP",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "00635964",
        "name": "wood-brown"
      },
      {
        "itemNo": "30624054",
        "name": "metal-black"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "40611621",
          "60611597",
          "30624054"
        ],
        "code": "72493",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09604034",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "00611425",
          "60611601",
          "30624054"
        ],
        "code": "72498",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09604086",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40611621",
          "90611609",
          "00635964"
        ],
        "code": "72493",
        "cover": "saxemara-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09619163",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "70611605",
          "10611613",
          "30624054"
        ],
        "code": "72570",
        "cover": "saxemara-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19604062",
        "rangeId": "mannarp",
        "widthInMillimeters": 2290,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "00611425",
          "00635964"
        ],
        "code": "72492",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19619148",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "00611425",
          "60611601",
          "30624054"
        ],
        "code": "72570",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29604066",
        "rangeId": "mannarp",
        "widthInMillimeters": 2290,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "50611324",
          "60611333",
          "30624054"
        ],
        "code": "72498",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29604090",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40611621",
          "60611597",
          "00635964"
        ],
        "code": "72493",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29619157",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "50611625",
          "40611621",
          "10611613",
          "90611609",
          "00635964"
        ],
        "code": "72572",
        "cover": "saxemara-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29619181",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "00611425",
          "60611601",
          "00635964"
        ],
        "code": "72570",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39619166",
        "rangeId": "mannarp",
        "widthInMillimeters": 2290,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "70611605",
          "10611613",
          "00635964"
        ],
        "code": "72498",
        "cover": "saxemara-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39619190",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "40611621",
          "90611609",
          "30624054"
        ],
        "code": "72493",
        "cover": "saxemara-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49604046",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "50611625",
          "60611601",
          "40611621",
          "60611597",
          "30624054"
        ],
        "code": "72572",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49604070",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "70611605",
          "10611613",
          "30624054"
        ],
        "code": "72498",
        "cover": "saxemara-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49604094",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "50611625",
          "60611601",
          "40611621",
          "60611597",
          "00635964"
        ],
        "code": "72572",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49619175",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "50611324",
          "60611333",
          "30624054"
        ],
        "code": "72570",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59598672",
        "rangeId": "mannarp",
        "widthInMillimeters": 2290,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "50611324",
          "00635964"
        ],
        "code": "72492",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59619151",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "50611625",
          "40611621",
          "10611613",
          "90611609",
          "30624054"
        ],
        "code": "72572",
        "cover": "saxemara-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69604074",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40611621",
          "60611328",
          "00635964"
        ],
        "code": "72493",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69619160",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "00611425",
          "60611601",
          "00635964"
        ],
        "code": "72498",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69619184",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611324",
          "30624054"
        ],
        "code": "72492",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79603998",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "70611605",
          "30624054"
        ],
        "code": "72492",
        "cover": "saxemara-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79604002",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "50611625",
          "40611621",
          "60611333",
          "60611328",
          "30624054"
        ],
        "code": "72572",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79604078",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "50611324",
          "60611333",
          "00635964"
        ],
        "code": "72570",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79619169",
        "rangeId": "mannarp",
        "widthInMillimeters": 2290,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "00611425",
          "30624054"
        ],
        "code": "72492",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89604030",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "50611625",
          "40611621",
          "60611333",
          "60611328",
          "00635964"
        ],
        "code": "72572",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89619178",
        "rangeId": "mannarp",
        "widthInMillimeters": 2690,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "40611621",
          "60611328",
          "30624054"
        ],
        "code": "72493",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99604039",
        "rangeId": "mannarp",
        "widthInMillimeters": 1980,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20611617",
          "70611605",
          "00635964"
        ],
        "code": "72492",
        "cover": "saxemara-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99619154",
        "rangeId": "mannarp",
        "widthInMillimeters": 1580,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20611617",
          "50611625",
          "50611324",
          "60611333",
          "00635964"
        ],
        "code": "72498",
        "cover": "saxemara-black-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99619187",
        "rangeId": "mannarp",
        "widthInMillimeters": 3000,
        "legs": "wood-brown"
      }
    ]
  },
  "morabo": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "gunnared-light-green",
        "dotOverride": "#C0C5B8"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "grann-bomstad-grey-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "grann-bomstad-golden-brown",
        "dotOverride": "#AB7150"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-blue",
        "dotOverride": "#293046"
      }
    ],
    "displayName": "MORABO",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "20456348",
        "name": "wood"
      },
      {
        "itemNo": "80456345",
        "name": "metal"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00513712",
        "rangeId": "morabo",
        "widthInMillimeters": 2250
      },
      {
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "70513723",
        "rangeId": "morabo",
        "widthInMillimeters": 2250
      },
      {
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "80513713",
        "rangeId": "morabo",
        "widthInMillimeters": 2250
      },
      {
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "90513722",
        "rangeId": "morabo",
        "widthInMillimeters": 2250
      },
      {
        "childItems": [
          "50456337",
          "80456345"
        ],
        "code": "48327",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09316670",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "90456340",
          "80456345"
        ],
        "code": "48327",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09317858",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "50456342",
          "80456345"
        ],
        "code": "48327",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09318320",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "30456343",
          "20456348"
        ],
        "code": "48327",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09318339",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "80456345"
        ],
        "code": "55845",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09442386",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70456336",
          "10455311",
          "20456348"
        ],
        "code": "64094",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09554326",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "70455327",
          "20455320",
          "20456348"
        ],
        "code": "66193",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09575866",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "70455332",
          "10455325",
          "80456345"
        ],
        "code": "66193",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09575871",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70456336",
          "10455311",
          "80456345"
        ],
        "code": "66194",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09575885",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "10455330",
          "80456345"
        ],
        "code": "48321",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19317848",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70455332",
          "80456345"
        ],
        "code": "48321",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19318310",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "50455333",
          "20456348"
        ],
        "code": "48321",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19318329",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "80505497",
          "20456348"
        ],
        "code": "48327",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19416508",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "40455324",
          "10456339",
          "80456345"
        ],
        "code": "55845",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19442395",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "90513722",
          "80456345"
        ],
        "code": "62493",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19491319",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "metal"
      },
      {
        "childItems": [
          "90513722",
          "20456348"
        ],
        "code": "62493",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19491324",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "wood"
      },
      {
        "childItems": [
          "40456333",
          "80455322",
          "80456345"
        ],
        "code": "64094",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19554316",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "70505488",
          "80456345"
        ],
        "code": "66194",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19575875",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "60456332",
          "40455324",
          "20456348"
        ],
        "code": "66194",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19575880",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "30456343",
          "10455311",
          "80456345"
        ],
        "code": "66195",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19575899",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "00456330",
          "80456345"
        ],
        "code": "48326",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29316612",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "10456339",
          "20456348"
        ],
        "code": "48327",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29317758",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "40456333",
          "20456348"
        ],
        "code": "48326",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29317857",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "90456335",
          "20456348"
        ],
        "code": "48326",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29318319",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "30456343",
          "80456345"
        ],
        "code": "48327",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29318338",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "80455322",
          "90456340",
          "80456345"
        ],
        "code": "55845",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29442385",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70505488",
          "80505459",
          "20456348"
        ],
        "code": "64094",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29554306",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "80456345",
          "20455320",
          "00456330"
        ],
        "code": "64094",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29554311",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "70456336",
          "10455311",
          "80456345"
        ],
        "code": "64094",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29554325",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "70455327",
          "20455320",
          "80456345"
        ],
        "code": "66193",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29575865",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "10455330",
          "80455322",
          "20456348"
        ],
        "code": "66193",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29575870",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "10456339",
          "40455324",
          "20456348"
        ],
        "code": "66195",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29575894",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "50455333",
          "80456345"
        ],
        "code": "48321",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39318328",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "80505497",
          "80456345"
        ],
        "code": "48327",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39416507",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "20456348"
        ],
        "code": "66195",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39416512",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "10455325",
          "50456342",
          "80456345"
        ],
        "code": "55845",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39442380",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70513723",
          "20456348"
        ],
        "code": "62493",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39491323",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "wood"
      },
      {
        "childItems": [
          "60456332",
          "40455324",
          "20456348"
        ],
        "code": "64094",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39554315",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "60456332",
          "40455324",
          "80456345"
        ],
        "code": "66194",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39575879",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "90456335",
          "10455325",
          "20456348"
        ],
        "code": "66194",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39575884",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "50456342",
          "10455325",
          "20456348"
        ],
        "code": "66195",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39575898",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "10456339",
          "80456345"
        ],
        "code": "48327",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49317757",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "metal"
      },
      {
        "childItems": [
          "40456333",
          "80456345"
        ],
        "code": "48326",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49317856",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "90456335",
          "80456345"
        ],
        "code": "48326",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49318318",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "70456336",
          "20456348"
        ],
        "code": "48326",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49318337",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "10455311",
          "30456343",
          "80456345"
        ],
        "code": "55845",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49442389",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "20456348"
        ],
        "code": "55845",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49442394",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "70505488",
          "80505459",
          "80456345"
        ],
        "code": "64094",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49554305",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "20456348",
          "20455320",
          "00456330"
        ],
        "code": "64094",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49554310",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "10455330",
          "80455322",
          "80456345"
        ],
        "code": "66193",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49575869",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "50455333",
          "10455311",
          "20456348"
        ],
        "code": "66193",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49575874",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "20456348"
        ],
        "code": "66195",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49575888",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "10456339",
          "40455324",
          "80456345"
        ],
        "code": "66195",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49575893",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "30455329",
          "20456348"
        ],
        "code": "48321",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59317752",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "70505488",
          "20456348"
        ],
        "code": "48326",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59416506",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "80456345"
        ],
        "code": "66195",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59416511",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "20455320",
          "50456337",
          "20456348"
        ],
        "code": "55845",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59442379",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "00513712",
          "20456348"
        ],
        "code": "62493",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59491322",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "wood"
      },
      {
        "childItems": [
          "90456335",
          "10455325",
          "20456348"
        ],
        "code": "64094",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59554324",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "20456348",
          "00456330",
          "20455320"
        ],
        "code": "66194",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59575878",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "90456335",
          "10455325",
          "80456345"
        ],
        "code": "66194",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59575883",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "50456342",
          "10455325",
          "80456345"
        ],
        "code": "66195",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59575897",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "30456343",
          "10455311",
          "20456348"
        ],
        "code": "66195",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59575901",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "50456337",
          "20456348"
        ],
        "code": "48327",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69316672",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "60456332",
          "20456348"
        ],
        "code": "48326",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69317756",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "70456336",
          "80456345"
        ],
        "code": "48326",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69318336",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "40455324",
          "10456339",
          "20456348"
        ],
        "code": "55845",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69442388",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "80455322",
          "90456340",
          "20456348"
        ],
        "code": "55845",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69442393",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "80513713",
          "80456345"
        ],
        "code": "62493",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69491326",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "metal"
      },
      {
        "childItems": [
          "40455324",
          "60456332",
          "80456345"
        ],
        "code": "64094",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69554314",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "30455329",
          "40455324",
          "20456348"
        ],
        "code": "66193",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69575868",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "50455333",
          "10455311",
          "80456345"
        ],
        "code": "66193",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69575873",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "80505497",
          "80456345"
        ],
        "code": "66195",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69575887",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "20456348",
          "20455320",
          "50456337"
        ],
        "code": "66195",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69575892",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "70455327",
          "20456348"
        ],
        "code": "48321",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79316638",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "30455329",
          "80456345"
        ],
        "code": "48321",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79317751",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70505488",
          "80456345"
        ],
        "code": "48326",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79416505",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "70505488",
          "20456348"
        ],
        "code": "66194",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79416510",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "10455325",
          "50456342",
          "20456348"
        ],
        "code": "55845",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79442383",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "10455311",
          "30456343",
          "20456348"
        ],
        "code": "55845",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79442397",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "80513713",
          "20456348"
        ],
        "code": "62493",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79491321",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "wood"
      },
      {
        "childItems": [
          "90456335",
          "10455325",
          "80456345"
        ],
        "code": "64094",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79554323",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "metal"
      },
      {
        "childItems": [
          "80456345",
          "00456330",
          "20455320"
        ],
        "code": "66194",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79575877",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "40456333",
          "80455322",
          "20456348"
        ],
        "code": "66194",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79575882",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "90456340",
          "80455322",
          "20456348"
        ],
        "code": "66195",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79575896",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "wood"
      },
      {
        "childItems": [
          "00456330",
          "20456348"
        ],
        "code": "48326",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89316633",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "wood"
      },
      {
        "childItems": [
          "60456332",
          "80456345"
        ],
        "code": "48326",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89317755",
        "rangeId": "morabo",
        "widthInMillimeters": 1660,
        "legs": "metal"
      },
      {
        "childItems": [
          "90456340",
          "20456348"
        ],
        "code": "48327",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89317859",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "50456342",
          "20456348"
        ],
        "code": "48327",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89318321",
        "rangeId": "morabo",
        "widthInMillimeters": 2060,
        "legs": "wood"
      },
      {
        "childItems": [
          "00513712",
          "80456345"
        ],
        "code": "62493",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89491325",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "metal"
      },
      {
        "childItems": [
          "30455329",
          "40455324",
          "80456345"
        ],
        "code": "66193",
        "cover": "grann-bomstad-golden-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89575867",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70455332",
          "10455325",
          "20456348"
        ],
        "code": "66193",
        "cover": "gunnared-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89575872",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "70456336",
          "10455311",
          "20456348"
        ],
        "code": "66194",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89575886",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "80456345",
          "20455320",
          "50456337"
        ],
        "code": "66195",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89575891",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      },
      {
        "childItems": [
          "70455327",
          "80456345"
        ],
        "code": "48321",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99316637",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "10455330",
          "20456348"
        ],
        "code": "48321",
        "cover": "grann-bomstad-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99317849",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "70455332",
          "20456348"
        ],
        "code": "48321",
        "cover": "gunnared-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99318311",
        "rangeId": "morabo",
        "legs": "wood"
      },
      {
        "childItems": [
          "50455333",
          "10455311",
          "80456345"
        ],
        "code": "48323",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99318330",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "80505459",
          "70505488",
          "80456345"
        ],
        "code": "66194",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99416509",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "20455320",
          "50456337",
          "80456345"
        ],
        "code": "55845",
        "cover": "grann-bomstad-black",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99442396",
        "rangeId": "morabo",
        "legs": "metal"
      },
      {
        "childItems": [
          "70513723",
          "80456345"
        ],
        "code": "62493",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99491320",
        "rangeId": "morabo",
        "widthInMillimeters": 2250,
        "legs": "metal"
      },
      {
        "childItems": [
          "40456333",
          "80455322",
          "20456348"
        ],
        "code": "64094",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99554317",
        "rangeId": "morabo",
        "widthInMillimeters": 3600,
        "legs": "wood"
      },
      {
        "childItems": [
          "80505459",
          "70505488",
          "20456348"
        ],
        "code": "66194",
        "cover": "djuparp-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99575876",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "wood"
      },
      {
        "childItems": [
          "40456333",
          "80455322",
          "80456345"
        ],
        "code": "66194",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99575881",
        "rangeId": "morabo",
        "widthInMillimeters": 2440,
        "legs": "metal"
      },
      {
        "childItems": [
          "90456340",
          "80455322",
          "80456345"
        ],
        "code": "66195",
        "cover": "grann-bomstad-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99575895",
        "rangeId": "morabo",
        "widthInMillimeters": 2840,
        "legs": "metal"
      }
    ]
  },
  "nyhamn": {
    "coverProducts": [
      {
        "itemNo": "10341598",
        "name": "knisa-grey-beige"
      },
      {
        "itemNo": "20546622",
        "name": "skartofta-black-light-grey"
      },
      {
        "itemNo": "40546621",
        "name": "naggen-beige"
      },
      {
        "itemNo": "40546635",
        "name": "naggen-dark-grey"
      },
      {
        "itemNo": "50547842",
        "name": "skartofta-red-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "knisa-grey-beige",
        "dotOverride": "#8B8883"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00058.jpg",
        "name": "skartofta-black"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "naggen-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "naggen-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "skartofta-red-brown"
      },
      {
        "name": "black"
      },
      {
        "name": "skartofta-black-light-grey",
        "dotOverride": "#828785"
      }
    ],
    "displayName": "NYHAMN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": [
      {
        "itemNo": "20535888",
        "name": "nyhamn-pocket-sprung-mattress"
      },
      {
        "itemNo": "50340163",
        "name": "nyhamn-foam-mattress-firm"
      }
    ],
    "sofas": [
      {
        "childItems": [
          "80455464",
          "70349624",
          "80547845"
        ],
        "code": "39389",
        "cover": "naggen-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19555575",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000
      },
      {
        "childItems": [
          "80455464",
          "50340163",
          "10341598"
        ],
        "code": "39389",
        "cover": "knisa-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39306368",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-foam-mattress-firm"
      },
      {
        "childItems": [
          "80455464",
          "20535888",
          "40546621"
        ],
        "code": "39389",
        "cover": "naggen-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59494617",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-pocket-sprung-mattress"
      },
      {
        "childItems": [
          "80455464",
          "20535888",
          "50547842"
        ],
        "code": "39389",
        "cover": "skartofta-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69494631",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-pocket-sprung-mattress"
      },
      {
        "childItems": [
          "80455464",
          "50340163",
          "40546621"
        ],
        "code": "39389",
        "cover": "naggen-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69499997",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-foam-mattress-firm"
      },
      {
        "childItems": [
          "80455464",
          "50340163",
          "50547842"
        ],
        "code": "39389",
        "cover": "skartofta-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79499992",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-foam-mattress-firm"
      },
      {
        "childItems": [
          "80455464",
          "10341598",
          "20535888"
        ],
        "code": "39388",
        "cover": "knisa-grey-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89306361",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-pocket-sprung-mattress"
      },
      {
        "childItems": [
          "80455464",
          "20535888",
          "20546622"
        ],
        "code": "39389",
        "cover": "skartofta-black-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89494611",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-pocket-sprung-mattress"
      },
      {
        "childItems": [
          "80455464",
          "50340163",
          "40546635"
        ],
        "code": "39389",
        "cover": "naggen-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89499982",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-foam-mattress-firm"
      },
      {
        "childItems": [
          "80455464",
          "20535888",
          "40546635"
        ],
        "code": "39389",
        "cover": "naggen-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99494620",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-pocket-sprung-mattress"
      },
      {
        "childItems": [
          "80455464",
          "50340163",
          "20546622"
        ],
        "code": "39389",
        "cover": "skartofta-black-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99499991",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000,
        "mattress": "nyhamn-foam-mattress-firm"
      },
      {
        "childItems": [
          "80455464",
          "70349624",
          "90546628"
        ],
        "code": "39389",
        "cover": "naggen-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99555576",
        "rangeId": "nyhamn",
        "widthInMillimeters": 2000
      }
    ]
  },
  "nykil": {
    "coverProducts": null,
    "covers": [
      {
        "name": "dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "NYKIL",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "68354",
        "cover": "dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30602194",
        "rangeId": "nykil",
        "widthInMillimeters": 1200
      }
    ]
  },
  "odenslunda": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "vissle-dark-grey"
      }
    ],
    "displayName": "ODENSLUNDA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "cover": "vissle-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "10487581",
        "rangeId": "odenslunda",
        "widthInMillimeters": 2300
      }
    ]
  },
  "ormaryd": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "dark-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00100.jpg",
        "name": "dark-red"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "beige"
      }
    ],
    "displayName": "ORMARYD",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "49009",
        "cover": "grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "00477592",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1340
      },
      {
        "code": "49010",
        "cover": "grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "10477596",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1890
      },
      {
        "code": "49009",
        "cover": "dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "20477591",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1340
      },
      {
        "code": "49010",
        "cover": "dark-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "30477595",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1890
      },
      {
        "code": "49009",
        "cover": "dark-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "40477590",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1340
      },
      {
        "code": "49010",
        "cover": "dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "60477594",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1890
      },
      {
        "code": "49009",
        "cover": "beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "80477593",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1340
      },
      {
        "code": "49010",
        "cover": "beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "90477597",
        "rangeId": "ormaryd",
        "widthInMillimeters": 1890
      }
    ]
  },
  "parup": {
    "coverProducts": [
      {
        "itemNo": "20493770",
        "name": "vissle-grey"
      },
      {
        "itemNo": "20567488",
        "name": "with-chaise-longue-kelinge-grey-turquoise"
      },
      {
        "itemNo": "30493784",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30567478",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "30567483",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "40493788",
        "name": "gunnared-dark-grey"
      },
      {
        "itemNo": "40567473",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "50567972",
        "name": "vissle-yellow-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "vissle-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00116.jpg",
        "name": "kelinge-grey-turquoise",
        "dotOverride": "#54736E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "gunnared-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "vissle-yellow-brown"
      }
    ],
    "displayName": "PÄRUP",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "80493734",
          "40493788"
        ],
        "code": "39474",
        "cover": "gunnared-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39389146",
        "rangeId": "parup",
        "widthInMillimeters": 1660
      },
      {
        "childItems": [
          "80493734",
          "50567972"
        ],
        "code": "39474",
        "cover": "vissle-yellow-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79514191",
        "rangeId": "parup",
        "widthInMillimeters": 1660
      },
      {
        "childItems": [
          "80493734",
          "20493770"
        ],
        "code": "39474",
        "cover": "vissle-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89389139",
        "rangeId": "parup",
        "widthInMillimeters": 1660
      },
      {
        "childItems": [
          "80493734",
          "30493784"
        ],
        "code": "39474",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99389148",
        "rangeId": "parup",
        "widthInMillimeters": 1660
      }
    ]
  },
  "rocksjon": {
    "coverProducts": [
      {
        "itemNo": "30557224",
        "name": "blekinge-white"
      },
      {
        "itemNo": "50557223",
        "name": "klovsta-grey-white"
      },
      {
        "itemNo": "70557222",
        "name": "kilanda-light-beige"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "blekinge-white",
        "dotOverride": "#F5F6FB"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "klovsta-grey-white"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      }
    ],
    "displayName": "ROCKSJÖN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "30557224",
          "00557225"
        ],
        "code": "66035",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19508857",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      },
      {
        "childItems": [
          "50557223",
          "00557225"
        ],
        "code": "66035",
        "cover": "klovsta-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19514698",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      },
      {
        "childItems": [
          "20557229",
          "70557222"
        ],
        "code": "66035",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19575012",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      },
      {
        "childItems": [
          "30557224",
          "20557229"
        ],
        "code": "66035",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39575011",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      },
      {
        "childItems": [
          "00557225",
          "70557222"
        ],
        "code": "66035",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59508860",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      },
      {
        "childItems": [
          "50557223",
          "20557229"
        ],
        "code": "66035",
        "cover": "klovsta-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99575013",
        "rangeId": "rocksjon",
        "widthInMillimeters": 1420
      }
    ]
  },
  "rullerum": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "grann-bomstad-golden-brown",
        "dotOverride": "#AB7150"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "grann-bomstad-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "lekungen-black-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00139.jpg",
        "name": "tornarp-dark-grey-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "lekungen-yellow-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      }
    ],
    "displayName": "RULLERUM",
    "hasRemovableCover": false,
    "hasRecliningBackrest": true,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "65234",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "10594232",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "65234",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10635534",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "65234",
        "cover": "grann-bomstad-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "20594236",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "65234",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40635537",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "39734",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "70594234",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "65234",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "70650060",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "39734",
        "cover": "lekungen-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "80594238",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "code": "39734",
        "cover": "lekungen-yellow-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "90594233",
        "rangeId": "rullerum",
        "widthInMillimeters": 1840
      },
      {
        "childItems": [
          "20594236",
          "00596830"
        ],
        "code": "65236",
        "cover": "grann-bomstad-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09586723",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "20594236",
          "00596830"
        ],
        "code": "65235",
        "cover": "grann-bomstad-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19564546",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "90594233",
          "60594244"
        ],
        "code": "66289",
        "cover": "lekungen-yellow-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19564551",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "20594236",
          "50624312"
        ],
        "code": "65236",
        "cover": "grann-bomstad-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621684",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "70594234",
          "80594243"
        ],
        "code": "65236",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29586722",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "10635534",
          "50635532"
        ],
        "code": "65236",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29619124",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "20594236",
          "50624312"
        ],
        "code": "65235",
        "cover": "grann-bomstad-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39621683",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "90594233",
          "60594244"
        ],
        "code": "65236",
        "cover": "lekungen-yellow-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49586721",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "10635534",
          "50635532"
        ],
        "code": "65235",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49619123",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "10594232",
          "00594237"
        ],
        "code": "65235",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69564544",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "80594238",
          "40594240"
        ],
        "code": "65236",
        "cover": "lekungen-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69586720",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "70650060",
          "90650059"
        ],
        "code": "65236",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "69630110",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "70594234",
          "80594243"
        ],
        "code": "66289",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79564548",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "40635537",
          "80635535"
        ],
        "code": "65235",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79619126",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "10594232",
          "00594237"
        ],
        "code": "65236",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89586719",
        "rangeId": "rullerum",
        "widthInMillimeters": 3340
      },
      {
        "childItems": [
          "90650059",
          "70650060"
        ],
        "code": "65235",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "itemNo": "89630109",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "80594238",
          "40594240"
        ],
        "code": "66289",
        "cover": "lekungen-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99564811",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      },
      {
        "childItems": [
          "40635537",
          "80635535"
        ],
        "code": "65236",
        "cover": "tornarp-dark-grey-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": true,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99619125",
        "rangeId": "rullerum",
        "widthInMillimeters": 2590
      }
    ]
  },
  "saleboda": {
    "coverProducts": null,
    "covers": [],
    "displayName": "SALEBODA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "salstad": {
    "coverProducts": null,
    "covers": [
      {
        "name": "knisa-light-grey"
      }
    ],
    "displayName": "SALSTAD",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "63728",
        "cover": "knisa-light-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00574946",
        "rangeId": "salstad"
      }
    ]
  },
  "saltmyran": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "oreryd-grey-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "oreryd-blue",
        "dotOverride": "#606C76"
      }
    ],
    "displayName": "SALTMYRAN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "73132",
        "cover": "oreryd-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10596995",
        "rangeId": "saltmyran",
        "widthInMillimeters": 1470
      },
      {
        "code": "73131",
        "cover": "oreryd-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30618519",
        "rangeId": "saltmyran",
        "widthInMillimeters": 1870
      },
      {
        "code": "73131",
        "cover": "oreryd-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40618514",
        "rangeId": "saltmyran",
        "widthInMillimeters": 1870
      },
      {
        "code": "73132",
        "cover": "oreryd-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40618533",
        "rangeId": "saltmyran",
        "widthInMillimeters": 1470
      }
    ]
  },
  "saltsjobaden": {
    "coverProducts": [
      {
        "itemNo": "00616970",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "00617106",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00617111",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00617125",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00618337",
        "name": "gunnared-light-green"
      },
      {
        "itemNo": "00618342",
        "name": "gunnared-light-green"
      },
      {
        "itemNo": "00637699",
        "name": "vittangi-light-beige-white"
      },
      {
        "itemNo": "10607588",
        "name": "blekinge-white"
      },
      {
        "itemNo": "10607625",
        "name": "blekinge-white"
      },
      {
        "itemNo": "10607649",
        "name": "blekinge-white"
      },
      {
        "itemNo": "10617016",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "10617177",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10618346",
        "name": "gunnared-light-green"
      },
      {
        "itemNo": "20607597",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "20607601",
        "name": "blekinge-white"
      },
      {
        "itemNo": "20617011",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "20617049",
        "name": "fridtuna-yellow"
      },
      {
        "itemNo": "20617054",
        "name": "fridtuna-yellow"
      },
      {
        "itemNo": "20617129",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "20617172",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20637679",
        "name": "vittangi-light-beige-white"
      },
      {
        "itemNo": "30607592",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "30607605",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "30607629",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "30617020",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "30617044",
        "name": "fridtuna-yellow"
      },
      {
        "itemNo": "40637678",
        "name": "vittangi-light-beige-white"
      },
      {
        "itemNo": "50607609",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "50607633",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "50607652",
        "name": "blekinge-white"
      },
      {
        "itemNo": "50616958",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "50616982",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "50617062",
        "name": "fridtuna-yellow"
      },
      {
        "itemNo": "50618354",
        "name": "gunnared-light-green"
      },
      {
        "itemNo": "60607637",
        "name": "blekinge-white"
      },
      {
        "itemNo": "60607656",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "60616972",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "60616986",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "60617028",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "60617066",
        "name": "fridtuna-yellow"
      },
      {
        "itemNo": "60618358",
        "name": "gunnared-light-green"
      },
      {
        "itemNo": "60637677",
        "name": "vittangi-light-beige-white"
      },
      {
        "itemNo": "70607651",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "70617117",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "70617155",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "70617160",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "80607641",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "80607660",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "80617032",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "80617517",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "90607645",
        "name": "tonerud-red-brown"
      },
      {
        "itemNo": "90607650",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "90617164",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "90637671",
        "name": "vittangi-light-beige-white"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00193.jpg",
        "name": "tonerud-red-brown",
        "dotOverride": "#D37043"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "fridtuna-light-beige",
        "dotOverride": "#D6D4C5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "gunnared-light-green",
        "dotOverride": "#C0C5B8"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00180.jpg",
        "name": "vittangi-light-beige-white"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "blekinge-white",
        "dotOverride": "#F5F6FB"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "fridtuna-dark-grey-blue",
        "dotOverride": "#6C8692"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00067.jpg",
        "name": "fridtuna-yellow"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tonerud-grey",
        "dotOverride": "#95959A"
      }
    ],
    "displayName": "SALTSJÖBADEN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "00635964",
        "name": "wood-brown"
      },
      {
        "itemNo": "30624054",
        "name": "metal-black"
      },
      {
        "itemNo": "60623703",
        "name": "birch"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40607469",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2600
      },
      {
        "cover": "",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40607488",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60607487",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "50607652",
          "60623703"
        ],
        "code": "72501",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09578558",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "20607597"
        ],
        "code": "72739",
        "cover": "tonerud-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09578596",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "30607629",
          "60623703"
        ],
        "code": "72502",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09579181",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "00607621"
        ],
        "code": "73565",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09579223",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "30618350"
        ],
        "code": "73565",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09602695",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "60616986"
        ],
        "code": "72739",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09602704",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "10617177"
        ],
        "code": "72739",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09602737",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "60637677",
          "60623703"
        ],
        "code": "72502",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621420",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "10618346",
          "30624054"
        ],
        "code": "72502",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622523",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "80607660",
          "40607469",
          "00635964"
        ],
        "code": "72501",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627455",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "10618346",
          "00635964"
        ],
        "code": "72502",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627479",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "60607637",
          "00635964"
        ],
        "code": "72499",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627498",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "60616972",
          "00635964"
        ],
        "code": "72499",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627506",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "90607645",
          "00635964"
        ],
        "code": "72499",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627530",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "50617062",
          "00635964"
        ],
        "code": "72503",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09627554",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "50607633",
          "60623703"
        ],
        "code": "72502",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19579185",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "90617164",
          "60623703"
        ],
        "code": "72502",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19599923",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "00617168"
        ],
        "code": "73565",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19602690",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "50616958",
          "30624054"
        ],
        "code": "72501",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622481",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "90617164",
          "30624054"
        ],
        "code": "72502",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622527",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "20617049",
          "30624054"
        ],
        "code": "72499",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622551",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "30607605",
          "30624054"
        ],
        "code": "72503",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622612",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "60607487",
          "00616970",
          "00624055"
        ],
        "code": "72980",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622631",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "20607465",
          "20637679",
          "30624054"
        ],
        "code": "72503",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622768",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "50607652",
          "00635964"
        ],
        "code": "72501",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19627431",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "00617125",
          "00635964"
        ],
        "code": "72503",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19627558",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "70607651",
          "30635967"
        ],
        "code": "72980",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19627577",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "20617011",
          "60623703"
        ],
        "code": "72501",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29599753",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "30617020",
          "60623703"
        ],
        "code": "72502",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29599913",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "10618346",
          "60623703"
        ],
        "code": "72502",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29599927",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "60616972",
          "60623703"
        ],
        "code": "72499",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29599932",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "60607487",
          "00616970",
          "40623704"
        ],
        "code": "72980",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29602166",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "20607559",
          "80617032"
        ],
        "code": "72739",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29602717",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "60618358"
        ],
        "code": "72739",
        "cover": "gunnared-light-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29602741",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "00618337",
          "30624054"
        ],
        "code": "72501",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622490",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "10607625",
          "30624054"
        ],
        "code": "72502",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622503",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "70617160",
          "30624054"
        ],
        "code": "72499",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622560",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "60617028",
          "30624054"
        ],
        "code": "72503",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622584",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "50607609",
          "30624054"
        ],
        "code": "72503",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622616",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "60607487",
          "00637699",
          "00624055"
        ],
        "code": "72980",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622758",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "30617044",
          "00635964"
        ],
        "code": "72501",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29627440",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "10607625",
          "00635964"
        ],
        "code": "72502",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29627459",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "90617164",
          "00635964"
        ],
        "code": "72502",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29627483",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "20617049",
          "00635964"
        ],
        "code": "72499",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29627510",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "60617028",
          "00635964"
        ],
        "code": "72503",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29627534",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "10607649",
          "40623704"
        ],
        "code": "72980",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39578547",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "60607656",
          "60623703"
        ],
        "code": "72501",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39578552",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "60607637",
          "60623703"
        ],
        "code": "72499",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39579189",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "70617155",
          "60623703"
        ],
        "code": "72501",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39599899",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "80617517",
          "60623703"
        ],
        "code": "72502",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39599903",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "70617117",
          "60623703"
        ],
        "code": "72502",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39599917",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "10617016",
          "60623703"
        ],
        "code": "72499",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39599936",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "20617049",
          "60623703"
        ],
        "code": "72499",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39599941",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "50616982",
          "60623703"
        ],
        "code": "72503",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39602142",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "50607652",
          "30624054"
        ],
        "code": "72501",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622475",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "30617020",
          "30624054"
        ],
        "code": "72502",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622507",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "30607629",
          "30624054"
        ],
        "code": "72502",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622531",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "10617016",
          "30624054"
        ],
        "code": "72499",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622545",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "60607637",
          "30624054"
        ],
        "code": "72499",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622569",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "50618354",
          "30624054"
        ],
        "code": "72503",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622588",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "60607487",
          "10607649",
          "00624055"
        ],
        "code": "72980",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622630",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "70617155",
          "00635964"
        ],
        "code": "72501",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39627449",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "30607629",
          "00635964"
        ],
        "code": "72502",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39627487",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "50618354",
          "00635964"
        ],
        "code": "72503",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39627538",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "30607605",
          "00635964"
        ],
        "code": "72503",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39627562",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2230,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "90607650",
          "30635967"
        ],
        "code": "72980",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39627576",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "10607461",
          "40637678",
          "00635964"
        ],
        "code": "72499",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39627661",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "20617054",
          "60623703"
        ],
        "code": "72502",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49599907",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "00617111",
          "60623703"
        ],
        "code": "72499",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49599945",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "50617062",
          "60623703"
        ],
        "code": "72503",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49602146",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "20617172",
          "60623703"
        ],
        "code": "72503",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49602165",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "60617066"
        ],
        "code": "72739",
        "cover": "fridtuna-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49602721",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "40637678",
          "60623703"
        ],
        "code": "72499",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621423",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "70617155",
          "30624054"
        ],
        "code": "72501",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622494",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "50607633",
          "30624054"
        ],
        "code": "72502",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622535",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "00618342",
          "30624054"
        ],
        "code": "72499",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622559",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "60637677",
          "30624054"
        ],
        "code": "72502",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622762",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "30617020",
          "00635964"
        ],
        "code": "72502",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49627463",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "00617111",
          "00635964"
        ],
        "code": "72499",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49627514",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "50607609",
          "00635964"
        ],
        "code": "72503",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49627566",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2230,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "70607651",
          "40623704"
        ],
        "code": "72980",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59578546",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "20607559",
          "10607588"
        ],
        "code": "72739",
        "cover": "blekinge-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59578589",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "80607641",
          "60623703"
        ],
        "code": "72499",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59579193",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "90637671",
          "60623703"
        ],
        "code": "72501",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59621413",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "30617044",
          "30624054"
        ],
        "code": "72501",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622484",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "80617517",
          "30624054"
        ],
        "code": "72502",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622511",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "00617111",
          "30624054"
        ],
        "code": "72499",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622554",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "20617172",
          "30624054"
        ],
        "code": "72503",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622592",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "20617011",
          "00635964"
        ],
        "code": "72501",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59627434",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "80617517",
          "00635964"
        ],
        "code": "72502",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59627467",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "50607633",
          "00635964"
        ],
        "code": "72502",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59627491",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "00618342",
          "00635964"
        ],
        "code": "72499",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59627518",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "20617172",
          "00635964"
        ],
        "code": "72503",
        "cover": "gunnared-medium-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59627542",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "00616970",
          "30635967"
        ],
        "code": "72980",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59627575",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "10607461",
          "90607645",
          "60623703"
        ],
        "code": "72499",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69579197",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "20607601",
          "60623703"
        ],
        "code": "72503",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69579201",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "30616978"
        ],
        "code": "73565",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599096",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "50616958",
          "60623703"
        ],
        "code": "72501",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599647",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "30617044",
          "60623703"
        ],
        "code": "72501",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599690",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "00617106",
          "60623703"
        ],
        "code": "72501",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599888",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "00618337",
          "60623703"
        ],
        "code": "72501",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599893",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "00618342",
          "60623703"
        ],
        "code": "72499",
        "cover": "gunnared-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599949",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "70617160",
          "60623703"
        ],
        "code": "72499",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69599954",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "60617028",
          "60623703"
        ],
        "code": "72503",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69602150",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "50617024"
        ],
        "code": "73565",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69602664",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607456",
          "20617054",
          "30624054"
        ],
        "code": "72502",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622515",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "80607641",
          "30624054"
        ],
        "code": "72499",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622563",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "20607601",
          "30624054"
        ],
        "code": "72503",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622596",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "50616982",
          "30624054"
        ],
        "code": "72503",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622600",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "90637671",
          "30624054"
        ],
        "code": "72501",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622756",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "00617106",
          "00635964"
        ],
        "code": "72501",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69627443",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "20607601",
          "00635964"
        ],
        "code": "72503",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69627546",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2230,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "90607650",
          "40623704"
        ],
        "code": "72980",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79578545",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "20607559",
          "30607592"
        ],
        "code": "72739",
        "cover": "tonerud-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79578593",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "30607605",
          "60623703"
        ],
        "code": "72503",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79579205",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607559",
          "20617129"
        ],
        "code": "72739",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79602729",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1850,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "20637679",
          "60623703"
        ],
        "code": "72503",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79621426",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607469",
          "20617011",
          "30624054"
        ],
        "code": "72501",
        "cover": "fridtuna-dark-grey-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622478",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "60607656",
          "30624054"
        ],
        "code": "72501",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622497",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607461",
          "60616972",
          "30624054"
        ],
        "code": "72499",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622548",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "60607487",
          "70607651",
          "00624055"
        ],
        "code": "72980",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622633",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "10607461",
          "40637678",
          "30624054"
        ],
        "code": "72499",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622765",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "60607656",
          "00635964"
        ],
        "code": "72501",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79627452",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "20617054",
          "00635964"
        ],
        "code": "72502",
        "cover": "fridtuna-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79627471",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "70617160",
          "00635964"
        ],
        "code": "72499",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79627522",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "20637679",
          "00635964"
        ],
        "code": "72503",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79627664",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "10607625",
          "60623703"
        ],
        "code": "72502",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89579177",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "80607617"
        ],
        "code": "73565",
        "cover": "tonerud-grey",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89579219",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "00617125",
          "60623703"
        ],
        "code": "72503",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89602154",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "30617058"
        ],
        "code": "73565",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89602682",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "60607487",
          "00637699",
          "40623704"
        ],
        "code": "72980",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621416",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "00617106",
          "30624054"
        ],
        "code": "72501",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622487",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "80607660",
          "40607469",
          "30624054"
        ],
        "code": "72501",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622500",
        "rangeId": "saltsjobaden",
        "legs": "metal-black"
      },
      {
        "childItems": [
          "10607456",
          "70617117",
          "30624054"
        ],
        "code": "72502",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622519",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "50617062",
          "30624054"
        ],
        "code": "72503",
        "cover": "fridtuna-yellow",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622604",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "40607469",
          "50616958",
          "00635964"
        ],
        "code": "72501",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627437",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "70617117",
          "00635964"
        ],
        "code": "72502",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89627475",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "80607641",
          "00635964"
        ],
        "code": "72499",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627526",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "20607465",
          "50616982",
          "00635964"
        ],
        "code": "72503",
        "cover": "fridtuna-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627550",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2230,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "10607649",
          "30635967"
        ],
        "code": "72980",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627574",
        "rangeId": "saltsjobaden"
      },
      {
        "childItems": [
          "40607469",
          "90637671",
          "00635964"
        ],
        "code": "72501",
        "cover": "vittangi-light-beige-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627649",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "60607487",
          "00637699",
          "30635967"
        ],
        "code": "72980",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89627654",
        "rangeId": "saltsjobaden"
      },
      {
        "childItems": [
          "80607660",
          "40607469",
          "60623703"
        ],
        "code": "72501",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99578549",
        "rangeId": "saltsjobaden",
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "50607609",
          "60623703"
        ],
        "code": "72503",
        "cover": "tonerud-red-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99579209",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "70607613"
        ],
        "code": "73565",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99579214",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "20607465",
          "50618354",
          "60623703"
        ],
        "code": "72503",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99602158",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "birch"
      },
      {
        "childItems": [
          "40607488",
          "90617121"
        ],
        "code": "73565",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99602686",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2340,
        "legs": "birch"
      },
      {
        "childItems": [
          "10607461",
          "90607645",
          "30624054"
        ],
        "code": "72499",
        "cover": "tonerud-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622566",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "20607465",
          "00617125",
          "30624054"
        ],
        "code": "72503",
        "cover": "gunnared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622608",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2330,
        "legs": "metal-black"
      },
      {
        "childItems": [
          "60607487",
          "90607650",
          "00624055"
        ],
        "code": "72980",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622632",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1440
      },
      {
        "childItems": [
          "40607469",
          "00618337",
          "00635964"
        ],
        "code": "72501",
        "cover": "gunnared-light-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99627446",
        "rangeId": "saltsjobaden",
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607461",
          "10617016",
          "00635964"
        ],
        "code": "72499",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99627502",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 2050,
        "legs": "wood-brown"
      },
      {
        "childItems": [
          "10607456",
          "60637677",
          "00635964"
        ],
        "code": "72502",
        "cover": "vittangi-light-beige-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99627658",
        "rangeId": "saltsjobaden",
        "widthInMillimeters": 1640,
        "legs": "wood-brown"
      }
    ]
  },
  "skonaback": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00179.jpg",
        "name": "vissle-yellow-green",
        "dotOverride": "#A39F74"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "knisa-dark-grey",
        "dotOverride": "#444444"
      }
    ],
    "displayName": "SKÖNABÄCK",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "66937",
        "cover": "vissle-yellow-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "60582547",
        "rangeId": "skonaback",
        "widthInMillimeters": 1580
      },
      {
        "code": "66937",
        "cover": "knisa-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "70582542",
        "rangeId": "skonaback",
        "widthInMillimeters": 1580
      }
    ]
  },
  "slatorp": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "hakebo-yellow-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00179.jpg",
        "name": "vissle-yellow-green",
        "dotOverride": "#A39F74"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      }
    ],
    "displayName": "SLATORP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "69103",
        "cover": "hakebo-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "10594388",
        "rangeId": "slatorp",
        "widthInMillimeters": 2460
      },
      {
        "code": "69104",
        "cover": "vissle-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20594364",
        "rangeId": "slatorp",
        "widthInMillimeters": 1760
      },
      {
        "code": "69103",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "20594383",
        "rangeId": "slatorp",
        "widthInMillimeters": 2460
      },
      {
        "code": "69104",
        "cover": "hakebo-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30594392",
        "rangeId": "slatorp",
        "widthInMillimeters": 1760
      },
      {
        "code": "69104",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40594377",
        "rangeId": "slatorp",
        "widthInMillimeters": 1760
      },
      {
        "code": "69103",
        "cover": "vissle-yellow-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "50594367",
        "rangeId": "slatorp",
        "widthInMillimeters": 2460
      },
      {
        "childItems": [
          "10594388",
          "40594396"
        ],
        "code": "69102",
        "cover": "hakebo-yellow-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09577610",
        "rangeId": "slatorp",
        "widthInMillimeters": 3260
      },
      {
        "childItems": [
          "20594359",
          "20594364"
        ],
        "code": "69101",
        "cover": "vissle-yellow-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19577596",
        "rangeId": "slatorp",
        "widthInMillimeters": 2560
      },
      {
        "childItems": [
          "30594373",
          "40594377"
        ],
        "code": "69101",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89577574",
        "rangeId": "slatorp",
        "widthInMillimeters": 2560
      },
      {
        "childItems": [
          "50594367",
          "20594359"
        ],
        "code": "69102",
        "cover": "vissle-yellow-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89577611",
        "rangeId": "slatorp",
        "widthInMillimeters": 3260
      },
      {
        "childItems": [
          "40594396",
          "30594392"
        ],
        "code": "69101",
        "cover": "hakebo-yellow-brown",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99577578",
        "rangeId": "slatorp",
        "widthInMillimeters": 2560
      },
      {
        "childItems": [
          "20594383",
          "30594373"
        ],
        "code": "69102",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99577601",
        "rangeId": "slatorp",
        "widthInMillimeters": 3260
      }
    ]
  },
  "smedsbyn": {
    "coverProducts": null,
    "covers": [],
    "displayName": "SMEDSBYN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "smedstorp": {
    "coverProducts": null,
    "covers": [
      {
        "name": "lejde-red-brown",
        "dotOverride": "#822C33"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "djuparp-dark-grey",
        "dotOverride": "#565656"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-green-blue",
        "dotOverride": "#063754"
      }
    ],
    "displayName": "SMEDSTORP",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "40500369",
        "name": "oak-natural"
      },
      {
        "itemNo": "60500368",
        "name": "black"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "40500086",
          "40500369"
        ],
        "code": "56751",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09418598",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "20500087",
          "40500369"
        ],
        "code": "56752",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09418602",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "30500082",
          "40500086",
          "40500369"
        ],
        "code": "56753",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19418593",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "10500083",
          "40500369"
        ],
        "code": "56751",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19418606",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "10500083",
          "60500368"
        ],
        "code": "56751",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19418611",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "black"
      },
      {
        "childItems": [
          "50500081",
          "80500089",
          "60500368"
        ],
        "code": "57893",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19478332",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "black"
      },
      {
        "childItems": [
          "70500080",
          "90500084",
          "40500369"
        ],
        "code": "56753",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29418597",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "90500084",
          "60500368"
        ],
        "code": "56751",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29418601",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "black"
      },
      {
        "childItems": [
          "70500080",
          "00500088",
          "40500369"
        ],
        "code": "57893",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29478341",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "70500080",
          "90500084",
          "60500368"
        ],
        "code": "56753",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39418592",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "black"
      },
      {
        "childItems": [
          "40500086",
          "60500368"
        ],
        "code": "56751",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39418605",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "black"
      },
      {
        "childItems": [
          "60500085",
          "60500368"
        ],
        "code": "56751",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39418610",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "black"
      },
      {
        "childItems": [
          "50500081",
          "60500085",
          "40500369"
        ],
        "code": "56753",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49418596",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "60500085",
          "40500369"
        ],
        "code": "56751",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49418600",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "30500082",
          "60500090",
          "40500369"
        ],
        "code": "57893",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49478335",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "90500079",
          "10500083",
          "40500369"
        ],
        "code": "56753",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59418591",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "20500087",
          "60500368"
        ],
        "code": "56752",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59418609",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "black"
      },
      {
        "childItems": [
          "30500082",
          "60500090",
          "60500368"
        ],
        "code": "57893",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59478330",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "black"
      },
      {
        "childItems": [
          "30500082",
          "40500086",
          "60500368"
        ],
        "code": "56753",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69418595",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "black"
      },
      {
        "childItems": [
          "00500088",
          "40500369"
        ],
        "code": "56752",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69418604",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "90500079",
          "20500087",
          "60500368"
        ],
        "code": "57893",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69478344",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "black"
      },
      {
        "childItems": [
          "50500081",
          "60500085",
          "60500368"
        ],
        "code": "56753",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79418590",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "black"
      },
      {
        "childItems": [
          "00500088",
          "60500368"
        ],
        "code": "56752",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79418608",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "black"
      },
      {
        "childItems": [
          "60500090",
          "40500369"
        ],
        "code": "56752",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79418613",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "50500081",
          "80500089",
          "40500369"
        ],
        "code": "57893",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79478334",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "60500090",
          "60500368"
        ],
        "code": "56752",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89418599",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "black"
      },
      {
        "childItems": [
          "80500089",
          "40500369"
        ],
        "code": "56752",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89418603",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "70500080",
          "00500088",
          "60500368"
        ],
        "code": "57893",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89478338",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "black"
      },
      {
        "childItems": [
          "90500079",
          "10500083",
          "60500368"
        ],
        "code": "56753",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99418594",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2460,
        "legs": "black"
      },
      {
        "childItems": [
          "80500089",
          "60500368"
        ],
        "code": "56752",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99418607",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2050,
        "legs": "black"
      },
      {
        "childItems": [
          "90500084",
          "40500369"
        ],
        "code": "56751",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99418612",
        "rangeId": "smedstorp",
        "widthInMillimeters": 1650,
        "legs": "oak-natural"
      },
      {
        "childItems": [
          "90500079",
          "20500087",
          "40500369"
        ],
        "code": "57893",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99478347",
        "rangeId": "smedstorp",
        "widthInMillimeters": 2860,
        "legs": "oak-natural"
      }
    ]
  },
  "soderhamn": {
    "coverProducts": [
      {
        "itemNo": "00517507",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517526",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "00517531",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517550",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00567347",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "00574480",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00629369",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "00629388",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "00629393",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "00629406",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "00629411",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "00629425",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "00629430",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "10463467",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517502",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517516",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517535",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517540",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "10518993",
        "name": "fridtuna-dark-grey"
      },
      {
        "itemNo": "10519073",
        "name": "gransel-natural"
      },
      {
        "itemNo": "10519110",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "10558601",
        "name": "blekinge-white"
      },
      {
        "itemNo": "10567323",
        "name": "tonerud-red"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10620924",
        "name": "knaback-anthracite"
      },
      {
        "itemNo": "10629359",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "10629364",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "10629383",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "10629397",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "10629401",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "10629420",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "10629439",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517506",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517525",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517530",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517549",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "20517554",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "20519058",
        "name": "gransel-natural"
      },
      {
        "itemNo": "20558605",
        "name": "blekinge-white"
      },
      {
        "itemNo": "20567327",
        "name": "tonerud-red"
      },
      {
        "itemNo": "20574479",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "20574484",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "20620914",
        "name": "vissle-dark-green"
      },
      {
        "itemNo": "20629368",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "20629387",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "20629392",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "20629405",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "20629410",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "20629434",
        "name": "alhamn-deep-orange-red"
      },
      {
        "itemNo": "20630263",
        "name": "gransel-natural"
      },
      {
        "itemNo": "30454481",
        "name": "viarp-beige-brown"
      },
      {
        "itemNo": "30463471",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517501",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517515",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "30517520",
        "name": "tallmyra-white-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30553513",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "30558600",
        "name": "blekinge-white"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30567355",
        "name": "kelinge-grey-turquoise"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30567402",
        "name": "kelinge-rust"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30567416",
        "name": "kelinge-rust"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30620918",
        "name": "knaback-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30620923",
        "name": "knaback-anthracite"
      },
      {
        "itemNo": "30629363",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "30629382",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "30629396",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "30629419",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "30629424",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "30629438",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "30629443",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "30630267",
        "name": "gransel-natural"
      },
      {
        "itemNo": "40454485",
        "name": "viarp-beige-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517505",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517529",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517534",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517548",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517553",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "40519000",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "40519062",
        "name": "gransel-natural"
      },
      {
        "itemNo": "40567331",
        "name": "tonerud-red"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40567406",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "40574478",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "40574483",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "40614323",
        "name": "gransel-natural"
      },
      {
        "itemNo": "40620913",
        "name": "vissle-dark-green"
      },
      {
        "itemNo": "40629367",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "40629372",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "40629386",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "40629391",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "40629414",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "40629428",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "40629433",
        "name": "alhamn-deep-orange-red"
      },
      {
        "itemNo": "40630262",
        "name": "gransel-natural"
      },
      {
        "itemNo": "40650269",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "50463470",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517500",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517519",
        "name": "tallmyra-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517524",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517538",
        "name": "tallmyra-dark-green"
      },
      {
        "itemNo": "50519014",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "50519028",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "50519066",
        "name": "gransel-natural"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50553507",
        "name": "djuparp-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50553606",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "50574487",
        "name": "gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50620922",
        "name": "knaback-anthracite"
      },
      {
        "itemNo": "50629362",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "50629381",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "50629395",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "50629404",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "50629418",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "50629423",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "50629437",
        "name": "alhamn-deep-orange-red"
      },
      {
        "itemNo": "50629442",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "50630271",
        "name": "gransel-natural"
      },
      {
        "itemNo": "60454489",
        "name": "viarp-beige-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517496",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517514",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517528",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517552",
        "name": "tallmyra-light-green"
      },
      {
        "itemNo": "60518981",
        "name": "fridtuna-dark-grey"
      },
      {
        "itemNo": "60519004",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "60519023",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "60519117",
        "name": "fridtuna-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60567410",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "60574482",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "60620912",
        "name": "vissle-dark-green"
      },
      {
        "itemNo": "60629366",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "60629371",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "60629385",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "60629390",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "60629408",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "60629413",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "60629427",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "60629432",
        "name": "alhamn-deep-orange-red"
      },
      {
        "itemNo": "60630256",
        "name": "gransel-natural"
      },
      {
        "itemNo": "70463469",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517518",
        "name": "tallmyra-light-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517523",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517537",
        "name": "tallmyra-blue"
      },
      {
        "itemNo": "70517542",
        "name": "tallmyra-white-black"
      },
      {
        "itemNo": "70518985",
        "name": "fridtuna-dark-grey"
      },
      {
        "itemNo": "70519008",
        "name": "fridtuna-light-beige"
      },
      {
        "itemNo": "70519027",
        "name": "tonerud-grey"
      },
      {
        "itemNo": "70519032",
        "name": "tonerud-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70553506",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "70558603",
        "name": "blekinge-white"
      },
      {
        "itemNo": "70567315",
        "name": "tonerud-red"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70567377",
        "name": "kelinge-grey-turquoise"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70567424",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "70574486",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "70620916",
        "name": "vissle-dark-green"
      },
      {
        "itemNo": "70629361",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "70629380",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "70629399",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "70629403",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "70629417",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "70629441",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "80454493",
        "name": "viarp-beige-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517513",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517527",
        "name": "tallmyra-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80567372",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "80574481",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "80629365",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "80629370",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "80629389",
        "name": "kelinge-dark-yellow"
      },
      {
        "itemNo": "80629412",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "80629426",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "80629431",
        "name": "alhamn-deep-orange-red"
      },
      {
        "itemNo": "80629445",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "80630255",
        "name": "gransel-natural"
      },
      {
        "itemNo": "90454497",
        "name": "viarp-beige-brown"
      },
      {
        "itemNo": "90463468",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517503",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517517",
        "name": "tallmyra-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517522",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517536",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517541",
        "name": "tallmyra-medium-grey"
      },
      {
        "itemNo": "90518989",
        "name": "fridtuna-dark-grey"
      },
      {
        "itemNo": "90519130",
        "name": "fridtuna-light-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90553505",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "90558602",
        "name": "blekinge-white"
      },
      {
        "itemNo": "90567319",
        "name": "tonerud-red"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90567343",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "90574485",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "90620915",
        "name": "vissle-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90620920",
        "name": "knaback-anthracite"
      },
      {
        "itemNo": "90629360",
        "name": "fridtuna-dark-grey-blue"
      },
      {
        "itemNo": "90629384",
        "name": "kelinge-dark-blue"
      },
      {
        "itemNo": "90629398",
        "name": "johanneshov-off-white"
      },
      {
        "itemNo": "90629402",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "90629416",
        "name": "johanneshov-dark-green"
      },
      {
        "itemNo": "90629421",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "90629435",
        "name": "alhamn-deep-orange-red"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-white-black",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "hillared-dark-blue",
        "dotOverride": "#3E5564"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "tallmyra-dark-green",
        "dotOverride": "#27392E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00116.jpg",
        "name": "kelinge-grey-turquoise",
        "dotOverride": "#54736E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kelinge-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00101.jpg",
        "name": "kelinge-dark-yellow"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "johanneshov-brown-beige",
        "dotOverride": "#C5B7A2"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "johanneshov-dark-green",
        "dotOverride": "#303F29"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00172.jpg",
        "name": "alhamn-dark-yellow-brown",
        "dotOverride": "#A07756"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "tallmyra-blue",
        "dotOverride": "#305E7E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hillared-beige",
        "dotOverride": "#D4C8B5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00097.jpg",
        "name": "tallmyra-light-green",
        "dotOverride": "#97AEA1"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "fridtuna-dark-grey",
        "dotOverride": "#424242"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gransel-natural",
        "dotOverride": "#EFEADE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tonerud-grey",
        "dotOverride": "#95959A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "blekinge-white",
        "dotOverride": "#F5F6FB"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "tonerud-red",
        "dotOverride": "#C33C41"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "knaback-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "fridtuna-dark-grey-blue",
        "dotOverride": "#6C8692"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "kelinge-dark-blue"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "johanneshov-off-white"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "johanneshov-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "alhamn-dark-grey-blue",
        "dotOverride": "#83A0A4"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "tallmyra-medium-grey",
        "dotOverride": "#61626A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "vissle-dark-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "alhamn-deep-orange-red"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-blue",
        "dotOverride": "#293046"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "kelinge-rust",
        "dotOverride": "#C38167"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "fridtuna-light-beige",
        "dotOverride": "#D6D4C5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      }
    ],
    "displayName": "SÖDERHAMN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70463469",
          "50463470",
          "10463467"
        ],
        "code": "44436",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09305426",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20517525",
          "10517535"
        ],
        "code": "44431",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430562",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "80517513",
          "40517548",
          "60517496"
        ],
        "code": "49339",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430576",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "70517523",
          "90517536",
          "30517501"
        ],
        "code": "63118",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430581",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "10517516",
          "80517527",
          "70517537",
          "10517502"
        ],
        "code": "44432",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430618",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "10517516",
          "10517502",
          "80517527"
        ],
        "code": "22201",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430623",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30517520",
          "20517554",
          "00517507"
        ],
        "code": "49339",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430642",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20517530",
          "90517541"
        ],
        "code": "44435",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09430656",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "10519073",
          "40519062",
          "20519058"
        ],
        "code": "44436",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09442150",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "60519004",
          "70519008"
        ],
        "code": "44434",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09449689",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "60519023",
          "70519027",
          "10519110"
        ],
        "code": "22201",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09452078",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "60519023",
          "70519027"
        ],
        "code": "22126",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09452101",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "50553606",
          "50553507",
          "70553506"
        ],
        "code": "44436",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09496850",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20558605",
          "90558602"
        ],
        "code": "44435",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09501762",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "40567331",
          "70567315"
        ],
        "code": "22126",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09514458",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70567377",
          "00567347"
        ],
        "code": "44435",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09514547",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60574482",
          "70574486"
        ],
        "code": "44431",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09527998",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "20519058",
          "10519073",
          "40614323"
        ],
        "code": "22201",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09598306",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "40519000",
          "40596852",
          "80223884",
          "80595884",
          "60519004",
          "00223864"
        ],
        "code": "73137",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09616268",
        "rangeId": "soderhamn",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "80595884",
          "30630371",
          "00629388",
          "80223884",
          "40629391",
          "00223864"
        ],
        "code": "73137",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09618677",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "70630369",
          "50629381",
          "80223884",
          "90629384",
          "00223864"
        ],
        "code": "73137",
        "cover": "kelinge-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621359",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "50223885",
          "20223882",
          "30630366",
          "10629359",
          "90629360",
          "30629363"
        ],
        "code": "73134",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621401",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "20629387",
          "00629388"
        ],
        "code": "22126",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621627",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "80630255",
          "60630256"
        ],
        "code": "22126",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621646",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70629417",
          "90629421",
          "50629418"
        ],
        "code": "44436",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09621665",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "90629421",
          "10629420"
        ],
        "code": "44434",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09621769",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "80630255",
          "60630256",
          "30630267",
          "00223878"
        ],
        "code": "74090",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622014",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "20629387",
          "00629388",
          "60629390",
          "00223878"
        ],
        "code": "74090",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622033",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "70629417",
          "30629419",
          "10629420",
          "50629418"
        ],
        "code": "44432",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622052",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629438",
          "30629443",
          "10629439"
        ],
        "code": "49339",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622090",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80629370",
          "20629368"
        ],
        "code": "44435",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622108",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "60630256",
          "30630267"
        ],
        "code": "22116",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622212",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "90629384",
          "10629383",
          "50629381"
        ],
        "code": "63118",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09622231",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30629438",
          "10629439",
          "70629441"
        ],
        "code": "22201",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622311",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30629363",
          "10629359",
          "90629360"
        ],
        "code": "22201",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09622325",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30517515",
          "00517526",
          "90517536",
          "30517501"
        ],
        "code": "44432",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430566",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "50517524",
          "40517534"
        ],
        "code": "44435",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430585",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80517527",
          "70517537"
        ],
        "code": "44431",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430613",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30517520",
          "00517507",
          "00517531"
        ],
        "code": "22201",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430627",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "40517553",
          "90517541",
          "20517506"
        ],
        "code": "63118",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430646",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50517519",
          "20517506"
        ],
        "code": "22126",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19430651",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "40519062",
          "50519066"
        ],
        "code": "44434",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19442140",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10519110",
          "70519032"
        ],
        "code": "44431",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19452068",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "60519023",
          "70519027",
          "10519110",
          "70519032"
        ],
        "code": "44432",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19452073",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10519110",
          "70519032"
        ],
        "code": "44435",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19452110",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30553513",
          "90553505"
        ],
        "code": "44431",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19496840",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70518985",
          "10518993",
          "90518989"
        ],
        "code": "49339",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19502290",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60567410",
          "30567416",
          "30567402"
        ],
        "code": "44436",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19514641",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30567355",
          "80567372",
          "90567343"
        ],
        "code": "49339",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19529044",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "80595884",
          "40596852",
          "40519000",
          "80223884"
        ],
        "code": "73135",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19580061",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2260
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30517520",
          "20517554",
          "00517507"
        ],
        "code": "44436",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19580339",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "00517550",
          "50517538"
        ],
        "code": "44434",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19580749",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "60223899",
          "70223907",
          "90620915",
          "40620913"
        ],
        "code": "44434",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19607107",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "00223901",
          "70223907",
          "70620916",
          "40620913"
        ],
        "code": "44431",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19607145",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223901",
          "70223907",
          "70620916",
          "40620913"
        ],
        "code": "44435",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19607169",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "00223864",
          "00630382",
          "10463467",
          "50463470"
        ],
        "code": "73137",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621368",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "50630370",
          "40629367",
          "80223884",
          "00629369",
          "00223864"
        ],
        "code": "73136",
        "cover": "kelinge-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621373",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "50630370",
          "40629367",
          "80223884"
        ],
        "code": "73135",
        "cover": "kelinge-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621387",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30629363",
          "10629359"
        ],
        "code": "22126",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621636",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "00629369",
          "80629370"
        ],
        "code": "44434",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19621759",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70629417",
          "50629418",
          "10629420",
          "00223878"
        ],
        "code": "74090",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622018",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "60629366",
          "20629368",
          "80629370",
          "40629367"
        ],
        "code": "44432",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622042",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "80630255",
          "40630262",
          "30630267",
          "60630256"
        ],
        "code": "44432",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622056",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70629417",
          "90629421",
          "50629418"
        ],
        "code": "49339",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622080",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40630262",
          "30630267"
        ],
        "code": "44431",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622184",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "40629367",
          "80629370"
        ],
        "code": "22116",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622198",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "60629432",
          "20629434"
        ],
        "code": "22116",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622216",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "00629406",
          "20629405",
          "70629403"
        ],
        "code": "63118",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622259",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30629424",
          "00629425",
          "80629426"
        ],
        "code": "22201",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19622315",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "50630370"
        ],
        "code": "74208",
        "cover": "kelinge-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19630966",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30463471",
          "90463468"
        ],
        "code": "44435",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29305425",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "60454489",
          "90454497"
        ],
        "code": "44434",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29305760",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30454481",
          "60454489",
          "40454485"
        ],
        "code": "44436",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29305816",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80454493",
          "90454497"
        ],
        "code": "44431",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29305883",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "50517524",
          "40517534"
        ],
        "code": "44431",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430561",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "90517522",
          "10517535",
          "50517500"
        ],
        "code": "63118",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430580",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "00517531",
          "70517542"
        ],
        "code": "44431",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430617",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30517520",
          "00517531",
          "70517542",
          "00517507"
        ],
        "code": "44432",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430622",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40517553",
          "50517519",
          "20517506"
        ],
        "code": "49339",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430641",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40517529",
          "10517540"
        ],
        "code": "44435",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29430655",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60518981",
          "60519117"
        ],
        "code": "44435",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29449626",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90518989",
          "10518993",
          "70518985"
        ],
        "code": "44436",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29449631",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "50519028",
          "70519032"
        ],
        "code": "44434",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29452100",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30553513",
          "90553505"
        ],
        "code": "44435",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29496849",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70558603",
          "30558600"
        ],
        "code": "22126",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29501761",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "40567331",
          "90567319",
          "20567327",
          "70567315"
        ],
        "code": "44432",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514419",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "40567331",
          "70567315",
          "90567319"
        ],
        "code": "22201",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514424",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "10567323",
          "20567327"
        ],
        "code": "44434",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514457",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "30567416",
          "40567406"
        ],
        "code": "44434",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29514565",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "20574479",
          "60574482",
          "70574486",
          "00574480"
        ],
        "code": "44432",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29528001",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40574483",
          "50574487"
        ],
        "code": "44431",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29528077",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90574485",
          "40574478",
          "80574481"
        ],
        "code": "49339",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29528096",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "10517516",
          "20517549",
          "10517502"
        ],
        "code": "44436",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29580334",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "80223898",
          "30223909",
          "60557821",
          "70557774"
        ],
        "code": "44434",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29580744",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "40614323",
          "10519073",
          "20519058",
          "50519066"
        ],
        "code": "44432",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29598032",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223919",
          "60223899",
          "70223894",
          "20620914",
          "90620915",
          "60620912"
        ],
        "code": "49339",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29607164",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "80595884",
          "70596860",
          "60454489",
          "00223864",
          "40454485",
          "80223884"
        ],
        "code": "73136",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29616446",
        "rangeId": "soderhamn",
        "widthInMillimeters": 3190
      },
      {
        "childItems": [
          "80595884",
          "70596860",
          "40454485",
          "80223884",
          "30454481",
          "80454493",
          "20223882",
          "50223885"
        ],
        "code": "73134",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29616451",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "00630382",
          "10463467",
          "80223884",
          "50463470",
          "00223864"
        ],
        "code": "73136",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29621382",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70629417",
          "50629418"
        ],
        "code": "22126",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29621650",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "50629395",
          "70629399",
          "30629396"
        ],
        "code": "44436",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29621669",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60629366",
          "00629369",
          "40629367"
        ],
        "code": "44436",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29621674",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "20630263",
          "30630267"
        ],
        "code": "44434",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29621773",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "10629439",
          "30629438",
          "00223878",
          "50629442"
        ],
        "code": "74090",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622008",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "60629366",
          "40629367",
          "80629370",
          "00223878"
        ],
        "code": "74090",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622027",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60629366",
          "00629369",
          "40629367"
        ],
        "code": "49339",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622070",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80629426",
          "60629427"
        ],
        "code": "44435",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622126",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20629368",
          "80629370"
        ],
        "code": "44431",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622169",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40629433",
          "20629434"
        ],
        "code": "44431",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622188",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "00629411",
          "60629413"
        ],
        "code": "22116",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622206",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "20629387",
          "00629388",
          "80629389"
        ],
        "code": "22201",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29622334",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "60223903",
          "50223908",
          "20223900",
          "20223896",
          "90574522",
          "60574528",
          "50574524",
          "70574518"
        ],
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "29639259",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30454481",
          "40454485",
          "80454493"
        ],
        "code": "22201",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39305892",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "60517514",
          "20517525",
          "10517535",
          "50517500"
        ],
        "code": "44432",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430565",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "50517519",
          "20517506",
          "20517530"
        ],
        "code": "22201",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430626",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "60517552",
          "10517540",
          "40517505"
        ],
        "code": "63118",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430645",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70517518",
          "40517505"
        ],
        "code": "22126",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39430650",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "10518993",
          "60518981"
        ],
        "code": "44434",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39449616",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "90518989",
          "70518985"
        ],
        "code": "22126",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39449621",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80567372",
          "00567347"
        ],
        "code": "44434",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39514536",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30567355",
          "90567343"
        ],
        "code": "22126",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39514541",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "60567410",
          "30567402",
          "70567424"
        ],
        "code": "22201",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39514598",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40517553",
          "50517519",
          "20517506"
        ],
        "code": "44436",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39580338",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "70517523",
          "90517536"
        ],
        "code": "44434",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39580748",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223919",
          "70223894",
          "00223901",
          "20620914",
          "60620912",
          "70620916"
        ],
        "code": "22201",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39607149",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10620924",
          "30620918"
        ],
        "code": "44435",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39607168",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "80629431",
          "90629435",
          "60629432"
        ],
        "code": "44436",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39621659",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "90629435",
          "20629434"
        ],
        "code": "44434",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39621777",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50629395",
          "30629396",
          "90629398",
          "00223878"
        ],
        "code": "74090",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622022",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "20629387",
          "80629389",
          "60629390",
          "00629388"
        ],
        "code": "44432",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622036",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "80629431",
          "40629433",
          "20629434",
          "60629432"
        ],
        "code": "44432",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622060",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20630263",
          "60630256",
          "80630255"
        ],
        "code": "49339",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622084",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60629413",
          "80629412"
        ],
        "code": "44435",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622116",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80629412",
          "60629413"
        ],
        "code": "44431",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622178",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "10629359",
          "50629362"
        ],
        "code": "22116",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622201",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "40629391",
          "60629390",
          "00629388"
        ],
        "code": "63118",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622220",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "70629399",
          "90629398",
          "30629396"
        ],
        "code": "63118",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622244",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "40629428",
          "60629427",
          "00629425"
        ],
        "code": "63118",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622263",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "70629417",
          "50629418",
          "30629419"
        ],
        "code": "22201",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39622319",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "00630382"
        ],
        "code": "74208",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39630970",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "40517548",
          "40517534",
          "60517496"
        ],
        "code": "63118",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430579",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30517515",
          "30517501"
        ],
        "code": "22126",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430584",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20517530",
          "90517541"
        ],
        "code": "44431",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430616",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "50517519",
          "20517530",
          "90517541",
          "20517506"
        ],
        "code": "44432",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430621",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70517518",
          "60517552",
          "40517505"
        ],
        "code": "49339",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49430640",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "90518989",
          "60518981",
          "70518985",
          "60519117"
        ],
        "code": "44432",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49449588",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "90518989",
          "70518985",
          "60519117"
        ],
        "code": "22201",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49449593",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50553606",
          "70553506"
        ],
        "code": "22126",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49496848",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "70558603",
          "30558600",
          "20558605"
        ],
        "code": "22201",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49501755",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "20574479",
          "00574480"
        ],
        "code": "22126",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49528024",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "40574478",
          "40574483",
          "50574487",
          "80574481"
        ],
        "code": "44432",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49528081",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "60567410",
          "30567402",
          "30567416",
          "20223882",
          "80223884",
          "00223864"
        ],
        "code": "49339",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49529047",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "80223898",
          "30223909",
          "40557822",
          "40557775"
        ],
        "code": "44434",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49580743",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10620924",
          "30620918"
        ],
        "code": "44431",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49607144",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90620920",
          "30620923",
          "50620922"
        ],
        "code": "49339",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49607163",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "80595884",
          "70596860",
          "60454489",
          "00223864",
          "40454485",
          "80223884"
        ],
        "code": "73137",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49616426",
        "rangeId": "soderhamn",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "80595884",
          "30630371",
          "80223884",
          "00629388",
          "50223885",
          "80629389",
          "20629387",
          "20223882"
        ],
        "code": "73134",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49618680",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "50630370",
          "40629367",
          "80223884",
          "00629369",
          "00223864"
        ],
        "code": "73137",
        "cover": "kelinge-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621362",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "50223885",
          "20223882",
          "70630369",
          "50629381",
          "30629382",
          "70629380"
        ],
        "code": "73134",
        "cover": "kelinge-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621395",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "50223885",
          "20223882",
          "00630382",
          "10463467",
          "30463471",
          "70463469"
        ],
        "code": "73134",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621404",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70629380",
          "50629381"
        ],
        "code": "22126",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621630",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50629395",
          "30629396"
        ],
        "code": "22126",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49621654",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "40629414",
          "60629413"
        ],
        "code": "44434",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49621767",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30629424",
          "00629425",
          "60629427",
          "00223878"
        ],
        "code": "74090",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622012",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30629363",
          "90629360",
          "50629362",
          "10629359"
        ],
        "code": "44432",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622045",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "20629410",
          "80629412",
          "60629413",
          "00629411"
        ],
        "code": "44432",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622050",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "80629431",
          "90629435",
          "60629432"
        ],
        "code": "49339",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622088",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "50629362",
          "90629360"
        ],
        "code": "44435",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622111",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "00629388",
          "60629390"
        ],
        "code": "22116",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622192",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "70629403",
          "20629405"
        ],
        "code": "22116",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622210",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "30629443",
          "50629442",
          "10629439"
        ],
        "code": "63118",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622267",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "60629366",
          "40629367",
          "20629368"
        ],
        "code": "22201",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49622328",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "40596852"
        ],
        "code": "74208",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49634152",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2140
      },
      {
        "childItems": [
          "00223901",
          "70223907",
          "60223899",
          "70223894",
          "10574521",
          "80574527",
          "70574523",
          "90574517"
        ],
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "49639258",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "70463469",
          "10463467",
          "30463471"
        ],
        "code": "22201",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59305419",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "90463468",
          "00223864",
          "50463470",
          "00223878"
        ],
        "code": "44434",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59305424",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30517515",
          "30517501",
          "00517526"
        ],
        "code": "22201",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430569",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "70517518",
          "40517505",
          "40517529"
        ],
        "code": "22201",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430625",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "90517517",
          "90517503"
        ],
        "code": "22126",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430649",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60517528",
          "50517538"
        ],
        "code": "44435",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59430654",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "10519073",
          "20519058"
        ],
        "code": "22126",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59442157",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60518981",
          "60519117"
        ],
        "code": "44431",
        "cover": "fridtuna-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59449583",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40519000",
          "60519004",
          "50519014"
        ],
        "code": "44436",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59449700",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60519023",
          "50519028",
          "70519027"
        ],
        "code": "49339",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59502293",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "90567319",
          "20567327"
        ],
        "code": "44431",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59514413",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "60567410",
          "70567424",
          "40567406",
          "30567402"
        ],
        "code": "44432",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59514597",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223919",
          "60223899",
          "70223894",
          "10567417",
          "40567411",
          "10567403"
        ],
        "code": "49339",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59514639",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "40223918",
          "80223898",
          "00223897",
          "00454492",
          "50454480",
          "80454488"
        ],
        "code": "49339",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "59567581",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70517518",
          "60517552",
          "40517505"
        ],
        "code": "44436",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59580337",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30517515",
          "70517523",
          "30517501"
        ],
        "code": "44436",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59580342",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "90517522",
          "10517535"
        ],
        "code": "44434",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59580747",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "90620920",
          "50620922",
          "10620924"
        ],
        "code": "22201",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59607148",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90620920",
          "50620922",
          "30620923"
        ],
        "code": "44436",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59607172",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "80595884",
          "30630371",
          "00629388",
          "80223884"
        ],
        "code": "73135",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59618670",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "30630366",
          "10629359",
          "80223884"
        ],
        "code": "73135",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59621390",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30629438",
          "10629439"
        ],
        "code": "22126",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59621639",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30629424",
          "00629425"
        ],
        "code": "22126",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59621644",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "80630255",
          "20630263",
          "60630256"
        ],
        "code": "44436",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59621663",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70629380",
          "90629384",
          "50629381"
        ],
        "code": "44436",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59621677",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "70629361",
          "50629362"
        ],
        "code": "44434",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59621762",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90629402",
          "00629406",
          "70629403"
        ],
        "code": "44436",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59621781",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "90629402",
          "70629403",
          "20629405",
          "00223878"
        ],
        "code": "74090",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622016",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20629387",
          "40629391",
          "00629388"
        ],
        "code": "49339",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622064",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20629410",
          "40629414",
          "00629411"
        ],
        "code": "49339",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622078",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20629405",
          "50629404"
        ],
        "code": "44435",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622120",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80629389",
          "60629390"
        ],
        "code": "44431",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622163",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "50629404",
          "20629405"
        ],
        "code": "44431",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622182",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "00629369",
          "80629370",
          "40629367"
        ],
        "code": "63118",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622238",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "90629421",
          "10629420",
          "50629418"
        ],
        "code": "63118",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622257",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "50629395",
          "30629396",
          "10629397"
        ],
        "code": "22201",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59622323",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "70596860"
        ],
        "code": "74208",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59634156",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2140
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30454481",
          "40454485"
        ],
        "code": "22126",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69305697",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "80517513",
          "50517524",
          "40517534",
          "60517496"
        ],
        "code": "44432",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430564",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30517515",
          "70517523",
          "30517501"
        ],
        "code": "49339",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430578",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "60517514",
          "50517500"
        ],
        "code": "22126",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430583",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40517529",
          "10517540"
        ],
        "code": "44431",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430615",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "70517518",
          "40517529",
          "10517540",
          "40517505"
        ],
        "code": "44432",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430620",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "00517550",
          "90517517",
          "90517503"
        ],
        "code": "49339",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430639",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "00517550",
          "50517538",
          "90517503"
        ],
        "code": "63118",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69430644",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "50519014",
          "40519000",
          "90519130"
        ],
        "code": "22201",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69449667",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "50553507",
          "90553505"
        ],
        "code": "44434",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69496847",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70567377",
          "00567347"
        ],
        "code": "44431",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514498",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "30567355",
          "90567343",
          "70567377"
        ],
        "code": "22201",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514511",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70567424",
          "40567406"
        ],
        "code": "44431",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514587",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70567424",
          "40567406"
        ],
        "code": "44435",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69514634",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "20574479",
          "00574480",
          "60574482"
        ],
        "code": "22201",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69528004",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "20574484",
          "70574486"
        ],
        "code": "44434",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69528023",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "40574478",
          "80574481"
        ],
        "code": "22126",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69528099",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "40519000",
          "40596852",
          "80223884",
          "80595884",
          "60519004",
          "00223864"
        ],
        "code": "73136",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69616128",
        "rangeId": "soderhamn",
        "widthInMillimeters": 3190
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "90629402",
          "70629403"
        ],
        "code": "22126",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69621648",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20629410",
          "40629414",
          "00629411"
        ],
        "code": "44436",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69621667",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "40629391",
          "60629390"
        ],
        "code": "44434",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69621752",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "00629406",
          "20629405"
        ],
        "code": "44434",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69621771",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "70629380",
          "50629381",
          "10629383",
          "00223878"
        ],
        "code": "74090",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622030",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "90629402",
          "50629404",
          "20629405",
          "70629403"
        ],
        "code": "44432",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622054",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629363",
          "70629361",
          "10629359"
        ],
        "code": "49339",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622073",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10629383",
          "30629382"
        ],
        "code": "44435",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622105",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "90629360",
          "50629362"
        ],
        "code": "44431",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622172",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80629426",
          "60629427"
        ],
        "code": "44431",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622186",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "00629425",
          "60629427"
        ],
        "code": "22116",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622214",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "40629414",
          "60629413",
          "00629411"
        ],
        "code": "63118",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622247",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "80629431",
          "60629432",
          "40629433"
        ],
        "code": "22201",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69622313",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "00223864",
          "80223884",
          "60574482",
          "70574486",
          "20574484",
          "00574480"
        ],
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "itemNo": "69639257",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "70463469",
          "90463468",
          "30463471",
          "10463467"
        ],
        "code": "44432",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79305418",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "70463469",
          "10463467",
          "20223882",
          "80223884"
        ],
        "code": "22126",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79305423",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "60517514",
          "50517500",
          "20517525"
        ],
        "code": "22201",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430568",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "00517526",
          "90517536"
        ],
        "code": "44435",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430587",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "10517516",
          "10517502"
        ],
        "code": "22126",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430648",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80517527",
          "70517537"
        ],
        "code": "44435",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79430653",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "90519130",
          "70519008"
        ],
        "code": "44431",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79449657",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "50519014",
          "40519000",
          "90519130",
          "70519008"
        ],
        "code": "44432",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79449662",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70519008",
          "90519130"
        ],
        "code": "44435",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79449695",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "50553606",
          "70553506",
          "30553513"
        ],
        "code": "22201",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79496842",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "10558601",
          "90558602"
        ],
        "code": "44434",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79501749",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "70558603",
          "20558605",
          "90558602",
          "30558600"
        ],
        "code": "44432",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79501754",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "10519073",
          "40519062",
          "20519058"
        ],
        "code": "49339",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79502292",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30558600",
          "10558601",
          "70558603"
        ],
        "code": "49339",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79505177",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40567331",
          "10567323",
          "70567315"
        ],
        "code": "44436",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79514474",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "60567410",
          "30567402"
        ],
        "code": "22126",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79514624",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60574482",
          "70574486"
        ],
        "code": "44435",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79528027",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20574479",
          "20574484",
          "00574480"
        ],
        "code": "44436",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79528032",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "90574485",
          "50574487"
        ],
        "code": "44434",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79528065",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "00517550",
          "90517517",
          "90517503"
        ],
        "code": "44436",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79580336",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60517514",
          "90517522",
          "50517500"
        ],
        "code": "44436",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79580341",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "80223898",
          "30223909",
          "20557818",
          "90557773"
        ],
        "code": "44434",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79580746",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223919",
          "00223901",
          "70223907",
          "70223894",
          "20620914",
          "60620912",
          "70620916",
          "40620913"
        ],
        "code": "44432",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79607147",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223919",
          "70223894",
          "20620914",
          "60620912"
        ],
        "code": "22126",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79607166",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223919",
          "60223899",
          "70223894",
          "20620914",
          "60620912",
          "90620915"
        ],
        "code": "44436",
        "cover": "vissle-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79607171",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "40519000",
          "90519130",
          "50519014",
          "40596852",
          "80223884",
          "50223885",
          "20223882",
          "80595884"
        ],
        "code": "73134",
        "cover": "fridtuna-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79616203",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "30630371",
          "00629388",
          "80223884",
          "40629391",
          "00223864"
        ],
        "code": "73136",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79618674",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "00223864",
          "30630366",
          "10629359",
          "70629361"
        ],
        "code": "73137",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79621365",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "70630369",
          "50629381",
          "80223884",
          "90629384",
          "00223864"
        ],
        "code": "73136",
        "cover": "kelinge-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79621370",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629363",
          "70629361",
          "10629359"
        ],
        "code": "44436",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79621657",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "90629384",
          "10629383"
        ],
        "code": "44434",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79621756",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "40629428",
          "60629427"
        ],
        "code": "44434",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79621775",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "20629410",
          "00629411",
          "60629413",
          "00223878"
        ],
        "code": "74090",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622020",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "70629380",
          "30629382",
          "10629383",
          "50629381"
        ],
        "code": "44432",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622039",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30629424",
          "80629426",
          "60629427",
          "00629425"
        ],
        "code": "44432",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622058",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "90629402",
          "00629406",
          "70629403"
        ],
        "code": "49339",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622082",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60629390",
          "80629389"
        ],
        "code": "44435",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622100",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40630262",
          "30630267"
        ],
        "code": "44435",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622124",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10629397",
          "90629398"
        ],
        "code": "44431",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622176",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "50629381",
          "10629383"
        ],
        "code": "22116",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622195",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "30629396",
          "90629398"
        ],
        "code": "22116",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622204",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "10629439",
          "50629442"
        ],
        "code": "22116",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622218",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "20630263",
          "30630267",
          "60630256"
        ],
        "code": "63118",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622261",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "80630255",
          "60630256",
          "40630262"
        ],
        "code": "22201",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79622317",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223919",
          "60223899",
          "70223894",
          "90648561",
          "50648563",
          "50648558"
        ],
        "code": "49339",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79629154",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30454481",
          "80454493",
          "90454497",
          "40454485"
        ],
        "code": "44432",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89305842",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "00517526",
          "90517536"
        ],
        "code": "44431",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430563",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60517514",
          "90517522",
          "50517500"
        ],
        "code": "49339",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430577",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "80517513",
          "60517496"
        ],
        "code": "22126",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430582",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "90517517",
          "60517528",
          "50517538",
          "90517503"
        ],
        "code": "44432",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430619",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "90517517",
          "90517503",
          "60517528"
        ],
        "code": "22201",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430624",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "10517516",
          "20517549",
          "10517502"
        ],
        "code": "49339",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430638",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "20517549",
          "70517537",
          "10517502"
        ],
        "code": "63118",
        "cover": "tallmyra-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430643",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "00517531",
          "70517542"
        ],
        "code": "44435",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89430657",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "40519000",
          "50519014"
        ],
        "code": "22126",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89449690",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70558603",
          "10558601",
          "30558600"
        ],
        "code": "44436",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89501763",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "90567319",
          "20567327"
        ],
        "code": "44435",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514464",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30567355",
          "70567377",
          "00567347",
          "90567343"
        ],
        "code": "44432",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514505",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30567355",
          "80567372",
          "90567343"
        ],
        "code": "44436",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89514553",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20574484",
          "20574479",
          "00574480"
        ],
        "code": "49339",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89528017",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "40574478",
          "80574481",
          "40574483"
        ],
        "code": "22201",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89528084",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40574483",
          "50574487"
        ],
        "code": "44435",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89528102",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "80595884",
          "70596860",
          "40454485",
          "80223884"
        ],
        "code": "73135",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89580067",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2260
      },
      {
        "childItems": [
          "80595884",
          "30630366",
          "10629359",
          "80223884",
          "70629361",
          "00223864"
        ],
        "code": "73136",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621379",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "70630369",
          "50629381",
          "80223884"
        ],
        "code": "73135",
        "cover": "kelinge-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621384",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "80223884",
          "50223885",
          "20223882",
          "50630370",
          "40629367",
          "20629368",
          "60629366"
        ],
        "code": "73134",
        "cover": "kelinge-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621398",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "60629366",
          "40629367"
        ],
        "code": "22126",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621633",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "20629410",
          "00629411"
        ],
        "code": "22126",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89621652",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "70629399",
          "90629398"
        ],
        "code": "44434",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89621765",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "80629431",
          "60629432",
          "20629434",
          "00223878"
        ],
        "code": "74090",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622010",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "50629395",
          "10629397",
          "90629398",
          "30629396"
        ],
        "code": "44432",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622048",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "70629380",
          "90629384",
          "50629381"
        ],
        "code": "49339",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622067",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629424",
          "40629428",
          "00629425"
        ],
        "code": "49339",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622086",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "90629398",
          "10629397"
        ],
        "code": "44435",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622114",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "40629433",
          "20629434"
        ],
        "code": "44435",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622128",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30629382",
          "10629383"
        ],
        "code": "44431",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622166",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70629441",
          "50629442"
        ],
        "code": "44431",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622190",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80223884",
          "00223878",
          "50629418",
          "10629420"
        ],
        "code": "22116",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622208",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1050
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "90629435",
          "20629434",
          "60629432"
        ],
        "code": "63118",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622265",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "70629380",
          "50629381",
          "30629382"
        ],
        "code": "22201",
        "cover": "kelinge-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89622331",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "70630369"
        ],
        "code": "74208",
        "cover": "kelinge-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89630963",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30463471",
          "90463468"
        ],
        "code": "44431",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99305417",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "80454493",
          "90454497"
        ],
        "code": "44435",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99305691",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "80517513",
          "60517496",
          "50517524"
        ],
        "code": "22201",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430567",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20517525",
          "10517535"
        ],
        "code": "44435",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430586",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "60517528",
          "50517538"
        ],
        "code": "44431",
        "cover": "tallmyra-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430614",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "20517554",
          "70517542",
          "00517507"
        ],
        "code": "63118",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430647",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30517520",
          "00517507"
        ],
        "code": "22126",
        "cover": "tallmyra-white-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99430652",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60519023",
          "70519027",
          "50519028"
        ],
        "code": "44436",
        "cover": "tonerud-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99452111",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "50553606",
          "30553513",
          "90553505",
          "70553506"
        ],
        "code": "44432",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99496841",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "20558605",
          "90558602"
        ],
        "code": "44431",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99501753",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "50519014",
          "60519004",
          "40519000"
        ],
        "code": "49339",
        "cover": "fridtuna-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99502291",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40567331",
          "10567323",
          "70567315"
        ],
        "code": "49339",
        "cover": "tonerud-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99514642",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "40574478",
          "90574485",
          "80574481"
        ],
        "code": "44436",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99528106",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "60454489",
          "30454481",
          "40454485"
        ],
        "code": "49339",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99534428",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "80517513",
          "40517548",
          "60517496"
        ],
        "code": "44436",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99580340",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "60517552",
          "10517540"
        ],
        "code": "44434",
        "cover": "tallmyra-light-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99580750",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "50519066",
          "40614323"
        ],
        "code": "44431",
        "cover": "gransel-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99598302",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "30620923",
          "30620918"
        ],
        "code": "44434",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99607108",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "90620920",
          "50620922",
          "10620924",
          "30620918"
        ],
        "code": "44432",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99607146",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "90620920",
          "50620922"
        ],
        "code": "22126",
        "cover": "knaback-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99607165",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "80595884",
          "00630382",
          "10463467",
          "80223884"
        ],
        "code": "73135",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99621393",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "80629431",
          "60629432"
        ],
        "code": "22126",
        "cover": "alhamn-deep-orange-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99621642",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1980
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629424",
          "40629428",
          "00629425"
        ],
        "code": "44436",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99621661",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "20629387",
          "40629391",
          "00629388"
        ],
        "code": "44436",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99621680",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "30629443",
          "50629442"
        ],
        "code": "44434",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99621779",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1860
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "30629438",
          "30629443",
          "10629439"
        ],
        "code": "44436",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99621784",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2850
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "30629363",
          "10629359",
          "50629362",
          "00223878"
        ],
        "code": "74090",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622024",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "50223885",
          "00223878",
          "80223884",
          "30629438",
          "70629441",
          "50629442",
          "10629439"
        ],
        "code": "44432",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622062",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "00223864",
          "80223884",
          "50629395",
          "70629399",
          "30629396"
        ],
        "code": "49339",
        "cover": "johanneshov-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622076",
        "rangeId": "soderhamn",
        "widthInMillimeters": 2910
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "10629420",
          "30629419"
        ],
        "code": "44435",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622118",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "70629441",
          "50629442"
        ],
        "code": "44435",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622161",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "50223885",
          "00223878",
          "30629419",
          "10629420"
        ],
        "code": "44431",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622180",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "00223864",
          "00223878",
          "80223884",
          "70629361",
          "50629362",
          "10629359"
        ],
        "code": "63118",
        "cover": "fridtuna-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622241",
        "rangeId": "soderhamn",
        "widthInMillimeters": 1920
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "20629410",
          "00629411",
          "80629412"
        ],
        "code": "22201",
        "cover": "johanneshov-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622321",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "20223882",
          "80223884",
          "50223885",
          "90629402",
          "70629403",
          "50629404"
        ],
        "code": "22201",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99622401",
        "rangeId": "soderhamn"
      },
      {
        "childItems": [
          "80595884",
          "30630371"
        ],
        "code": "74208",
        "cover": "kelinge-dark-yellow",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99630934",
        "rangeId": "soderhamn"
      }
    ]
  },
  "sorvallen": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "viarp-beige-brown",
        "dotOverride": "#B5B1A5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00138.jpg",
        "name": "tallmyra-black-white",
        "dotOverride": "#D3D2CE"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "tallmyra-medium-grey",
        "dotOverride": "#61626A"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "lejde-grey-black",
        "dotOverride": "#787878"
      }
    ],
    "displayName": "SÖRVALLEN",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10506419",
        "rangeId": "sorvallen",
        "widthInMillimeters": 1620
      },
      {
        "cover": "tallmyra-black-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40518618",
        "rangeId": "sorvallen",
        "widthInMillimeters": 1620
      },
      {
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50508713",
        "rangeId": "sorvallen",
        "widthInMillimeters": 1620
      },
      {
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "70508712",
        "rangeId": "sorvallen",
        "widthInMillimeters": 1620
      },
      {
        "childItems": [
          "40438396",
          "50438391",
          "20438397",
          "40438400"
        ],
        "code": "34141",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09304144",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "00506405",
          "30506404",
          "40506408"
        ],
        "code": "34141",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09419404",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90506401",
          "00506405",
          "80506406",
          "40506408"
        ],
        "code": "46939",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09419418",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "50518670",
          "30518671",
          "40518675"
        ],
        "code": "46783",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432387",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70518669",
          "30518671"
        ],
        "code": "34122",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432392",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "30518609",
          "70518612",
          "00518615",
          "60518617"
        ],
        "code": "34140",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432434",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518609",
          "50518613",
          "70518612"
        ],
        "code": "44953",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432448",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "80438399",
          "50438391",
          "70508712"
        ],
        "code": "59503",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09494441",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "40438396",
          "20438397",
          "80438399"
        ],
        "code": "34124",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19304148",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "90506401",
          "00506405",
          "30506404",
          "40506408"
        ],
        "code": "46785",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19419408",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "30506404",
          "70506402"
        ],
        "code": "34124",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19419413",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "70518669",
          "30518671",
          "70518674"
        ],
        "code": "44965",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432382",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "50518670",
          "10518672",
          "30518671"
        ],
        "code": "46786",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432396",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "70518669",
          "70518674",
          "40518675",
          "00518677"
        ],
        "code": "34142",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432400",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "10518610",
          "70518612",
          "00518615",
          "60518617"
        ],
        "code": "46784",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432438",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10518610",
          "90518611"
        ],
        "code": "46788",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432443",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "40438396",
          "70438390",
          "30438392",
          "40438400"
        ],
        "code": "34140",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29304143",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "80462233",
          "80438399",
          "30438392"
        ],
        "code": "46783",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29314774",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "80462233",
          "20438397",
          "80438399"
        ],
        "code": "46787",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29314788",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "10506400",
          "50506403",
          "80506406",
          "40506408"
        ],
        "code": "34140",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29419403",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "00506405",
          "80506406",
          "40506408"
        ],
        "code": "34142",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29419417",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "50518670",
          "30518671",
          "70518674"
        ],
        "code": "46782",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29432386",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518671",
          "90518673",
          "50508713"
        ],
        "code": "55334",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29432391",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "30518609",
          "90518611",
          "00518615"
        ],
        "code": "44966",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29432433",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10518610",
          "50518613",
          "90518611"
        ],
        "code": "46787",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29432447",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "80438399",
          "20438397",
          "70508712"
        ],
        "code": "55334",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29433404",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "80438399",
          "30438392",
          "70508712"
        ],
        "code": "59503",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29494440",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "40438396",
          "70438390",
          "80438399"
        ],
        "code": "34123",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39304147",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "80462233",
          "80438399"
        ],
        "code": "46788",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39314783",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "90506401",
          "50506403",
          "80506406",
          "40506408"
        ],
        "code": "46784",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39419407",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "50506403",
          "70506402"
        ],
        "code": "34123",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39419412",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "50518670",
          "30518671"
        ],
        "code": "46788",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432395",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "10518610",
          "90518611",
          "00518615"
        ],
        "code": "46783",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432437",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518609",
          "90518611"
        ],
        "code": "34122",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432442",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "40438396",
          "30438392",
          "80438399"
        ],
        "code": "44966",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49304142",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "70506402",
          "80506406"
        ],
        "code": "44966",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49419402",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90506401",
          "30506404",
          "50506403"
        ],
        "code": "46938",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49419416",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "70518669",
          "70518674",
          "90518673",
          "00518677"
        ],
        "code": "34141",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432385",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518671",
          "10518672",
          "50508713"
        ],
        "code": "55333",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432390",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "30518609",
          "90518611",
          "30518614"
        ],
        "code": "44965",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432432",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10518610",
          "70518612",
          "90518611"
        ],
        "code": "46786",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432446",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "10518610",
          "30518614",
          "00518615",
          "60518617"
        ],
        "code": "46939",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432451",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "30518671",
          "70518674",
          "50508713"
        ],
        "code": "59503",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49494439",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70506402",
          "80506406",
          "10506419"
        ],
        "code": "59503",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49494444",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "40438396",
          "70438390",
          "20438397"
        ],
        "code": "44953",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59304146",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "80462233",
          "70438390",
          "30438392",
          "40438400"
        ],
        "code": "46784",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59314777",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90506401",
          "70506402",
          "80506406"
        ],
        "code": "46783",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59419406",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90506401",
          "70506402"
        ],
        "code": "46788",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59419411",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2320
      },
      {
        "childItems": [
          "50518670",
          "90518673",
          "10518672"
        ],
        "code": "46938",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59432399",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "10518610",
          "90518611",
          "30518614"
        ],
        "code": "46782",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59432436",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90518611",
          "50518613",
          "40518618"
        ],
        "code": "55334",
        "cover": "tallmyra-black-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59432441",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "40438396",
          "50438391",
          "80438399"
        ],
        "code": "44965",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69304141",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "80462233",
          "20438397",
          "70438390"
        ],
        "code": "46938",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69314786",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "80462233",
          "70438390",
          "80438399"
        ],
        "code": "46786",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69314791",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "10506400",
          "70506402",
          "00506405"
        ],
        "code": "44965",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69419401",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90506401",
          "30506404",
          "70506402"
        ],
        "code": "46787",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69419415",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "70506402",
          "30506404",
          "10506419"
        ],
        "code": "55334",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69419420",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "50518670",
          "70518674",
          "90518673",
          "00518677"
        ],
        "code": "46785",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432389",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70518669",
          "90518673",
          "30518671"
        ],
        "code": "34124",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432394",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "30518609",
          "50518613",
          "90518611"
        ],
        "code": "34124",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432445",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "30518609",
          "30518614",
          "00518615",
          "60518617"
        ],
        "code": "34142",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432450",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "90518611",
          "30518614",
          "40518618"
        ],
        "code": "59503",
        "cover": "tallmyra-black-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69494438",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90518611",
          "00518615",
          "40518618"
        ],
        "code": "59503",
        "cover": "tallmyra-black-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69494443",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "40438396",
          "80438399"
        ],
        "code": "34122",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79304145",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "80462233",
          "50438391",
          "30438392",
          "40438400"
        ],
        "code": "46939",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79314795",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "90506401",
          "70506402",
          "00506405"
        ],
        "code": "46782",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79419405",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "30506404",
          "50506403"
        ],
        "code": "44953",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79419410",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "70518669",
          "10518672",
          "40518675",
          "00518677"
        ],
        "code": "34140",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432384",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70518669",
          "90518673",
          "10518672"
        ],
        "code": "44953",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432398",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "30518609",
          "30518614",
          "50518613",
          "60518617"
        ],
        "code": "34141",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432435",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "90518611",
          "70518612",
          "40518618"
        ],
        "code": "55333",
        "cover": "tallmyra-black-white",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432440",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "80462233",
          "50438391",
          "80438399"
        ],
        "code": "46782",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89314771",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70506402",
          "50506403",
          "10506419"
        ],
        "code": "55333",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89419419",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "50518670",
          "10518672",
          "40518675",
          "00518677"
        ],
        "code": "46784",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89432388",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "70518669",
          "10518672",
          "30518671"
        ],
        "code": "34123",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89432393",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "10518610",
          "50518613",
          "70518612"
        ],
        "code": "46938",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89432449",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "70506402",
          "00506405",
          "10506419"
        ],
        "code": "59503",
        "cover": "viarp-beige-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89494437",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518671",
          "40518675",
          "50508713"
        ],
        "code": "59503",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89494442",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "40438396",
          "50438391",
          "30438392",
          "40438400"
        ],
        "code": "34142",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99304149",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3650
      },
      {
        "childItems": [
          "80462233",
          "50438391",
          "20438397",
          "40438400"
        ],
        "code": "46785",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99314780",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "10506400",
          "70506402"
        ],
        "code": "34122",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99419409",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "90506401",
          "50506403",
          "70506402"
        ],
        "code": "46786",
        "cover": "viarp-beige-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99419414",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "70518669",
          "30518671",
          "40518675"
        ],
        "code": "44966",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432383",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "50518670",
          "90518673",
          "30518671"
        ],
        "code": "46787",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432397",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3130
      },
      {
        "childItems": [
          "50518670",
          "70518674",
          "40518675",
          "00518677"
        ],
        "code": "46939",
        "cover": "tallmyra-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432401",
        "rangeId": "sorvallen",
        "widthInMillimeters": 3940
      },
      {
        "childItems": [
          "10518610",
          "30518614",
          "50518613",
          "60518617"
        ],
        "code": "46785",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432439",
        "rangeId": "sorvallen"
      },
      {
        "childItems": [
          "30518609",
          "70518612",
          "90518611"
        ],
        "code": "34123",
        "cover": "tallmyra-black-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432444",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      },
      {
        "childItems": [
          "80438399",
          "70438390",
          "70508712"
        ],
        "code": "55333",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99433405",
        "rangeId": "sorvallen",
        "widthInMillimeters": 2840
      }
    ]
  },
  "stackmora": {
    "coverProducts": null,
    "covers": [],
    "displayName": "STACKMORA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "stockholm": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00143.jpg",
        "name": "seglora-dark-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00142.jpg",
        "name": "seglora-natural"
      }
    ],
    "displayName": "STOCKHOLM",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "24030",
        "cover": "seglora-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "40245048",
        "rangeId": "stockholm",
        "widthInMillimeters": 2110
      },
      {
        "code": "24030",
        "cover": "seglora-natural",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "80245051",
        "rangeId": "stockholm",
        "widthInMillimeters": 2110
      }
    ]
  },
  "stockholm-2025": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "alhamn-dark-turquoise"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00143.jpg",
        "name": "alhamn-dark-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00172.jpg",
        "name": "alhamn-beige",
        "dotOverride": "#D19451"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "djurmo-grey-white"
      }
    ],
    "displayName": "STOCKHOLM 2025",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "69162",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "10586109",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 1780
      },
      {
        "code": "69162",
        "cover": "alhamn-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "30586108",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 1780
      },
      {
        "code": "69162",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90586110",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 1780
      },
      {
        "code": "69162",
        "cover": "alhamn-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90591748",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 1780
      },
      {
        "childItems": [
          "30586108",
          "20586123"
        ],
        "code": "69163",
        "cover": "alhamn-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09574292",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "60586121",
          "40586136"
        ],
        "code": "69163",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09574305",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "70591749",
          "90591753"
        ],
        "code": "69163",
        "cover": "alhamn-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19574296",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "10586109",
          "00586124"
        ],
        "code": "69163",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19574300",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "70586125",
          "90586110"
        ],
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29602029",
        "rangeId": "stockholm-2025"
      },
      {
        "childItems": [
          "90591748",
          "10591752"
        ],
        "code": "69163",
        "cover": "alhamn-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39574295",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "80586120",
          "60586135"
        ],
        "code": "69163",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39574304",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "40586122",
          "20586137"
        ],
        "code": "69165",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39574323",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "90586110",
          "70586125"
        ],
        "code": "69163",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59574303",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "60586121",
          "40586136"
        ],
        "code": "69165",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59574322",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "30586108",
          "20586123"
        ],
        "code": "69165",
        "cover": "alhamn-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69574307",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "90591748",
          "10591752"
        ],
        "code": "69165",
        "cover": "alhamn-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69574312",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "30591751",
          "40591755"
        ],
        "code": "69163",
        "cover": "alhamn-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79574298",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "10586114",
          "90586129"
        ],
        "code": "69163",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79574302",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "80586120",
          "60586135"
        ],
        "code": "69165",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79574321",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "40586122",
          "20586137"
        ],
        "code": "69163",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89574306",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "50586112",
          "10586128"
        ],
        "code": "69163",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99574297",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "70586111",
          "30586127"
        ],
        "code": "69163",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99574301",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 2430
      },
      {
        "childItems": [
          "10586109",
          "00586124"
        ],
        "code": "69165",
        "cover": "alhamn-dark-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99574315",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      },
      {
        "childItems": [
          "90586110",
          "70586125"
        ],
        "code": "69165",
        "cover": "djurmo-grey-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99574320",
        "rangeId": "stockholm-2025",
        "widthInMillimeters": 3080
      }
    ]
  },
  "stockholm-2025-alt": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "sundhamn-beige"
      }
    ],
    "displayName": "STOCKHOLM 2025",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "69164",
        "cover": "sundhamn-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90586092",
        "rangeId": "stockholm-2025-alt",
        "widthInMillimeters": 2330
      }
    ]
  },
  "strandmon": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "nordvalla-dark-grey"
      }
    ],
    "displayName": "STRANDMON",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "28524",
        "cover": "nordvalla-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "00325443",
        "rangeId": "strandmon",
        "widthInMillimeters": 1710
      }
    ]
  },
  "tornsborg": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "naggen-beige"
      }
    ],
    "displayName": "TORNSBORG",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "code": "69506",
        "cover": "naggen-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "90584658",
        "rangeId": "tornsborg",
        "widthInMillimeters": 1540
      }
    ]
  },
  "tunsta": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "anthracite"
      }
    ],
    "displayName": "TUNSTA",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": []
  },
  "uppakra": {
    "coverProducts": [
      {
        "itemNo": "00618931",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "00620726",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "10618898",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "10618902",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "10620392",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "10620698",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "10620863",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "20618850",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "20618906",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "20618911",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "20620396",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "20620400",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "20620693",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "20620711",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "20620725",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "20620754",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "20620834",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "30618859",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "30618915",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "30618939",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "30618944",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "30620838",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "30620862",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "40618948",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "40620404",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "40620705",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "40620710",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "40620729",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "40620753",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "40620833",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "40620866",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "50618858",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "50618919",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "50618938",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "50620408",
        "name": "axvall-dark-grey-blue"
      },
      {
        "itemNo": "50620724",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "50620757",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "50620837",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "50620861",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "60618886",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "60620323",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "60620709",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "60620728",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "60620752",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "60620832",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "60620865",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "70618857",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "70620723",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "70620756",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "70620836",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "70620860",
        "name": "samsala-yellow-brown"
      },
      {
        "itemNo": "80618890",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "80618927",
        "name": "axvall-off-white"
      },
      {
        "itemNo": "80620317",
        "name": "johanneshov-dark-grey"
      },
      {
        "itemNo": "80620727",
        "name": "samsala-dark-blue"
      },
      {
        "itemNo": "80620751",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "90620388",
        "name": "johanneshov-brown-beige"
      },
      {
        "itemNo": "90620722",
        "name": "samsala-brown-red"
      },
      {
        "itemNo": "90620755",
        "name": "samsala-dark-brown"
      },
      {
        "itemNo": "90620835",
        "name": "samsala-grey-beige"
      },
      {
        "itemNo": "90620864",
        "name": "samsala-yellow-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "axvall-dark-grey-blue",
        "dotOverride": "#567887"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "samsala-dark-blue",
        "dotOverride": "#3B596F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "johanneshov-brown-beige",
        "dotOverride": "#C5B7A2"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "samsala-brown-red",
        "dotOverride": "#A05749"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "samsala-yellow-brown",
        "dotOverride": "#B27D35"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "johanneshov-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "axvall-off-white",
        "dotOverride": "#E7E7DC"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00143.jpg",
        "name": "samsala-dark-brown",
        "dotOverride": "#775A49"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "samsala-grey-beige",
        "dotOverride": "#D8C19F"
      }
    ],
    "displayName": "UPPÅKRA",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "00620420",
        "name": "wood"
      },
      {
        "itemNo": "20620424",
        "name": "chrome-plated"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00620316",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10618775",
        "rangeId": "uppakra",
        "widthInMillimeters": 1100
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "10618841",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "20618794",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "20620315",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30618798",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30618802",
        "rangeId": "uppakra",
        "widthInMillimeters": 1050
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50620314",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "90620307",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "cover": "",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "90620312",
        "rangeId": "uppakra",
        "widthInMillimeters": 1270
      },
      {
        "childItems": [
          "90620388",
          "10618902",
          "80618890",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09612722",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620323",
          "80620317",
          "20620424"
        ],
        "code": "73680",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613000",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "80620317",
          "50618858",
          "20620424"
        ],
        "code": "73679",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613019",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50620724",
          "80620727",
          "20620424"
        ],
        "code": "73679",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613024",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "80620727",
          "60620728",
          "00620726",
          "20620424"
        ],
        "code": "73618",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613038",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70620723",
          "60620728",
          "00620726",
          "20620424"
        ],
        "code": "73619",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613043",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "40620404",
          "50620408",
          "30618944",
          "20620424"
        ],
        "code": "73661",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613057",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "70620836",
          "50620837",
          "20620834",
          "20620424"
        ],
        "code": "73661",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613062",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "20620711",
          "40620705",
          "10620698",
          "20620424"
        ],
        "code": "73674",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613076",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "20620396",
          "50618919",
          "80618927",
          "20620424"
        ],
        "code": "73676",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613081",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10620698",
          "40620710",
          "20620693",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613967",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "40620404",
          "30618944",
          "00618931",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09613972",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "90620388",
          "10620392",
          "00620420"
        ],
        "code": "73680",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614047",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "50620837",
          "70620836",
          "00620420"
        ],
        "code": "73680",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614052",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "80620317",
          "50618858",
          "00620420"
        ],
        "code": "73679",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614066",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50620861",
          "90620864",
          "00620420"
        ],
        "code": "73679",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614071",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "40620705",
          "10620698",
          "20620693",
          "00620420"
        ],
        "code": "73619",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614085",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "80620317",
          "60620323",
          "30618859",
          "00620420"
        ],
        "code": "73661",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614165",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620864",
          "60620865",
          "30620862",
          "00620420"
        ],
        "code": "73661",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614170",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40618948",
          "50618938",
          "50620408",
          "00620420"
        ],
        "code": "73674",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614189",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40620729",
          "70620723",
          "60620728",
          "00620420"
        ],
        "code": "73674",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614194",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20620396",
          "20620400",
          "00618926",
          "20618911",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614226",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620755",
          "70620756",
          "40620753",
          "20620754",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614231",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620388",
          "10618902",
          "80618890",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614245",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "70620836",
          "20620834",
          "90620835",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09614250",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "10618775",
          "90620312",
          "00618894",
          "80618890",
          "10620392",
          "20620424"
        ],
        "code": "73619",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19612689",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620865",
          "90620864",
          "20620424"
        ],
        "code": "73680",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613009",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620728",
          "70620723",
          "20620424"
        ],
        "code": "73678",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613014",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "80620317",
          "60620323",
          "20618850",
          "20620424"
        ],
        "code": "73618",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613028",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "20620400",
          "20618911",
          "20620396",
          "20620424"
        ],
        "code": "73618",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613033",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70620860",
          "60620865",
          "10620863",
          "20620424"
        ],
        "code": "73619",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613047",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50620724",
          "80620727",
          "00620726",
          "20620424"
        ],
        "code": "73620",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613052",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "30618915",
          "50618919",
          "20620424"
        ],
        "code": "73677",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613066",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70620723",
          "50620724",
          "20620424"
        ],
        "code": "73677",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613071",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "80620727",
          "50620724",
          "40620729",
          "20620424"
        ],
        "code": "73676",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613085",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20620396",
          "20620400",
          "00618926",
          "20618911",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613957",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620722",
          "10620698",
          "40620710",
          "20620693",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613962",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620722",
          "40620710",
          "20620693",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19613976",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "10620392",
          "00618894",
          "00620420"
        ],
        "code": "73678",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614056",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "50620837",
          "60620832",
          "00620420"
        ],
        "code": "73678",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614061",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "80620317",
          "60620323",
          "20618850",
          "00620420"
        ],
        "code": "73618",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614075",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620864",
          "10620863",
          "60620865",
          "00620420"
        ],
        "code": "73618",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614080",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50618919",
          "20620396",
          "20618911",
          "00620420"
        ],
        "code": "73620",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614136",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "60620752",
          "90620755",
          "20620754",
          "00620420"
        ],
        "code": "73620",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614141",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70620860",
          "50620861",
          "00620420"
        ],
        "code": "73677",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614179",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "40620404",
          "30618939",
          "40618948",
          "00620420"
        ],
        "code": "73676",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614198",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620722",
          "60620709",
          "20620711",
          "00620420"
        ],
        "code": "73676",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614202",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20620400",
          "00618926",
          "20618911",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614235",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "70620756",
          "40620753",
          "20620754",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19614240",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "10620392",
          "10618902",
          "80618890",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29612721",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "10620698",
          "40620705",
          "20620424"
        ],
        "code": "73678",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613018",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "60620709",
          "90620722",
          "20620424"
        ],
        "code": "73679",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613023",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620722",
          "10620698",
          "20620693",
          "20620424"
        ],
        "code": "73618",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613037",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "30618915",
          "20620400",
          "20618911",
          "20620424"
        ],
        "code": "73619",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613042",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "80620317",
          "60620323",
          "30618859",
          "20620424"
        ],
        "code": "73661",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613056",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620755",
          "70620756",
          "40620753",
          "20620424"
        ],
        "code": "73661",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613061",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40620866",
          "70620860",
          "60620865",
          "20620424"
        ],
        "code": "73674",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613075",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "80620317",
          "50618858",
          "60618886",
          "20620424"
        ],
        "code": "73676",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613080",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "50620837",
          "20620834",
          "90620835",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613966",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "80620317",
          "30618859",
          "20618850",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29613971",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "20620400",
          "20620396",
          "00620420"
        ],
        "code": "73680",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614046",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "70620756",
          "90620755",
          "00620420"
        ],
        "code": "73680",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614051",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "90620388",
          "10618898",
          "00620420"
        ],
        "code": "73679",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614065",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "40620833",
          "70620836",
          "00620420"
        ],
        "code": "73679",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614070",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70620860",
          "60620865",
          "10620863",
          "00620420"
        ],
        "code": "73619",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614089",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "70620836",
          "50620837",
          "20620834",
          "00620420"
        ],
        "code": "73661",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614169",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70618857",
          "50618858",
          "00620420"
        ],
        "code": "73677",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614174",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "20620711",
          "40620705",
          "10620698",
          "00620420"
        ],
        "code": "73674",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614193",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620864",
          "50620861",
          "40620866",
          "00620420"
        ],
        "code": "73676",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614206",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "40620404",
          "50620408",
          "30618944",
          "00618931",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614225",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "80620727",
          "60620728",
          "20620725",
          "00620726",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614230",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620755",
          "40620753",
          "20620754",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29614249",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "90620388",
          "10618898",
          "20620424"
        ],
        "code": "73679",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39598668",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "50620837",
          "70620836",
          "20620424"
        ],
        "code": "73680",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613008",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "20620400",
          "30618915",
          "20620424"
        ],
        "code": "73678",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613013",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "80620751",
          "70620756",
          "20620754",
          "20620424"
        ],
        "code": "73619",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613046",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50620861",
          "90620864",
          "10620863",
          "20620424"
        ],
        "code": "73620",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613051",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "50618938",
          "30618939",
          "20620424"
        ],
        "code": "73677",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613065",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70620860",
          "50620861",
          "20620424"
        ],
        "code": "73677",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613070",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "40620404",
          "50620408",
          "30618944",
          "00618931",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613956",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "70620836",
          "50620837",
          "20620834",
          "90620835",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613961",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "70620836",
          "20620834",
          "90620835",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39613975",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "20620400",
          "30618915",
          "00620420"
        ],
        "code": "73678",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614055",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "70620756",
          "80620751",
          "00620420"
        ],
        "code": "73678",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614060",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "70620836",
          "50620837",
          "90620835",
          "00620420"
        ],
        "code": "73618",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614079",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70618857",
          "60620323",
          "20618850",
          "00620420"
        ],
        "code": "73619",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614084",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "30618939",
          "40620404",
          "00618931",
          "00620420"
        ],
        "code": "73620",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614135",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50620724",
          "80620727",
          "00620726",
          "00620420"
        ],
        "code": "73620",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614140",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620388",
          "10620392",
          "10618902",
          "00620420"
        ],
        "code": "73661",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614164",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "60620832",
          "40620833",
          "00620420"
        ],
        "code": "73677",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614178",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40620866",
          "70620860",
          "60620865",
          "00620420"
        ],
        "code": "73674",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614197",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "80620317",
          "50618858",
          "60618886",
          "00620420"
        ],
        "code": "73676",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614201",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20620725",
          "60620728",
          "00620726",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614239",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20620396",
          "00618926",
          "20618911",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39614244",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "10620392",
          "00618894",
          "20620424"
        ],
        "code": "73678",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49612273",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618841",
          "00618894",
          "10620392",
          "20618906",
          "20620424"
        ],
        "code": "73674",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49612715",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "70620756",
          "80620751",
          "20620424"
        ],
        "code": "73678",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613017",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50620861",
          "90620864",
          "20620424"
        ],
        "code": "73679",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613022",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620864",
          "10620863",
          "60620865",
          "20620424"
        ],
        "code": "73618",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613036",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "50618938",
          "50620408",
          "00618931",
          "20620424"
        ],
        "code": "73619",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613041",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "60620752",
          "90620755",
          "20620754",
          "20620424"
        ],
        "code": "73620",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613055",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "80620727",
          "60620728",
          "20620725",
          "20620424"
        ],
        "code": "73661",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613060",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "30620838",
          "60620832",
          "50620837",
          "20620424"
        ],
        "code": "73674",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613079",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620755",
          "60620752",
          "50620757",
          "20620424"
        ],
        "code": "73676",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613084",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "50620408",
          "30618944",
          "00618931",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613965",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20620725",
          "60620728",
          "00620726",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49613970",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "50620408",
          "40620404",
          "00620420"
        ],
        "code": "73680",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614045",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620728",
          "80620727",
          "00620420"
        ],
        "code": "73680",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614050",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "60620752",
          "90620755",
          "00620420"
        ],
        "code": "73679",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614069",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620388",
          "10620392",
          "80618890",
          "00620420"
        ],
        "code": "73618",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614074",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "60620832",
          "50620837",
          "90620835",
          "00620420"
        ],
        "code": "73619",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614088",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620755",
          "70620756",
          "40620753",
          "00620420"
        ],
        "code": "73661",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614168",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "00618894",
          "10618898",
          "20618794",
          "30618798",
          "00620420"
        ],
        "code": "73677",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614173",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "60618886",
          "70618857",
          "60620323",
          "00620420"
        ],
        "code": "73674",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614192",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "70620836",
          "40620833",
          "30620838",
          "00620420"
        ],
        "code": "73676",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614205",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620722",
          "10620698",
          "40620710",
          "20620693",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614229",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "50620408",
          "30618944",
          "00618931",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614234",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "80620727",
          "20620725",
          "00620726",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49614248",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "20620424",
          "90620388",
          "10620392",
          "80618890"
        ],
        "code": "73618",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59598667",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620728",
          "80620727",
          "20620424"
        ],
        "code": "73680",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613007",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "50620408",
          "50618938",
          "20620424"
        ],
        "code": "73678",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613012",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "60620752",
          "90620755",
          "20620424"
        ],
        "code": "73679",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613026",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "60620832",
          "50620837",
          "90620835",
          "20620424"
        ],
        "code": "73619",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59613045",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50618919",
          "20620396",
          "20618911",
          "20620424"
        ],
        "code": "73620",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613050",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "80620751",
          "60620752",
          "20620424"
        ],
        "code": "73677",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613069",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "80618927",
          "30618915",
          "20620400",
          "20620424"
        ],
        "code": "73674",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613074",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "80620317",
          "60620323",
          "30618859",
          "20618850",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613955",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620755",
          "70620756",
          "40620753",
          "20620754",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59613960",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620728",
          "70620723",
          "00620420"
        ],
        "code": "73678",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614059",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50618919",
          "20620396",
          "00620420"
        ],
        "code": "73679",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614064",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620755",
          "70620756",
          "20620754",
          "00620420"
        ],
        "code": "73618",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614078",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "10618775",
          "90620312",
          "00618894",
          "80618890",
          "10620392",
          "00620420"
        ],
        "code": "73619",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614083",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "60620709",
          "90620722",
          "20620693",
          "00620420"
        ],
        "code": "73620",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614139",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "20620396",
          "20620400",
          "00618926",
          "00620420"
        ],
        "code": "73661",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614163",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "80620751",
          "60620752",
          "00620420"
        ],
        "code": "73677",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614177",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "30620838",
          "60620832",
          "50620837",
          "00620420"
        ],
        "code": "73674",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614196",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620388",
          "10618898",
          "20618906",
          "00620420"
        ],
        "code": "73676",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614200",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10620698",
          "40620710",
          "20620693",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614238",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "40620404",
          "30618944",
          "00618931",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59614243",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "20620400",
          "20620396",
          "20620424"
        ],
        "code": "73680",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613002",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "50620837",
          "60620832",
          "20620424"
        ],
        "code": "73678",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613016",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50618919",
          "20620396",
          "20620424"
        ],
        "code": "73679",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613021",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "70620836",
          "50620837",
          "90620835",
          "20620424"
        ],
        "code": "73618",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613035",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70618857",
          "60620323",
          "20618850",
          "20620424"
        ],
        "code": "73619",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613040",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620722",
          "10620698",
          "40620710",
          "20620424"
        ],
        "code": "73661",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613059",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70618857",
          "50618858",
          "20620424"
        ],
        "code": "73677",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613064",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "50620757",
          "80620751",
          "70620756",
          "20620424"
        ],
        "code": "73674",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613078",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620864",
          "50620861",
          "40620866",
          "20620424"
        ],
        "code": "73676",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613083",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "60620865",
          "30620862",
          "10620863",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613969",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620864",
          "30620862",
          "10620863",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69613974",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "10620698",
          "90620722",
          "00620420"
        ],
        "code": "73680",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614049",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "50620408",
          "50618938",
          "00620420"
        ],
        "code": "73678",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614054",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "50620724",
          "80620727",
          "00620420"
        ],
        "code": "73679",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614068",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "20620400",
          "20618911",
          "20620396",
          "00620420"
        ],
        "code": "73618",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614073",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "80620751",
          "70620756",
          "20620754",
          "00620420"
        ],
        "code": "73619",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614087",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "80620727",
          "60620728",
          "20620725",
          "00620420"
        ],
        "code": "73661",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614167",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "30618915",
          "50618919",
          "00620420"
        ],
        "code": "73677",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614172",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618841",
          "00618894",
          "10620392",
          "20618906",
          "00620420"
        ],
        "code": "73674",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614191",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "80620317",
          "60620323",
          "30618859",
          "20618850",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614228",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620864",
          "60620865",
          "30620862",
          "10620863",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614233",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620722",
          "40620710",
          "20620693",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69614247",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "00618894",
          "10618898",
          "20618794",
          "30618798",
          "20620424"
        ],
        "code": "73677",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79612714",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620323",
          "70618857",
          "20620424"
        ],
        "code": "73678",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613011",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "40620833",
          "70620836",
          "20620424"
        ],
        "code": "73679",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613025",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "30618939",
          "40620404",
          "00618931",
          "20620424"
        ],
        "code": "73620",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613049",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "40620833",
          "70620836",
          "90620835",
          "20620424"
        ],
        "code": "73620",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613054",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "60620832",
          "40620833",
          "20620424"
        ],
        "code": "73677",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613068",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40618948",
          "50618938",
          "50620408",
          "20620424"
        ],
        "code": "73674",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613073",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "70620836",
          "40620833",
          "30620838",
          "20620424"
        ],
        "code": "73676",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613087",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "80620727",
          "60620728",
          "20620725",
          "00620726",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613959",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20620400",
          "00618926",
          "20618911",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613964",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620755",
          "40620753",
          "20620754",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79613978",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "10620698",
          "40620705",
          "00620420"
        ],
        "code": "73678",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614058",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "40620404",
          "30618939",
          "00620420"
        ],
        "code": "73679",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614063",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "80620727",
          "60620728",
          "00620726",
          "00620420"
        ],
        "code": "73618",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614077",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "30618915",
          "20620400",
          "20618911",
          "00620420"
        ],
        "code": "73619",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614082",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50618858",
          "80620317",
          "20618850",
          "00620420"
        ],
        "code": "73620",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614138",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50620861",
          "90620864",
          "10620863",
          "00620420"
        ],
        "code": "73620",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614143",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "40620404",
          "50620408",
          "30618944",
          "00620420"
        ],
        "code": "73661",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614162",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "70620723",
          "50620724",
          "00620420"
        ],
        "code": "73677",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614176",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "50620757",
          "80620751",
          "70620756",
          "00620420"
        ],
        "code": "73674",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614195",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620755",
          "60620752",
          "50620757",
          "00620420"
        ],
        "code": "73676",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614204",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "60620323",
          "30618859",
          "20618850",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614237",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "60620865",
          "30620862",
          "10620863",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79614242",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618845",
          "70618796",
          "20620315",
          "20618888",
          "30618883",
          "10620325",
          "20620424"
        ],
        "code": "73674",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79619876",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620388",
          "10618898",
          "20618906",
          "20620424"
        ],
        "code": "73676",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89612718",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620388",
          "10620392",
          "10618902",
          "80618890",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89612723",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "50620408",
          "40620404",
          "20620424"
        ],
        "code": "73680",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613001",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620865",
          "70620860",
          "20620424"
        ],
        "code": "73678",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613015",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "40620404",
          "30618939",
          "20620424"
        ],
        "code": "73679",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613020",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620755",
          "70620756",
          "20620754",
          "20620424"
        ],
        "code": "73618",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613039",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "40620705",
          "10620698",
          "20620693",
          "20620424"
        ],
        "code": "73619",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613044",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "20620396",
          "20620400",
          "00618926",
          "20620424"
        ],
        "code": "73661",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613058",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620864",
          "60620865",
          "30620862",
          "20620424"
        ],
        "code": "73661",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613063",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "40620729",
          "70620723",
          "60620728",
          "20620424"
        ],
        "code": "73674",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613077",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "40620404",
          "30618939",
          "40618948",
          "20620424"
        ],
        "code": "73676",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613082",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "70620756",
          "40620753",
          "20620754",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613968",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20620396",
          "00618926",
          "20618911",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89613973",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620323",
          "80620317",
          "00620420"
        ],
        "code": "73680",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614048",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "60620865",
          "90620864",
          "00620420"
        ],
        "code": "73680",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614053",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "60620709",
          "90620722",
          "00620420"
        ],
        "code": "73679",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614067",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "40620404",
          "50620408",
          "00618931",
          "00620420"
        ],
        "code": "73618",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614072",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "70620723",
          "60620728",
          "00620726",
          "00620420"
        ],
        "code": "73619",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614086",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620722",
          "10620698",
          "40620710",
          "00620420"
        ],
        "code": "73661",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614166",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "50618938",
          "30618939",
          "00620420"
        ],
        "code": "73677",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614171",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "80618927",
          "30618915",
          "20620400",
          "00620420"
        ],
        "code": "73674",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614190",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620388",
          "10620392",
          "10618902",
          "80618890",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614227",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "70620836",
          "50620837",
          "20620834",
          "90620835",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73664",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614232",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "80620317",
          "30618859",
          "20618850",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614246",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620864",
          "30620862",
          "10620863",
          "10618775",
          "90620307",
          "30618802",
          "00620420"
        ],
        "code": "73673",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89614251",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "90620388",
          "10620392",
          "20620424"
        ],
        "code": "73680",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99598670",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "10618898",
          "90620388",
          "80618890",
          "20620424"
        ],
        "code": "73620",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99612690",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "90620312",
          "30618802",
          "90620388",
          "10620392",
          "10618902",
          "20620424"
        ],
        "code": "73661",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99612713",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "10620698",
          "90620722",
          "20620424"
        ],
        "code": "73680",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613005",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "90620307",
          "70620756",
          "90620755",
          "20620424"
        ],
        "code": "73680",
        "cover": "samsala-dark-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613010",
        "rangeId": "uppakra",
        "widthInMillimeters": 2500,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "40620404",
          "50620408",
          "00618931",
          "20620424"
        ],
        "code": "73618",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613034",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "50618858",
          "80620317",
          "20618850",
          "20620424"
        ],
        "code": "73620",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613048",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "60620709",
          "90620722",
          "20620693",
          "20620424"
        ],
        "code": "73620",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613053",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "40620705",
          "60620709",
          "20620424"
        ],
        "code": "73677",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613067",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "10618841",
          "20618794",
          "90620312",
          "60618886",
          "70618857",
          "60620323",
          "20620424"
        ],
        "code": "73674",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613072",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "90620722",
          "60620709",
          "20620711",
          "20620424"
        ],
        "code": "73676",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613086",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620864",
          "60620865",
          "30620862",
          "10620863",
          "10618775",
          "90620307",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73664",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613958",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "60620323",
          "30618859",
          "20618850",
          "10618775",
          "90620312",
          "30618802",
          "20620424"
        ],
        "code": "73672",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613963",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "80620727",
          "20620725",
          "00620726",
          "10618775",
          "90620307",
          "30618802",
          "20620424"
        ],
        "code": "73673",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99613977",
        "rangeId": "uppakra",
        "legs": "chrome-plated"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620323",
          "70618857",
          "00620420"
        ],
        "code": "73678",
        "cover": "johanneshov-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614057",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620312",
          "20618794",
          "60620865",
          "70620860",
          "00620420"
        ],
        "code": "73678",
        "cover": "samsala-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614062",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10618775",
          "90620307",
          "90620312",
          "90620722",
          "10620698",
          "20620693",
          "00620420"
        ],
        "code": "73618",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614076",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "90620312",
          "10618775",
          "50618938",
          "50620408",
          "00618931",
          "00620420"
        ],
        "code": "73619",
        "cover": "axvall-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614081",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "10618898",
          "90620388",
          "80618890",
          "00620420"
        ],
        "code": "73620",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614137",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "30618798",
          "90620307",
          "10618775",
          "40620833",
          "70620836",
          "90620835",
          "00620420"
        ],
        "code": "73620",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614142",
        "rangeId": "uppakra",
        "widthInMillimeters": 3640,
        "legs": "wood"
      },
      {
        "childItems": [
          "20618794",
          "30618798",
          "40620705",
          "60620709",
          "00620420"
        ],
        "code": "73677",
        "cover": "samsala-brown-red",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614175",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "20620396",
          "50618919",
          "80618927",
          "00620420"
        ],
        "code": "73676",
        "cover": "axvall-off-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614199",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "90620307",
          "30618798",
          "10618841",
          "80620727",
          "50620724",
          "40620729",
          "00620420"
        ],
        "code": "73676",
        "cover": "samsala-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614203",
        "rangeId": "uppakra",
        "widthInMillimeters": 2540,
        "legs": "wood"
      },
      {
        "childItems": [
          "10620392",
          "10618902",
          "80618890",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "johanneshov-brown-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614236",
        "rangeId": "uppakra",
        "legs": "wood"
      },
      {
        "childItems": [
          "50620837",
          "20620834",
          "90620835",
          "10618775",
          "90620312",
          "30618802",
          "00620420"
        ],
        "code": "73672",
        "cover": "samsala-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99614241",
        "rangeId": "uppakra",
        "legs": "wood"
      }
    ]
  },
  "uppland": {
    "coverProducts": [
      {
        "itemNo": "00487633",
        "name": "blekinge-white"
      },
      {
        "itemNo": "00529925",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "00547081",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "00557843",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "00557857",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "00557862",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "00560237",
        "name": "kelinge-anthracite"
      },
      {
        "itemNo": "10529864",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10529901",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10530042",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "10557847",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "10557852",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "10560246",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "20547075",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "20557856",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "20557861",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "30529858",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "30529919",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "30530055",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "30547065",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "30557846",
        "name": "kelinge-anthracite"
      },
      {
        "itemNo": "30557851",
        "name": "hillared-beige"
      },
      {
        "itemNo": "40529834",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "40557855",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "40557860",
        "name": "kelinge-anthracite"
      },
      {
        "itemNo": "40560235",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "50487635",
        "name": "blekinge-white"
      },
      {
        "itemNo": "50529876",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "50529937",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "50547069",
        "name": "karlshov-beige-multicolour"
      },
      {
        "itemNo": "50557845",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "50557850",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "60529913",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "60530049",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "60557859",
        "name": "hillared-dark-blue"
      },
      {
        "itemNo": "70487639",
        "name": "with-chaise-longue-blekinge-white"
      },
      {
        "itemNo": "70557849",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "70557854",
        "name": "kelinge-beige"
      },
      {
        "itemNo": "70560234",
        "name": "hillared-beige"
      },
      {
        "itemNo": "70560248",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "80487629",
        "name": "blekinge-white"
      },
      {
        "itemNo": "80529846",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "80529851",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "80529870",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "80529907",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "80557844",
        "name": "hillared-beige"
      },
      {
        "itemNo": "80557858",
        "name": "hillared-beige"
      },
      {
        "itemNo": "80557863",
        "name": "kelinge-rust"
      },
      {
        "itemNo": "90557848",
        "name": "kelinge-grey-turquoise"
      },
      {
        "itemNo": "90557853",
        "name": "kelinge-anthracite"
      },
      {
        "itemNo": "90560233",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "90560247",
        "name": "kelinge-grey-turquoise"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00061.jpg",
        "name": "blekinge-white",
        "dotOverride": "#F5F6FB"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "karlshov-beige-multicolour",
        "dotOverride": [
          "#AF9F92",
          "#4B4746",
          "#EFEAE9",
          "#878381"
        ]
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00116.jpg",
        "name": "kelinge-grey-turquoise",
        "dotOverride": "#54736E"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "kelinge-anthracite"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "kilanda-dark-blue",
        "dotOverride": "#47525F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kelinge-beige"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "hillared-dark-blue",
        "dotOverride": "#3E5564"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "kelinge-rust",
        "dotOverride": "#C38167"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "hakebo-grey-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hillared-beige",
        "dotOverride": "#D4C8B5"
      },
      {
        "name": "karlshov-grey-beige",
        "dotOverride": [
          "#AF9F92",
          "#4B4746",
          "#EFEAE9",
          "#878381"
        ]
      }
    ],
    "displayName": "UPPLAND",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "10472532",
          "10530042"
        ],
        "code": "50272",
        "cover": "kilanda-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09442490",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "30547065"
        ],
        "code": "50265",
        "cover": "karlshov-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09488609",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "50472530",
          "50557850"
        ],
        "code": "50267",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09499957",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "50472530",
          "40557855"
        ],
        "code": "50267",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09499962",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "90557848"
        ],
        "code": "50272",
        "cover": "kelinge-grey-turquoise",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09499976",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "90560233"
        ],
        "code": "50265",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09508184",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "30472531",
          "50487635"
        ],
        "code": "50271",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19384116",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "90472707",
          "50529876"
        ],
        "code": "50265",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19442456",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "30472531",
          "50529937"
        ],
        "code": "50271",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19442480",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "30472531",
          "60557859"
        ],
        "code": "50271",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19499966",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "10472532",
          "00557843"
        ],
        "code": "50272",
        "cover": "hillared-anthracite",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19499971",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "40560235"
        ],
        "code": "50265",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19508188",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "50472530",
          "80529907"
        ],
        "code": "50267",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29442470",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "00547081"
        ],
        "code": "50272",
        "cover": "karlshov-grey-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29488627",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "50472530",
          "70557854"
        ],
        "code": "50267",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29499961",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "10557847"
        ],
        "code": "50272",
        "cover": "kelinge-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29499975",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "40529834"
        ],
        "code": "50265",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39442460",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "30472531",
          "80529851"
        ],
        "code": "50271",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "39442484",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "30472531",
          "80557858"
        ],
        "code": "50271",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39499965",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "30472531",
          "80557863"
        ],
        "code": "50271",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39499970",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "90472707",
          "70560234"
        ],
        "code": "50265",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39508187",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "90472707",
          "80487629"
        ],
        "code": "50265",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49384110",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "50472530",
          "10529901"
        ],
        "code": "50267",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49442474",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "30530055"
        ],
        "code": "50272",
        "cover": "hakebo-grey-green",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49442488",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "50472530",
          "90557853"
        ],
        "code": "50267",
        "cover": "kelinge-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49499960",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30472531",
          "00529925"
        ],
        "code": "50271",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59442478",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "30472531",
          "20547075"
        ],
        "code": "50271",
        "cover": "karlshov-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59488621",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "30472531",
          "00557862"
        ],
        "code": "50271",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59499969",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "10472532",
          "30557846"
        ],
        "code": "50272",
        "cover": "kelinge-anthracite",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59499974",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "90560247"
        ],
        "code": "50265",
        "cover": "kelinge-grey-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59508186",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "50472530",
          "00487633"
        ],
        "code": "50267",
        "cover": "blekinge-white",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69384114",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "90472707",
          "80529870"
        ],
        "code": "50265",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69442454",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "10472532",
          "30529858"
        ],
        "code": "50272",
        "cover": "kilanda-light-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69442492",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "50472530",
          "10557852"
        ],
        "code": "50267",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69499959",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30472531",
          "00557857"
        ],
        "code": "50271",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69499964",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "10472532",
          "70487639"
        ],
        "code": "50272",
        "cover": "blekinge-white",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79384118",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "10529864"
        ],
        "code": "50265",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79442458",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "30472531",
          "30529919"
        ],
        "code": "50271",
        "cover": "kilanda-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79442482",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "50472530",
          "50547069"
        ],
        "code": "50267",
        "cover": "karlshov-grey-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79488615",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30472531",
          "20557861"
        ],
        "code": "50271",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79499968",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "10472532",
          "50557845"
        ],
        "code": "50272",
        "cover": "hillared-dark-blue",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79499973",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "70560248"
        ],
        "code": "50265",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79508185",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "90472707",
          "00560237"
        ],
        "code": "50265",
        "cover": "kelinge-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79508190",
        "rangeId": "uppland"
      },
      {
        "childItems": [
          "50472530",
          "60529913"
        ],
        "code": "50267",
        "cover": "hakebo-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89442472",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "60530049"
        ],
        "code": "50272",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89442486",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "50472530",
          "30557851"
        ],
        "code": "50267",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89499958",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "50472530",
          "20557856"
        ],
        "code": "50267",
        "cover": "kelinge-rust",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89499963",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "10472532",
          "70557849"
        ],
        "code": "50272",
        "cover": "kelinge-rust",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89499977",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "50472530",
          "80529846"
        ],
        "code": "50267",
        "cover": "kilanda-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "99442476",
        "rangeId": "uppland",
        "widthInMillimeters": 1820
      },
      {
        "childItems": [
          "30472531",
          "40557860"
        ],
        "code": "50271",
        "cover": "kelinge-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99499967",
        "rangeId": "uppland",
        "widthInMillimeters": 2240
      },
      {
        "childItems": [
          "10472532",
          "80557844"
        ],
        "code": "50272",
        "cover": "hillared-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99499972",
        "rangeId": "uppland",
        "widthInMillimeters": 2580
      },
      {
        "childItems": [
          "90472707",
          "10560246"
        ],
        "code": "50265",
        "cover": "kelinge-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99508189",
        "rangeId": "uppland"
      }
    ]
  },
  "valnas": {
    "coverProducts": [
      {
        "itemNo": "10624111",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "30624110",
        "name": "alhamn-dark-yellow-brown"
      },
      {
        "itemNo": "50624109",
        "name": "alhamn-dark-grey-blue"
      },
      {
        "itemNo": "70624108",
        "name": "knaback-light-beige"
      },
      {
        "itemNo": "70624113",
        "name": "knaback-light-beige"
      },
      {
        "itemNo": "90624112",
        "name": "alhamn-dark-yellow-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00174.jpg",
        "name": "alhamn-dark-grey-blue",
        "dotOverride": "#83A0A4"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00172.jpg",
        "name": "alhamn-dark-yellow-brown",
        "dotOverride": "#A07756"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "knaback-light-beige"
      }
    ],
    "displayName": "VALNÄS",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "70624108",
          "20624101"
        ],
        "code": "74023",
        "cover": "knaback-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09615320",
        "rangeId": "valnas",
        "widthInMillimeters": 2060
      },
      {
        "childItems": [
          "40624100",
          "90624112"
        ],
        "code": "74024",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "19615329",
        "rangeId": "valnas",
        "widthInMillimeters": 2460
      },
      {
        "childItems": [
          "50624109",
          "20624101"
        ],
        "code": "74023",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "49615323",
        "rangeId": "valnas",
        "widthInMillimeters": 2060
      },
      {
        "childItems": [
          "40624100",
          "10624111"
        ],
        "code": "74024",
        "cover": "alhamn-dark-grey-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "59615332",
        "rangeId": "valnas",
        "widthInMillimeters": 2460
      },
      {
        "childItems": [
          "30624110",
          "20624101"
        ],
        "code": "74023",
        "cover": "alhamn-dark-yellow-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79615326",
        "rangeId": "valnas",
        "widthInMillimeters": 2060
      },
      {
        "childItems": [
          "40624100",
          "70624113"
        ],
        "code": "74024",
        "cover": "knaback-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "89615335",
        "rangeId": "valnas",
        "widthInMillimeters": 2460
      }
    ]
  },
  "vimle": {
    "coverProducts": [
      {
        "itemNo": "00495789",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00495794",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00495812",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "00496114",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "00496152",
        "name": "hallarp-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517258",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517277",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00517282",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00520543",
        "name": "wide-djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "00520557",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "00557942",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "10495784",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10495798",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10495802",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "10495835",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "10495859",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "10496095",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "10496118",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "10496137",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "10496180",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "10496203",
        "name": "hallarp-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517234",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517267",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517272",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517286",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10517309",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10520547",
        "name": "wide-djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10520552",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "10520566",
        "name": "djuparp-dark-green"
      },
      {
        "itemNo": "10557951",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "20495811",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20495849",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "20496085",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "20496113",
        "name": "hallarp-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517224",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517257",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517262",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517276",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517281",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20517304",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20520542",
        "name": "wide-hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "20520561",
        "name": "djuparp-dark-grey"
      },
      {
        "itemNo": "20557955",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "20557984",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "30409988",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30495783",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "30495844",
        "name": "gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30516196",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517233",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517252",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517266",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517271",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517285",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30517308",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30520551",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30520565",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "30520570",
        "name": "lejde-red-brown"
      },
      {
        "itemNo": "40495792",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "40495805",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "40496089",
        "name": "saxemara-light-blue"
      },
      {
        "itemNo": "40496112",
        "name": "saxemara-black-blue"
      },
      {
        "itemNo": "40500048",
        "name": "wide-gunnared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517256",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517261",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517275",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517280",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40517303",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40520541",
        "name": "wide-lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40520555",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "40520560",
        "name": "djuparp-dark-green-blue"
      },
      {
        "itemNo": "40557983",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "50495862",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "50496098",
        "name": "saxemara-light-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50516280",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517227",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517232",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517251",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517265",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517270",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50517307",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50520545",
        "name": "wide-hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "50520569",
        "name": "lejde-grey-black"
      },
      {
        "itemNo": "50557949",
        "name": "djuparp-red-brown"
      },
      {
        "itemNo": "60496111",
        "name": "saxemara-light-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60516246",
        "name": "hillared-dark-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517255",
        "name": "hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517260",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517284",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60517302",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60520540",
        "name": "wide-lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60520559",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "60520564",
        "name": "lejde-grey-black"
      },
      {
        "itemNo": "60557963",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "60557977",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "70410089",
        "name": "gunnared-medium-grey"
      },
      {
        "itemNo": "70496097",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "70496139",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "70496200",
        "name": "hallarp-grey"
      },
      {
        "itemNo": "70500037",
        "name": "wide-hallarp-beige"
      },
      {
        "itemNo": "70501541",
        "name": "wide-gunnared-medium-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517250",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517274",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517288",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70517306",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70520549",
        "name": "wide-hillared-beige"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70520554",
        "name": "djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "70520568",
        "name": "hillared-beige"
      },
      {
        "itemNo": "70557967",
        "name": "djuparp-dark-blue"
      },
      {
        "itemNo": "80495808",
        "name": "gunnared-beige"
      },
      {
        "itemNo": "80496092",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "80496129",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "80496148",
        "name": "hallarp-beige"
      },
      {
        "itemNo": "80496186",
        "name": "hallarp-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517235",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517264",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80517278",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80520544",
        "name": "wide-djuparp-dark-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80520558",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "80520563",
        "name": "hillared-beige"
      },
      {
        "itemNo": "80557938",
        "name": "wide-djuparp-dark-blue"
      },
      {
        "itemNo": "90500036",
        "name": "wide-hallarp-grey"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517225",
        "name": "djuparp-dark-green-blue"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517230",
        "name": "djuparp-dark-green"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517254",
        "name": "hillared-anthracite"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517268",
        "name": "lejde-red-brown"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517287",
        "name": "lejde-grey-black"
      },
      {
        "isIkeaPlus": true,
        "itemNo": "90517310",
        "name": "lejde-red-brown"
      },
      {
        "itemNo": "90557985",
        "name": "djuparp-red-brown"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "gunnared-beige",
        "dotOverride": "#F0E5D5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hallarp-grey",
        "dotOverride": "#5A595C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "lejde-red-brown",
        "dotOverride": "#822C33"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "lejde-grey-black",
        "dotOverride": "#787878"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "djuparp-dark-grey",
        "dotOverride": "#565656"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-green-blue",
        "dotOverride": "#063754"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "djuparp-dark-blue",
        "dotOverride": "#293046"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00140.jpg",
        "name": "grann-bomstad-golden-brown",
        "dotOverride": "#AB7150"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "gunnared-medium-grey",
        "dotOverride": "#646364"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hallarp-beige",
        "dotOverride": "#E8DBC8"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "saxemara-black-blue",
        "dotOverride": "#3C3F44"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "hillared-dark-blue",
        "dotOverride": "#3E5564"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00141.jpg",
        "name": "djuparp-dark-green",
        "dotOverride": "#25372C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "grann-bomstad-black",
        "dotOverride": "#1C1C1C"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hillared-beige",
        "dotOverride": "#D4C8B5"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00023.jpg",
        "name": "saxemara-light-blue",
        "dotOverride": "#AEC5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00155.jpg",
        "name": "djuparp-red-brown",
        "dotOverride": "#692925"
      }
    ],
    "displayName": "VIMLE",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "cover": "",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "60489549",
        "rangeId": "vimle",
        "widthInMillimeters": 1600,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466751",
          "20466743",
          "30466785"
        ],
        "code": "42133",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09306256",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "20465376",
          "70466689"
        ],
        "code": "42130",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09306261",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "80466759"
        ],
        "code": "38155",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09306690",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465369",
          "50465351",
          "20465376"
        ],
        "code": "38158",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09306708",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "30466766",
          "50466713",
          "40466780"
        ],
        "code": "48424",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09306732",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "40496089",
          "60496111"
        ],
        "code": "38148",
        "cover": "saxemara-light-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09399019",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "70410089",
          "10488793",
          "50489494",
          "10495798",
          "40495792"
        ],
        "code": "42133",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09399024",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "70489488",
          "30498116",
          "20397127",
          "60500047",
          "70495781",
          "30495815",
          "60410042"
        ],
        "code": "55105",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "09399104",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "20496113",
          "10495859",
          "80496129",
          "80496148"
        ],
        "code": "38153",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09399670",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "30489490",
          "90500036",
          "70496097",
          "00496152"
        ],
        "code": "55166",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09401772",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "10488793",
          "50495862",
          "90500036",
          "10496118",
          "70496097"
        ],
        "code": "55083",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09401809",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "40500048",
          "30495783",
          "10495802",
          "00495812"
        ],
        "code": "55081",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09401828",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "70520554",
          "80520544"
        ],
        "code": "55101",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432679",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "40517280",
          "50517270",
          "30520551",
          "10520547"
        ],
        "code": "55105",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09432684",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "80520563",
          "70520549"
        ],
        "code": "55099",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09432764",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "40520555",
          "20517276",
          "50520545"
        ],
        "code": "55166",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09432778",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "30520570",
          "80517278",
          "40520541"
        ],
        "code": "55166",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09432815",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30520551",
          "70517250"
        ],
        "code": "38148",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09433594",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "50517251",
          "70520554",
          "00517282"
        ],
        "code": "42133",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09433607",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "70520568",
          "40517275",
          "60517255"
        ],
        "code": "38158",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09434273",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "20517276",
          "50489494",
          "30489490",
          "50517227",
          "10520552",
          "40517256"
        ],
        "code": "38153",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "09434353",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "90489492",
          "70489488",
          "20397127",
          "40468755",
          "60516246",
          "40515969",
          "30516196"
        ],
        "code": "42130",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "09434367",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40517275",
          "80498114",
          "30489490",
          "50517232",
          "80520563",
          "70520549"
        ],
        "code": "55081",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09436719",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40520560",
          "10488793",
          "80498114",
          "90517225",
          "80520558",
          "00520543"
        ],
        "code": "55083",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09436781",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "40520555",
          "10517286",
          "40517256"
        ],
        "code": "42133",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09441160",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60466699",
          "00417621",
          "70465369",
          "10568638"
        ],
        "code": "44672",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09477333",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466789",
          "50466713",
          "00417621",
          "50466751",
          "10568638"
        ],
        "code": "48437",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09477366",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "80466702",
          "40465219",
          "50417930",
          "50465370",
          "90568639"
        ],
        "code": "48437",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09477371",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50498115",
          "60488795",
          "10557989",
          "30557945"
        ],
        "code": "55101",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09501408",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "90516198",
          "40515974",
          "10557649"
        ],
        "code": "38149",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09508358",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "30498116",
          "90488794",
          "10516300",
          "40515974",
          "10557649",
          "60515987"
        ],
        "code": "55083",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "09508363",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "50498115",
          "40557978",
          "30557945",
          "50568641",
          "00417621",
          "50489489",
          "80557962"
        ],
        "code": "55313",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "09515995",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "70517306",
          "70517274",
          "90517254"
        ],
        "code": "44674",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09536945",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "50517307",
          "40517275",
          "60517255"
        ],
        "code": "44674",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09536974",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "50489494",
          "00496114",
          "80496186"
        ],
        "code": "44672",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09537030",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "10496180",
          "20496113",
          "10496137"
        ],
        "code": "44673",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09537054",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "80498114",
          "30517271",
          "20517224",
          "20520561",
          "20517304",
          "80520544",
          "10568638"
        ],
        "code": "55335",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09537247",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "00520543",
          "40517303",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09537266",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "20517304",
          "30517271",
          "80520544"
        ],
        "code": "55313",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09537271",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "20495849",
          "10495798",
          "10495784",
          "40495805",
          "10495835"
        ],
        "code": "44671",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09545266",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "20495849",
          "50489494",
          "10495798"
        ],
        "code": "44672",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09545271",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "50517307",
          "40517275",
          "70520549"
        ],
        "code": "55313",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09562128",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "50498115",
          "00557961",
          "70557986",
          "10557946"
        ],
        "code": "55104",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "09576187",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "80466759",
          "30466785"
        ],
        "code": "42130",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19306265",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466751",
          "30466766",
          "50466713",
          "40466780"
        ],
        "code": "48421",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19306760",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "40465380",
          "60465218",
          "60465384",
          "70465369"
        ],
        "code": "48458",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19306784",
        "rangeId": "vimle",
        "widthInMillimeters": 3270,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10488793",
          "50489494",
          "00495789",
          "00495794"
        ],
        "code": "38151",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19399033",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40496112",
          "10496095"
        ],
        "code": "38151",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19399052",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "20496113",
          "10495859",
          "80496148"
        ],
        "code": "38155",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19399127",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "10495798",
          "40495792",
          "10495835"
        ],
        "code": "38158",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19399486",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "50495862",
          "00496114",
          "10496118"
        ],
        "code": "38149",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19399504",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "10488793",
          "00495794",
          "30495783",
          "10495802",
          "00495789"
        ],
        "code": "38156",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19399575",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "70501541",
          "40495792"
        ],
        "code": "55101",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19401333",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "70500037",
          "10495859",
          "80496129"
        ],
        "code": "55160",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19401781",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "70500037",
          "10495859",
          "80496129",
          "80496148"
        ],
        "code": "55081",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19401818",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "80520558",
          "00520543"
        ],
        "code": "55099",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432674",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "40520560",
          "10517272",
          "00520543"
        ],
        "code": "55166",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19432688",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "60520559",
          "20520542"
        ],
        "code": "55101",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432768",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "30517285",
          "40517275",
          "80520563",
          "70520549"
        ],
        "code": "55105",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19432773",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "60520564",
          "60520540"
        ],
        "code": "55099",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432805",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "30520570",
          "40520541"
        ],
        "code": "55101",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19432810",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40520560",
          "30517252"
        ],
        "code": "38151",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19433598",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "40517280",
          "50517270",
          "30520551",
          "70517250"
        ],
        "code": "42130",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19433602",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "50517251",
          "20517224",
          "20520561"
        ],
        "code": "38149",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434135",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "50517270",
          "90517230",
          "30520551",
          "70517250"
        ],
        "code": "38153",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19434140",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "60520559",
          "60517284",
          "90517254"
        ],
        "code": "42133",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434277",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "80520563",
          "60517255"
        ],
        "code": "38148",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434282",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40520555",
          "10488793",
          "50489494",
          "50517227",
          "10520552",
          "40517256"
        ],
        "code": "38156",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434357",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "50517232",
          "80520563",
          "60517255"
        ],
        "code": "38149",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434362",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "20517257",
          "50520569",
          "90517287"
        ],
        "code": "42133",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434395",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10488793",
          "50489494",
          "20517257",
          "60520564",
          "30517233",
          "50520569"
        ],
        "code": "38156",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19434456",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40520555",
          "10488793",
          "80498114",
          "50517227",
          "10520552",
          "50520545"
        ],
        "code": "55083",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19436653",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10488793",
          "80498114",
          "40520541",
          "30520565",
          "10517234",
          "30520570"
        ],
        "code": "55083",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19436733",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10517272",
          "80498114",
          "30489490",
          "90517225",
          "80520558",
          "00520543"
        ],
        "code": "55081",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19436785",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20465220",
          "00417621",
          "80465378",
          "30465371",
          "50568641"
        ],
        "code": "48440",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "19477356",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "50498115",
          "40557978",
          "30557945",
          "50568641",
          "00417621"
        ],
        "code": "55312",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19501380",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70489493",
          "60488795",
          "10557989",
          "20557941"
        ],
        "code": "38151",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19501399",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50498115",
          "60488795",
          "20557984",
          "80557938"
        ],
        "code": "55101",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19501648",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "90488765",
          "30498116",
          "10488806",
          "90516297",
          "50515959",
          "70557646"
        ],
        "code": "55160",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19508268",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "30498116",
          "90488794",
          "90516297",
          "50515959",
          "70557646",
          "00515985"
        ],
        "code": "55083",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "19508273",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "60557963",
          "40557983",
          "50498115",
          "80557938"
        ],
        "code": "55104",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19515947",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60488795",
          "20557984",
          "50498115",
          "40411962",
          "70557967",
          "80557938"
        ],
        "code": "55100",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19515952",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "40411962",
          "80557962",
          "50557968",
          "90557985",
          "50498115",
          "30557945"
        ],
        "code": "55105",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19515985",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "70517306",
          "20520542",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19536959",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50517307",
          "40517275",
          "50489494",
          "10568638",
          "50517232",
          "80520563",
          "60517255"
        ],
        "code": "44671",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19536983",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "80496186",
          "90500036",
          "50495862",
          "10496118",
          "00496152"
        ],
        "code": "55335",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19537020",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "80498114",
          "10568638",
          "80496186",
          "90500036",
          "70496139"
        ],
        "code": "55314",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19537096",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "40517303",
          "30517252"
        ],
        "code": "44672",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19537256",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "40517303",
          "10517272",
          "30517252"
        ],
        "code": "44674",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19537275",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "10517309",
          "60520540",
          "60520564",
          "30517233",
          "00517277"
        ],
        "code": "55335",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19537280",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "90517310",
          "00517258",
          "30520565",
          "10517234",
          "80517278"
        ],
        "code": "44671",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19537548",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "90517310",
          "80517278",
          "40520541"
        ],
        "code": "55313",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "19537553",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "30495844",
          "80498114",
          "40500048"
        ],
        "code": "55312",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19545204",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "30495844",
          "00495794",
          "00495812"
        ],
        "code": "44674",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "19545242",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "00417621",
          "50489489",
          "70489493",
          "50568641",
          "60557977",
          "00557942",
          "60557963"
        ],
        "code": "44674",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19569394",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "40465380",
          "60465218",
          "60465384",
          "70466689"
        ],
        "code": "48423",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29306284",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "60465384"
        ],
        "code": "48447",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29306665",
        "rangeId": "vimle",
        "widthInMillimeters": 2270,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466751",
          "20466743",
          "80466759"
        ],
        "code": "38158",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29306712",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "30466766",
          "50466713",
          "40466780",
          "50466751"
        ],
        "code": "48458",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29306788",
        "rangeId": "vimle",
        "widthInMillimeters": 3270,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "00496114",
          "70496097"
        ],
        "code": "38151",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29399042",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "40397126",
          "00495794",
          "30495783",
          "00495812",
          "30409988",
          "30489490"
        ],
        "code": "42130",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29399103",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "00495794",
          "30495783",
          "10495802"
        ],
        "code": "38149",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29399476",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "50495862",
          "90500036"
        ],
        "code": "55099",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29400564",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40500048",
          "30495783",
          "00495812"
        ],
        "code": "55104",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29401295",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "50495862",
          "90500036",
          "00496152"
        ],
        "code": "55104",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29401422",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "30489490",
          "70501541",
          "40495792",
          "10495835"
        ],
        "code": "55166",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29401766",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "10520566",
          "40517280",
          "10520547"
        ],
        "code": "55100",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29432678",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "00517282",
          "30517271",
          "20520561",
          "80520544"
        ],
        "code": "55105",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29432683",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "10520552",
          "50520545"
        ],
        "code": "55099",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "29432763",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "60520559",
          "70517274",
          "20520542"
        ],
        "code": "55166",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29432777",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "10520566",
          "40517280",
          "70517250"
        ],
        "code": "42133",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29433606",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "10520566",
          "50517270",
          "70517250"
        ],
        "code": "38158",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29433611",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "70489488",
          "90489492",
          "60516246",
          "40515969",
          "30516196"
        ],
        "code": "38155",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "29434366",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70520568",
          "10488793",
          "80498114",
          "50517232",
          "80520563",
          "70520549"
        ],
        "code": "55083",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29436718",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10520566",
          "10488793",
          "80498114",
          "90517230",
          "30520551",
          "10520547"
        ],
        "code": "55083",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29436780",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10520552",
          "50489494",
          "30489490",
          "20517276",
          "40488763",
          "40517256"
        ],
        "code": "38155",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29441159",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90466805",
          "90466730",
          "50417930",
          "30466752",
          "90568639"
        ],
        "code": "48437",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29477365",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60466699",
          "60465218",
          "00417621",
          "70465369",
          "70568640"
        ],
        "code": "48437",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "29477370",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "50498115",
          "30557945",
          "50557949",
          "90557985"
        ],
        "code": "55160",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29501271",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "10557989",
          "60488795",
          "50498115",
          "30557945",
          "50557949",
          "90557985"
        ],
        "code": "55083",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29501285",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "50498115",
          "90557985",
          "30557945"
        ],
        "code": "55099",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29501394",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "30498116",
          "70489488",
          "10516300",
          "40515974",
          "10557649",
          "20516248"
        ],
        "code": "55081",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "29508362",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50517307",
          "40517275",
          "80498114",
          "10568638",
          "50517232",
          "80520563",
          "70520549"
        ],
        "code": "55335",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29536973",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "10496180",
          "20496113",
          "10495859",
          "80496129",
          "80496148"
        ],
        "code": "44671",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29537005",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "80498114",
          "90500036",
          "80496186"
        ],
        "code": "55312",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29537048",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "80496186",
          "00496114",
          "00496152"
        ],
        "code": "44674",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29537072",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "80498114",
          "10568638",
          "80496186",
          "90500036",
          "00496152"
        ],
        "code": "55313",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29537086",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "40517303",
          "50489494",
          "10517272",
          "10568638",
          "90517225",
          "80520558",
          "30517252"
        ],
        "code": "44671",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29537251",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "40517303",
          "10517272",
          "00520543"
        ],
        "code": "55313",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29537270",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "10517309",
          "20517257",
          "10517267"
        ],
        "code": "44673",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29537289",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "10517309",
          "10517267",
          "60520540"
        ],
        "code": "55314",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29537294",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "70517306",
          "80517264",
          "20520542"
        ],
        "code": "55314",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29542667",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "70517306",
          "20520542",
          "00520557",
          "80517235",
          "70517274"
        ],
        "code": "55335",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29544218",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "20495849",
          "80498114",
          "70501541"
        ],
        "code": "55312",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29545251",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "40465380",
          "20465376"
        ],
        "code": "38153",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39306764",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "30409988",
          "10488793",
          "50489494",
          "00495789",
          "00495794"
        ],
        "code": "42133",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39399027",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "70489488",
          "90489492",
          "20397127",
          "80495785",
          "90495799",
          "60495833",
          "50410090"
        ],
        "code": "42130",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "39399107",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "50489494",
          "10495784",
          "10495798",
          "10495835"
        ],
        "code": "38155",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39399112",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "10495784",
          "10495798",
          "40495805",
          "10495835"
        ],
        "code": "38153",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39399584",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "10488793",
          "20496113",
          "10495859",
          "80496129",
          "80496092"
        ],
        "code": "38156",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39399659",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "10488793",
          "50495862",
          "00496114",
          "10496118",
          "70496097"
        ],
        "code": "38156",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39399664",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "10488793",
          "80498114",
          "70410089",
          "70501541",
          "40495792"
        ],
        "code": "55100",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39401327",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "10488793",
          "40500048",
          "30495783",
          "10495802",
          "00495789"
        ],
        "code": "55083",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39401799",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "10488793",
          "10495784",
          "70501541",
          "40495805",
          "40495792"
        ],
        "code": "55083",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39401803",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "20520561",
          "80520544"
        ],
        "code": "55099",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432673",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "50517270",
          "30520551",
          "10520547"
        ],
        "code": "55104",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39432687",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "70520568",
          "30517285",
          "70520549"
        ],
        "code": "55100",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432767",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "10517286",
          "20517276",
          "10520552",
          "50520545"
        ],
        "code": "55105",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39432772",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "50520569",
          "60520540"
        ],
        "code": "55101",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39432809",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "00517277",
          "60520564",
          "60520540"
        ],
        "code": "55104",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39432814",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "10520566",
          "70517250"
        ],
        "code": "38151",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39433597",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "30517271",
          "00517282",
          "20520561",
          "50517251"
        ],
        "code": "42130",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39433601",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "30517271",
          "20517224",
          "20520561",
          "50517251"
        ],
        "code": "38153",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39434139",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "80520563",
          "40517275",
          "60517255"
        ],
        "code": "38155",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39434276",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "60520559",
          "90517254"
        ],
        "code": "38151",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39434281",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "50517227",
          "10520552",
          "40517256"
        ],
        "code": "38149",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39434361",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "20517257",
          "60520564",
          "00517277",
          "90517287"
        ],
        "code": "42130",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39434399",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "20517257",
          "60520564"
        ],
        "code": "38148",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39434403",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10488793",
          "50489494",
          "00517258",
          "30520565",
          "10517234",
          "30520570"
        ],
        "code": "38156",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39434455",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "50517227",
          "10520552",
          "50520545"
        ],
        "code": "55160",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39436652",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "60520559",
          "30488805",
          "10488793",
          "80498114",
          "80517235",
          "00520557",
          "20520542"
        ],
        "code": "55083",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39436690",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10488793",
          "80498114",
          "60520540",
          "60520564",
          "30517233",
          "50520569"
        ],
        "code": "55083",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39436732",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "10557989",
          "60488795",
          "70489493",
          "20557941",
          "50557949",
          "90557985"
        ],
        "code": "38156",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39501275",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "20488764",
          "90488807",
          "50489489",
          "00417621",
          "70489493",
          "80557962",
          "50557949",
          "90557985",
          "40557978",
          "20557941",
          "50568641"
        ],
        "code": "44671",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39501299",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "70489493",
          "50489489",
          "60557963",
          "10557951",
          "40557983",
          "00557942"
        ],
        "code": "38153",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39501609",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70489493",
          "60488795",
          "20557984",
          "00557942"
        ],
        "code": "38151",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39501647",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "50516195",
          "50515959",
          "70557646"
        ],
        "code": "38149",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "39508267",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "70489488",
          "50516195",
          "50515959",
          "70557646",
          "80516245"
        ],
        "code": "38153",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "39508272",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "40411962",
          "60557963",
          "70557967",
          "40557983",
          "50498115",
          "80557938"
        ],
        "code": "55105",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39515946",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60488795",
          "50489489",
          "20557984",
          "60557963",
          "50498115",
          "80557938"
        ],
        "code": "55166",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39515951",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40489550",
          "00417621",
          "70489493",
          "50568641",
          "40557978",
          "20557941",
          "50489489",
          "80557962"
        ],
        "code": "44674",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39515994",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "50517307",
          "70520549",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39536958",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "10496180",
          "70500037",
          "10495859",
          "80496129",
          "80496148"
        ],
        "code": "55335",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39537019",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "60517302",
          "70517250"
        ],
        "code": "44672",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39537255",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10517309",
          "50489494",
          "10568638",
          "20517257"
        ],
        "code": "44672",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39537284",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "90517310",
          "40520541",
          "30520565",
          "10517234",
          "80517278"
        ],
        "code": "55335",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39537547",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "90517310",
          "00517258",
          "90517268"
        ],
        "code": "44673",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39537552",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20489551",
          "10488806",
          "90488765",
          "70489488",
          "50417930",
          "30498116",
          "90568639",
          "70495842",
          "60500047",
          "70495781",
          "50495800",
          "30495815"
        ],
        "code": "55335",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "39545199",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "30495844",
          "40500048",
          "30495783",
          "10495802",
          "00495812"
        ],
        "code": "55335",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "39545203",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "30495844",
          "00495794",
          "80495808"
        ],
        "code": "44673",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39545236",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "20488764",
          "90488807",
          "50489489",
          "00417621",
          "50498115",
          "50568641",
          "60557977",
          "80557938",
          "40557983",
          "10557951",
          "60557963"
        ],
        "code": "55335",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39569388",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40489550",
          "60488762",
          "00417621",
          "70489493",
          "50568641",
          "60557977",
          "00557942",
          "20557955"
        ],
        "code": "44673",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39569393",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751"
        ],
        "code": "38148",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49306297",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "40466780"
        ],
        "code": "48447",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49306669",
        "rangeId": "vimle",
        "widthInMillimeters": 2270,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "30466766",
          "80466759"
        ],
        "code": "38153",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49306768",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "10495784",
          "50489494",
          "10495798"
        ],
        "code": "38148",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49398975",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "70496200",
          "10488793",
          "50489494",
          "00496114",
          "70496097"
        ],
        "code": "42133",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49399036",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "20496113",
          "10495859",
          "80496148",
          "10496203"
        ],
        "code": "42130",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49399121",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "20496113",
          "80496092",
          "80496148"
        ],
        "code": "38158",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49399507",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "10495784",
          "70501541",
          "40495805",
          "10495835"
        ],
        "code": "55081",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49401831",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "70520554",
          "00517282",
          "80520544"
        ],
        "code": "55100",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432677",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "20517281",
          "10517272",
          "80520558",
          "00520543"
        ],
        "code": "55105",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49432682",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "00520557",
          "20520542"
        ],
        "code": "55099",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49432762",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "40517275",
          "80520563",
          "70520549"
        ],
        "code": "55104",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49432776",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "50517270",
          "30520551",
          "70517250"
        ],
        "code": "38155",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49433605",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "50517251",
          "70520554",
          "30517271"
        ],
        "code": "38158",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49433610",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "90517225",
          "80520558",
          "30517252"
        ],
        "code": "38149",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49434134",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488794",
          "90489492",
          "20397127",
          "90515981",
          "40468755",
          "30516196"
        ],
        "code": "42133",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49434365",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "00517258",
          "30520570",
          "70517288"
        ],
        "code": "42133",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49434394",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "50517232",
          "80520563",
          "70520549"
        ],
        "code": "55160",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49436717",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "80520544",
          "20517224",
          "20520561"
        ],
        "code": "55160",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49436779",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "30517271",
          "20517224",
          "20520561",
          "80520544"
        ],
        "code": "55081",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49436784",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "60517284",
          "70517274",
          "00520557",
          "90517254"
        ],
        "code": "42130",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49441035",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10520552",
          "50489494",
          "30489490",
          "40397126",
          "10517286",
          "20517276",
          "40488763",
          "40517256"
        ],
        "code": "42130",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49441158",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20465220",
          "90466706",
          "00417621",
          "30465371",
          "50568641"
        ],
        "code": "48437",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "49477369",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "20557941",
          "90557985"
        ],
        "code": "38148",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49501393",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70489493",
          "60488795",
          "50489489",
          "20557941",
          "10557989",
          "80557962"
        ],
        "code": "38158",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49501411",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "70489488",
          "90516198",
          "40515974",
          "10557649",
          "20516248"
        ],
        "code": "38153",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "49508361",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "80557962",
          "90557985",
          "30557945",
          "50498115"
        ],
        "code": "55104",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49515984",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "30517308",
          "50520545",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49536953",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "80496186",
          "00496114",
          "50495862",
          "10496118",
          "00496152"
        ],
        "code": "44671",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49537009",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "10496180",
          "20496113",
          "80496148"
        ],
        "code": "44674",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49537066",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "80498114",
          "10568638",
          "10496180",
          "70500037",
          "10496137"
        ],
        "code": "55314",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49537090",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "20517304",
          "40517261",
          "50517251"
        ],
        "code": "44673",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49537269",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "60517302",
          "50517270",
          "70517250"
        ],
        "code": "44674",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49537274",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "50517307",
          "50517265",
          "70520549"
        ],
        "code": "55314",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49542666",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "80498114",
          "10568638",
          "70517306",
          "70517274",
          "20520542"
        ],
        "code": "55313",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49555512",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "70569885",
          "30517308",
          "20517276",
          "40517256"
        ],
        "code": "44674",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "49562126",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369"
        ],
        "code": "38148",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59306292",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10488793",
          "50489494",
          "80496092",
          "20496113"
        ],
        "code": "38151",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59399045",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "40397126",
          "10495784",
          "10495798",
          "10495835",
          "70410089",
          "30489490"
        ],
        "code": "42130",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59399106",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "50495862",
          "00496114",
          "00496152"
        ],
        "code": "38155",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59399130",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "10488793",
          "10495784",
          "10495798",
          "40495805",
          "40495792"
        ],
        "code": "38156",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59399578",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "70500037",
          "10495859",
          "80496148",
          "10496203"
        ],
        "code": "55105",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59401411",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40397126",
          "10496203",
          "10488793",
          "80498114",
          "80496092",
          "70500037"
        ],
        "code": "55100",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59401425",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "80496092",
          "70500037"
        ],
        "code": "55101",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59401430",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "50495862",
          "90500036",
          "10496118"
        ],
        "code": "55160",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59401784",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "50495862",
          "90500036",
          "10496118",
          "00496152"
        ],
        "code": "55081",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59401821",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "30517271",
          "20520561",
          "80520544"
        ],
        "code": "55104",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59432686",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "20517276",
          "50517227",
          "10520552",
          "50520545"
        ],
        "code": "55081",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59432733",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "60520559",
          "60517284",
          "20520542"
        ],
        "code": "55100",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59432766",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "60517284",
          "70517274",
          "00520557",
          "20520542"
        ],
        "code": "55105",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59432771",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "30520570",
          "70517288",
          "40520541"
        ],
        "code": "55100",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59432808",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "80517278",
          "30520565",
          "40520541"
        ],
        "code": "55104",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59432813",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "50517251",
          "20520561"
        ],
        "code": "38148",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59433596",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "20517281",
          "10517272",
          "80520558",
          "30517252"
        ],
        "code": "42130",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59433600",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70520554",
          "10488793",
          "50489494",
          "50517251",
          "20517224",
          "20520561"
        ],
        "code": "38156",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59434138",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "70520568",
          "30517285",
          "60517255"
        ],
        "code": "42133",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59434275",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "70520568",
          "60517255"
        ],
        "code": "38151",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59434280",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70517274",
          "50489494",
          "30489490",
          "80517235",
          "00520557",
          "90517254"
        ],
        "code": "38153",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59434355",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "00517258",
          "30520565",
          "80517278",
          "70517288"
        ],
        "code": "42130",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59434398",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "00517258",
          "30520565"
        ],
        "code": "38148",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59434402",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "80517235",
          "00520557",
          "20520542"
        ],
        "code": "55160",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59436689",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "40520541",
          "30520565",
          "10517234"
        ],
        "code": "55160",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59436731",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60466699",
          "00417621",
          "20465376",
          "70465369",
          "10568638"
        ],
        "code": "44674",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59477359",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "50489489",
          "40411962",
          "80557962",
          "50557968",
          "90557985",
          "20557941"
        ],
        "code": "42130",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59501401",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "20557984",
          "60488795",
          "70489493",
          "00557942",
          "10557951",
          "40557983"
        ],
        "code": "38156",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59501608",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "50498115",
          "40557983",
          "80557938"
        ],
        "code": "55099",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59501646",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70489493",
          "60488795",
          "50489489",
          "00557942",
          "20557984",
          "60557963"
        ],
        "code": "38158",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59501651",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "30498116",
          "70489488",
          "90516297",
          "50515959",
          "70557646",
          "80516245"
        ],
        "code": "55081",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "59508271",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "70517306",
          "80517264",
          "90517254"
        ],
        "code": "44673",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59536976",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "50489494",
          "20496113",
          "10496180"
        ],
        "code": "44672",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537023",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "80498114",
          "10496180",
          "70500037"
        ],
        "code": "55312",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537042",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "60517302",
          "10520547",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537264",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "40517303",
          "20517262",
          "00520543"
        ],
        "code": "55314",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537278",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "90517310",
          "40520541",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59537551",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40489550",
          "20488764",
          "90488807",
          "50489489",
          "00417621",
          "50498115",
          "50568641",
          "50495843",
          "80500051",
          "50495782",
          "30495801",
          "60495814"
        ],
        "code": "55335",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "59545202",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "20488764",
          "90488807",
          "50489489",
          "00417621",
          "70489493",
          "50568641",
          "60557977",
          "00557942",
          "40557983",
          "10557951",
          "60557963"
        ],
        "code": "44671",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59569387",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "00417621",
          "50568641",
          "40489550",
          "60557977",
          "50498115",
          "80557938"
        ],
        "code": "55312",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "59569392",
        "rangeId": "vimle",
        "widthInMillimeters": 2040,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "40465380",
          "50465351"
        ],
        "code": "38156",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69306748",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "50495862",
          "00496114"
        ],
        "code": "38148",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69399002",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "40496112",
          "20496085"
        ],
        "code": "38148",
        "cover": "saxemara-black-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69399016",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "10495784",
          "10495798",
          "40495805"
        ],
        "code": "38149",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69399479",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30495783",
          "80498114",
          "40500048"
        ],
        "code": "55099",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "69400543",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "10495784",
          "70501541",
          "10495835",
          "70410089"
        ],
        "code": "55105",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69401298",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "40500048",
          "30495783",
          "00495812",
          "30409988"
        ],
        "code": "55105",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69401302",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "00495789",
          "40500048"
        ],
        "code": "55101",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69401335",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "30489490",
          "70500037",
          "80496092",
          "80496148"
        ],
        "code": "55166",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69401769",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30488805",
          "40500048",
          "30495783",
          "10495802"
        ],
        "code": "55160",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69401793",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "10488793",
          "70500037",
          "10495859",
          "80496129",
          "80496092"
        ],
        "code": "55083",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69401806",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "40520560",
          "20517281",
          "00520543"
        ],
        "code": "55100",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432676",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "10520566",
          "10520547"
        ],
        "code": "55101",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69432681",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "70517274",
          "00520557",
          "20520542"
        ],
        "code": "55104",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69432775",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "40520560",
          "10517272",
          "30517252"
        ],
        "code": "38158",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69433609",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "90517230",
          "30520551",
          "70517250"
        ],
        "code": "38149",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69434133",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "20517257",
          "50520569",
          "00517277"
        ],
        "code": "38158",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69434393",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "20517257",
          "60520564",
          "30517233",
          "00517277"
        ],
        "code": "38153",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69434454",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "40520541",
          "30520565",
          "10517234",
          "80517278"
        ],
        "code": "55081",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69436735",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "90517225",
          "80520558",
          "00520543"
        ],
        "code": "55160",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69436778",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "50517270",
          "90517230",
          "30520551",
          "10520547"
        ],
        "code": "55081",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69436783",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40520555",
          "40517256"
        ],
        "code": "38151",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69441157",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466789",
          "10466734",
          "30466766",
          "00417621",
          "80466759",
          "50466751",
          "10568638"
        ],
        "code": "44671",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69477373",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "70489493",
          "20557941",
          "50557949",
          "90557985"
        ],
        "code": "38149",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69501269",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "50489489",
          "80557962",
          "90557985",
          "20557941"
        ],
        "code": "38155",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69501405",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "90488794",
          "90516198",
          "40515974",
          "10557649",
          "60515987"
        ],
        "code": "38156",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "69508360",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50498115",
          "60488795",
          "10557989",
          "30557945",
          "40411962",
          "50557968"
        ],
        "code": "55100",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69515983",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "40517256",
          "30517308"
        ],
        "code": "44672",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69536971",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "30517271",
          "20517224",
          "20520561",
          "20517304",
          "50517251",
          "10568638"
        ],
        "code": "44671",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69537249",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "40517303",
          "20517262",
          "30517252"
        ],
        "code": "44673",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69537268",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "20517304",
          "30517271",
          "50517251"
        ],
        "code": "44674",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69537273",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "10517309",
          "60520540",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69537287",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "10517309",
          "20517257",
          "00517277"
        ],
        "code": "44674",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69537292",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "90517310",
          "90517268",
          "40520541"
        ],
        "code": "55314",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69537555",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "30517308",
          "30517266",
          "50520545"
        ],
        "code": "55314",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69542665",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "30495844",
          "00495794",
          "30495783",
          "10495802",
          "00495812"
        ],
        "code": "44671",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69545225",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "80498114",
          "10568638",
          "20495849",
          "70501541",
          "10495784",
          "40495805",
          "10495835"
        ],
        "code": "55335",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69545249",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "80498114",
          "10568638",
          "20495849",
          "70501541",
          "10495835"
        ],
        "code": "55313",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "69545287",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40489550",
          "60488762",
          "00417621",
          "50498115",
          "50568641",
          "60557977",
          "80557938",
          "20557955"
        ],
        "code": "55314",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "69569396",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "40465380"
        ],
        "code": "38149",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79306719",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "10495798",
          "40495792"
        ],
        "code": "38151",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "79399030",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10488793",
          "50489494",
          "50496098",
          "60496111"
        ],
        "code": "38151",
        "cover": "saxemara-light-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79399049",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "50489489",
          "50498115",
          "40411962",
          "80500051",
          "50495782",
          "60495814",
          "90410045"
        ],
        "code": "55105",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79399105",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "20496113",
          "10495859",
          "80496129"
        ],
        "code": "38149",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79399501",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "50495862",
          "00496114",
          "10496118",
          "00496152"
        ],
        "code": "38153",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79399676",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "10488793",
          "80498114",
          "30409988",
          "00495789",
          "40500048"
        ],
        "code": "55100",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79401330",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40397126",
          "70496200",
          "10488793",
          "80498114",
          "90500036",
          "70496097"
        ],
        "code": "55100",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79401429",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20489551",
          "50417930",
          "90568639",
          "70489488",
          "90489492",
          "50516280",
          "60516246",
          "30516196"
        ],
        "code": "44674",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79421494",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488794",
          "90489492",
          "70489488",
          "90515981",
          "60516246",
          "30516196"
        ],
        "code": "38158",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79421502",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20489551",
          "50417930",
          "90568639",
          "70489488",
          "30498116",
          "50516280",
          "60516246",
          "70516302"
        ],
        "code": "55346",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79421615",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "10517272",
          "80520558",
          "00520543"
        ],
        "code": "55104",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79432685",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "70520554",
          "30517271",
          "80520544"
        ],
        "code": "55166",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79432690",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "40520555",
          "10517286",
          "50520545"
        ],
        "code": "55100",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432765",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "70520568",
          "70520549"
        ],
        "code": "55101",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432770",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "40397126",
          "50520569",
          "90517287",
          "60520540"
        ],
        "code": "55100",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79432807",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "90517287",
          "00517277",
          "60520564",
          "60520540"
        ],
        "code": "55105",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79432812",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "80520558",
          "30517252"
        ],
        "code": "38148",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79433595",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "30517271",
          "20520561",
          "50517251"
        ],
        "code": "38155",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79433604",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40520560",
          "10488793",
          "50489494",
          "90517225",
          "80520558",
          "30517252"
        ],
        "code": "38156",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79434137",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "40517275",
          "30517285",
          "80520563",
          "60517255"
        ],
        "code": "42130",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79434279",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "60520559",
          "30488805",
          "10488793",
          "50489494",
          "80517235",
          "00520557",
          "90517254"
        ],
        "code": "38156",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79434359",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488794",
          "90489492",
          "70489488",
          "90515981",
          "60516246",
          "30516196"
        ],
        "code": "38158",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79434364",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "20517257",
          "60520564",
          "00517277"
        ],
        "code": "38155",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79434397",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "20517257",
          "50520569"
        ],
        "code": "38151",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79434401",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "20517257",
          "60520564",
          "30517233"
        ],
        "code": "38149",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79434458",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "60520540",
          "60520564",
          "30517233"
        ],
        "code": "55160",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79436730",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50466789",
          "00417621",
          "50466751",
          "10568638"
        ],
        "code": "44672",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79477339",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "80466702",
          "50417930",
          "00465377",
          "50465370",
          "90568639"
        ],
        "code": "48440",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79477358",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60466699",
          "70465345",
          "40465380",
          "00417621",
          "20465376",
          "70465369",
          "10568638"
        ],
        "code": "44671",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79477377",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "20488764",
          "90488807",
          "50489489",
          "00417621",
          "50498115",
          "80557962",
          "50557949",
          "90557985",
          "40557978",
          "30557945",
          "50568641"
        ],
        "code": "55335",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79501297",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "50498115",
          "80557938",
          "10557951",
          "40557983"
        ],
        "code": "55160",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79501607",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "20557984",
          "60488795",
          "50498115",
          "80557938",
          "10557951",
          "40557983"
        ],
        "code": "55083",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79501612",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "00557942",
          "40557983"
        ],
        "code": "38148",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79501645",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "50489489",
          "40411962",
          "60557963",
          "70557967",
          "40557983",
          "00557942"
        ],
        "code": "42130",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79501650",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "10488806",
          "90489492",
          "90488794",
          "50516195",
          "50515959",
          "70557646",
          "00515985"
        ],
        "code": "38156",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "79508270",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "60488762",
          "00417621",
          "50498115",
          "50568641",
          "40557978",
          "00557956",
          "30557945"
        ],
        "code": "55314",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79515987",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "50517307",
          "50517265",
          "60517255"
        ],
        "code": "44673",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536975",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "70517306",
          "90517254"
        ],
        "code": "44672",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79536980",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "80496186",
          "00496114",
          "70496139"
        ],
        "code": "44673",
        "cover": "hallarp-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79537060",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "80498114",
          "10568638",
          "10496180",
          "70500037",
          "80496148"
        ],
        "code": "55313",
        "cover": "hallarp-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79537084",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "40517303",
          "80498114",
          "10517272",
          "10568638",
          "90517225",
          "80520558",
          "00520543"
        ],
        "code": "55335",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79537244",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "60517302",
          "60517260",
          "10520547"
        ],
        "code": "55314",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79537277",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "30488805",
          "40488763",
          "30489490",
          "00417621",
          "80498114",
          "70568640",
          "30495844",
          "40500048",
          "30495783",
          "10495802",
          "00495812"
        ],
        "code": "55335",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "79545201",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "80498114",
          "10568638",
          "30495844",
          "40500048",
          "80495808"
        ],
        "code": "55314",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79545215",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "20495849",
          "10495798",
          "20495811"
        ],
        "code": "44673",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79545277",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "20495849",
          "10495798",
          "10495835"
        ],
        "code": "44674",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79545282",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466751",
          "20466743"
        ],
        "code": "38151",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89306648",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "20465376"
        ],
        "code": "38155",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89306686",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465345",
          "70465369",
          "40465380",
          "60465218",
          "60465384"
        ],
        "code": "48424",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89306728",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "30466766",
          "20466743"
        ],
        "code": "38156",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89306752",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40397126",
          "10496203",
          "10488793",
          "50489494",
          "80496092",
          "20496113"
        ],
        "code": "42133",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89399039",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "40397126",
          "50495862",
          "00496114",
          "00496152",
          "70496200"
        ],
        "code": "42130",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89399124",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "00495794",
          "00495789",
          "00495812"
        ],
        "code": "38158",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89399483",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "00496114",
          "70496097",
          "00496152"
        ],
        "code": "38158",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89399510",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30495783",
          "00495794"
        ],
        "code": "38148",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89399893",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "10495859",
          "70500037"
        ],
        "code": "55099",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89400561",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "70500037",
          "10495859",
          "80496148"
        ],
        "code": "55104",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89401419",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "90488765",
          "90489492",
          "70489488",
          "20397127",
          "40468755",
          "60516246",
          "40515969",
          "30516196"
        ],
        "code": "42130",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "89421498",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30520551",
          "10520547"
        ],
        "code": "55099",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89432675",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "40520560",
          "00520543"
        ],
        "code": "55101",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89432680",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "70520568",
          "40517275",
          "70520549"
        ],
        "code": "55166",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89432779",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "50520569",
          "00517277",
          "60520540"
        ],
        "code": "55166",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89432816",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "40397126",
          "40520560",
          "20517281",
          "30517252"
        ],
        "code": "42133",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89433608",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "60520559",
          "70517274",
          "90517254"
        ],
        "code": "38158",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89434274",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "40517275",
          "50489494",
          "30489490",
          "50517232",
          "80520563",
          "60517255"
        ],
        "code": "38153",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89434354",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "00517258",
          "30520570",
          "80517278"
        ],
        "code": "38158",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89434392",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "00517258",
          "30520565",
          "10517234",
          "80517278"
        ],
        "code": "38153",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89434453",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "90517230",
          "30520551",
          "10520547"
        ],
        "code": "55160",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89436777",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70520554",
          "10488793",
          "80498114",
          "80520544",
          "20517224",
          "20520561"
        ],
        "code": "55083",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89436782",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10520552",
          "50489494",
          "40488763",
          "40517256"
        ],
        "code": "38148",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89441156",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "30489490",
          "40520555",
          "20517276",
          "40517256"
        ],
        "code": "38158",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89441161",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50466789",
          "00417621",
          "80466759",
          "50466751",
          "10568638"
        ],
        "code": "44674",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89477353",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60466699",
          "60465218",
          "00417621",
          "70465369",
          "10568638"
        ],
        "code": "44673",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89477372",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "60488762",
          "00417621",
          "70489493",
          "50568641",
          "40557978",
          "00557956",
          "20557941"
        ],
        "code": "44673",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89501386",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "30498116",
          "10488806",
          "10516300",
          "40515974",
          "10557649"
        ],
        "code": "55160",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89508359",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70489493",
          "60488795",
          "10557989",
          "20557941",
          "40411962",
          "50557968"
        ],
        "code": "42133",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89515982",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "30517308",
          "30517266",
          "40517256"
        ],
        "code": "44673",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89536970",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "60517302",
          "80498114",
          "10568638",
          "50517270",
          "90517230",
          "30520551",
          "10520547"
        ],
        "code": "55335",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89537248",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "50489494",
          "10568638",
          "60517302",
          "60517260",
          "70517250"
        ],
        "code": "44673",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89537267",
        "rangeId": "vimle",
        "widthInMillimeters": 2610,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "60517302",
          "50517270",
          "10520547"
        ],
        "code": "55313",
        "cover": "djuparp-dark-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89537272",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "10568638",
          "30489490",
          "80498114",
          "10517309",
          "00517277",
          "60520540"
        ],
        "code": "55313",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "89537291",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "00417621",
          "10568638",
          "60489549",
          "30495844",
          "50489494",
          "00495794"
        ],
        "code": "44672",
        "cover": "gunnared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89545229",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "00417621",
          "50489489",
          "50498115",
          "50568641",
          "60557977",
          "80557938",
          "60557963"
        ],
        "code": "55313",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "89569395",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "70465369",
          "50465351",
          "70466689"
        ],
        "code": "42133",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99306252",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "30466766",
          "50466713",
          "40466780",
          "30466785"
        ],
        "code": "48423",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99306285",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465369",
          "50465351"
        ],
        "code": "38151",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99306643",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "10466734",
          "50466751",
          "30466766"
        ],
        "code": "38149",
        "cover": "grann-bomstad-golden-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99306723",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "70465369",
          "40465380",
          "60465218",
          "60465384"
        ],
        "code": "48421",
        "cover": "grann-bomstad-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99306756",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "10495859",
          "20496113"
        ],
        "code": "38148",
        "cover": "hallarp-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99399005",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "50489494",
          "00495794",
          "30495783",
          "00495812"
        ],
        "code": "38155",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99399109",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "30489490",
          "00495794",
          "30495783",
          "10495802",
          "00495812"
        ],
        "code": "38153",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99399581",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "10495784",
          "80498114",
          "70501541"
        ],
        "code": "55099",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99400546",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "10495784",
          "70501541",
          "10495835"
        ],
        "code": "55104",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99401292",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "50495862",
          "90500036",
          "00496152",
          "70496200"
        ],
        "code": "55104",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99401414",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "90500036",
          "70496097"
        ],
        "code": "55101",
        "cover": "hallarp-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99401433",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "30489490",
          "40500048",
          "00495789",
          "00495812"
        ],
        "code": "55166",
        "cover": "gunnared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99401763",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30488805",
          "10495784",
          "70501541",
          "40495805"
        ],
        "code": "55160",
        "cover": "gunnared-medium-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99401796",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "10488793",
          "80498114",
          "30489490",
          "10520566",
          "50517270",
          "10520547"
        ],
        "code": "55166",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99432689",
        "rangeId": "vimle",
        "widthInMillimeters": 3360,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "80498114",
          "10488793",
          "40520555",
          "50520545"
        ],
        "code": "55101",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432769",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30489490",
          "80498114",
          "20517276",
          "10520552",
          "50520545"
        ],
        "code": "55104",
        "cover": "hillared-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99432774",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30520565",
          "40520541"
        ],
        "code": "55099",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99432806",
        "rangeId": "vimle",
        "widthInMillimeters": 1850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "80498114",
          "30489490",
          "40397126",
          "70517288",
          "80517278",
          "30520565",
          "40520541"
        ],
        "code": "55105",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99432811",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "70520554",
          "50517251"
        ],
        "code": "38151",
        "cover": "djuparp-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99433599",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "10517272",
          "80520558",
          "30517252"
        ],
        "code": "38155",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99433603",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10520566",
          "10488793",
          "50489494",
          "90517230",
          "30520551",
          "70517250"
        ],
        "code": "38156",
        "cover": "djuparp-dark-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434136",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "10517272",
          "50489494",
          "30489490",
          "90517225",
          "80520558",
          "30517252"
        ],
        "code": "38153",
        "cover": "djuparp-dark-green-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99434141",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "70517274",
          "00520557",
          "90517254"
        ],
        "code": "38155",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99434278",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "00520557",
          "90517254"
        ],
        "code": "38148",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434283",
        "rangeId": "vimle",
        "widthInMillimeters": 1710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70520568",
          "10488793",
          "50489494",
          "50517232",
          "80520563",
          "60517255"
        ],
        "code": "38156",
        "cover": "hillared-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434358",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "80517235",
          "00520557",
          "90517254"
        ],
        "code": "38149",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434363",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "50489494",
          "30489490",
          "00517258",
          "30520565",
          "80517278"
        ],
        "code": "38155",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99434396",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50489494",
          "10488793",
          "00517258",
          "30520570"
        ],
        "code": "38151",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434400",
        "rangeId": "vimle",
        "widthInMillimeters": 2410,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "50489494",
          "00517258",
          "30520565",
          "10517234"
        ],
        "code": "38149",
        "cover": "lejde-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99434457",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "70517274",
          "80498114",
          "30489490",
          "80517235",
          "00520557",
          "20520542"
        ],
        "code": "55081",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99436692",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "40488763",
          "30488805",
          "80498114",
          "30489490",
          "60520540",
          "60520564",
          "30517233",
          "00517277"
        ],
        "code": "55081",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99436734",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60466699",
          "00417621",
          "20465376",
          "70465369",
          "70568640"
        ],
        "code": "48440",
        "cover": "grann-bomstad-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "99477357",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "50498115",
          "50489489",
          "80557962",
          "50557949",
          "90557985",
          "30557945"
        ],
        "code": "55081",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99501277",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "70489493",
          "50489489",
          "80557962",
          "50557949",
          "90557985",
          "20557941"
        ],
        "code": "38153",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99501282",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "40489550",
          "00417621",
          "70489493",
          "50568641",
          "40557978",
          "20557941"
        ],
        "code": "44672",
        "cover": "djuparp-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99501376",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "70489493",
          "00557942",
          "10557951",
          "40557983"
        ],
        "code": "38149",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99501606",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "20488764",
          "90488807",
          "50498115",
          "50489489",
          "60557963",
          "10557951",
          "40557983",
          "80557938"
        ],
        "code": "55081",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99501611",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "20488764",
          "70489493",
          "50489489",
          "60557963",
          "40557983",
          "00557942"
        ],
        "code": "38155",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99501649",
        "rangeId": "vimle",
        "widthInMillimeters": 2520,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "90488765",
          "70489488",
          "30498116",
          "40516247",
          "60515973",
          "30516304"
        ],
        "code": "55104",
        "cover": "lejde-grey-black",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "99507986",
        "rangeId": "vimle",
        "widthInMillimeters": 2660,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60488795",
          "20557984",
          "70557967",
          "40411962",
          "70489493",
          "00557942"
        ],
        "code": "42133",
        "cover": "djuparp-dark-blue",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99515953",
        "rangeId": "vimle",
        "widthInMillimeters": 2550,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "50498115",
          "60488795",
          "50489489",
          "30557945",
          "10557989",
          "80557962"
        ],
        "code": "55166",
        "cover": "djuparp-red-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99515986",
        "rangeId": "vimle",
        "widthInMillimeters": 3220,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "50517307",
          "60517255"
        ],
        "code": "44672",
        "cover": "hillared-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99536979",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "70517306",
          "70517274",
          "10568638",
          "80517235",
          "00520557",
          "90517254"
        ],
        "code": "44671",
        "cover": "hillared-anthracite",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99536984",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "50489494",
          "10568638",
          "20517304",
          "50517251"
        ],
        "code": "44672",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99537257",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "80498114",
          "20517304",
          "80520544",
          "10568638",
          "00417621"
        ],
        "code": "55312",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99537262",
        "rangeId": "vimle",
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "10568638",
          "80498114",
          "20517304",
          "40517261",
          "80520544"
        ],
        "code": "55314",
        "cover": "djuparp-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99537276",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "40488763",
          "30488805",
          "30489490",
          "00417621",
          "50489494",
          "10568638",
          "10517309",
          "20517257",
          "60520564",
          "30517233",
          "00517277"
        ],
        "code": "44671",
        "cover": "lejde-grey-black",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99537281",
        "rangeId": "vimle",
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "90517310",
          "50489494",
          "10568638",
          "00517258"
        ],
        "code": "44672",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99537549",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "30489490",
          "50489494",
          "10568638",
          "90517310",
          "00517258",
          "80517278"
        ],
        "code": "44674",
        "cover": "lejde-red-brown",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "99537554",
        "rangeId": "vimle",
        "widthInMillimeters": 2710,
        "armrestDimension": "standard"
      },
      {
        "childItems": [
          "60489549",
          "60488639",
          "00417621",
          "80498114",
          "10568638",
          "20495849",
          "70501541",
          "20495811"
        ],
        "code": "55314",
        "cover": "gunnared-medium-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99545257",
        "rangeId": "vimle",
        "widthInMillimeters": 2750,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "60489549",
          "00417621",
          "70569885",
          "30489490",
          "80498114",
          "30517308",
          "20517276",
          "50520545"
        ],
        "code": "55313",
        "cover": "hillared-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "isMissingBryggaData": true,
        "itemNo": "99562124",
        "rangeId": "vimle",
        "widthInMillimeters": 2850,
        "armrestDimension": "wide"
      },
      {
        "childItems": [
          "00417621",
          "50568641",
          "40489550",
          "60557977",
          "70489493",
          "00557942"
        ],
        "code": "44672",
        "cover": "djuparp-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingBryggaData": true,
        "itemNo": "99569390",
        "rangeId": "vimle",
        "widthInMillimeters": 1900,
        "armrestDimension": "standard"
      }
    ],
    "hasArmrestPicker": true
  },
  "vinliden": {
    "coverProducts": [
      {
        "itemNo": "00438360",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "00443738",
        "name": "hakebo-light-turquoise"
      },
      {
        "itemNo": "00455378",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "00455383",
        "name": "hillared-anthracite"
      },
      {
        "itemNo": "30438368",
        "name": "with-chaise-longue-hakebo-dark-grey"
      },
      {
        "itemNo": "50438353",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "50443769",
        "name": "with-chaise-longue-hakebo-beige"
      },
      {
        "itemNo": "60443759",
        "name": "hakebo-beige"
      },
      {
        "itemNo": "60443764",
        "name": "hakebo-beige"
      },
      {
        "itemNo": "70443749",
        "name": "with-chaise-longue-hakebo-light-turquoise"
      },
      {
        "itemNo": "80443744",
        "name": "hakebo-light-turquoise"
      },
      {
        "itemNo": "90455388",
        "name": "with-chaise-longue-hillared-anthracite"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00041.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00102.jpg",
        "name": "hakebo-light-turquoise"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "hillared-anthracite",
        "dotOverride": "#424146"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "hakebo-beige"
      }
    ],
    "displayName": "VINLIDEN",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "50438273",
          "60443759",
          "30484845"
        ],
        "code": "69318",
        "cover": "hakebo-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09304605",
        "rangeId": "vinliden",
        "widthInMillimeters": 1630
      },
      {
        "childItems": [
          "60438338",
          "60443764",
          "30484845"
        ],
        "code": "69319",
        "cover": "hakebo-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09304648",
        "rangeId": "vinliden",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "60438343",
          "50443769",
          "30484845"
        ],
        "code": "69320",
        "cover": "hakebo-beige",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09304672",
        "rangeId": "vinliden",
        "widthInMillimeters": 2330
      },
      {
        "childItems": [
          "50438273",
          "00443738",
          "30484845"
        ],
        "code": "69318",
        "cover": "hakebo-light-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19304619",
        "rangeId": "vinliden",
        "widthInMillimeters": 1630
      },
      {
        "childItems": [
          "60438338",
          "80443744",
          "30484845"
        ],
        "code": "69319",
        "cover": "hakebo-light-turquoise",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19304657",
        "rangeId": "vinliden",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "60438343",
          "70443749",
          "30484845"
        ],
        "code": "69320",
        "cover": "hakebo-light-turquoise",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19304681",
        "rangeId": "vinliden",
        "widthInMillimeters": 2330
      },
      {
        "childItems": [
          "50438273",
          "00455378",
          "30484845"
        ],
        "code": "69318",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29304633",
        "rangeId": "vinliden",
        "widthInMillimeters": 1630
      },
      {
        "childItems": [
          "60438343",
          "30438368",
          "30484845"
        ],
        "code": "69320",
        "cover": "hakebo-dark-grey",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39304675",
        "rangeId": "vinliden",
        "widthInMillimeters": 2330
      },
      {
        "childItems": [
          "60438338",
          "50438353",
          "30484845"
        ],
        "code": "69319",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49304651",
        "rangeId": "vinliden",
        "widthInMillimeters": 2030
      },
      {
        "childItems": [
          "60438343",
          "90455388",
          "30484845"
        ],
        "code": "69320",
        "cover": "hillared-anthracite",
        "hasMirroredVariation": true,
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "89304687",
        "rangeId": "vinliden",
        "widthInMillimeters": 2330
      },
      {
        "childItems": [
          "50438273",
          "00438360",
          "30484845"
        ],
        "code": "69318",
        "cover": "hakebo-dark-grey",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99304615",
        "rangeId": "vinliden",
        "widthInMillimeters": 1630
      },
      {
        "childItems": [
          "60438338",
          "00455383",
          "30484845"
        ],
        "code": "69319",
        "cover": "hillared-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99304663",
        "rangeId": "vinliden",
        "widthInMillimeters": 2030
      }
    ]
  },
  "viskafors": {
    "coverProducts": null,
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00008.jpg",
        "name": "lejde-anthracite"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00139.jpg",
        "name": "hogalid-brown"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "lejde-grey-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "lejde-light-beige"
      }
    ],
    "displayName": "VISKAFORS",
    "hasRemovableCover": false,
    "hasRecliningBackrest": false,
    "hasSofabed": false,
    "hasStorage": false,
    "legs": [
      {
        "itemNo": "60523464",
        "name": "birch"
      },
      {
        "itemNo": "70525028",
        "name": "brown"
      }
    ],
    "mattresses": null,
    "sofas": [
      {
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "00521788",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940
      },
      {
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "20522249",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240
      },
      {
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30522239",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240
      },
      {
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "30522244",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240
      },
      {
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40513357",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240
      },
      {
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40522229",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940
      },
      {
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "40522234",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940
      },
      {
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "isMissingGenericProduct": true,
        "isMissingMainProductPictureAltText": true,
        "itemNo": "50522224",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940
      },
      {
        "childItems": [
          "20522249",
          "70525028"
        ],
        "code": "58910",
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443357",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "brown"
      },
      {
        "childItems": [
          "40513357",
          "70525028"
        ],
        "code": "58910",
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "09443362",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "brown"
      },
      {
        "childItems": [
          "20522249",
          "60523464"
        ],
        "code": "58910",
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "19443352",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "birch"
      },
      {
        "childItems": [
          "40522229",
          "70525028"
        ],
        "code": "58909",
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443257",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "brown"
      },
      {
        "childItems": [
          "50522224",
          "70525028"
        ],
        "code": "58909",
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443262",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "brown"
      },
      {
        "childItems": [
          "30522239",
          "60523464"
        ],
        "code": "58910",
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "29443337",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "birch"
      },
      {
        "childItems": [
          "00521788",
          "60523464"
        ],
        "code": "58909",
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443209",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "birch"
      },
      {
        "childItems": [
          "40522234",
          "70525028"
        ],
        "code": "58909",
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443247",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "brown"
      },
      {
        "childItems": [
          "00521788",
          "70525028"
        ],
        "code": "58909",
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443252",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "brown"
      },
      {
        "childItems": [
          "40513357",
          "60523464"
        ],
        "code": "58910",
        "cover": "lejde-anthracite",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443327",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "birch"
      },
      {
        "childItems": [
          "30522244",
          "60523464"
        ],
        "code": "58910",
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "39443332",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "birch"
      },
      {
        "childItems": [
          "50522224",
          "60523464"
        ],
        "code": "58909",
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443218",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "birch"
      },
      {
        "childItems": [
          "40522234",
          "60523464"
        ],
        "code": "58909",
        "cover": "hogalid-brown",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "49443242",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "birch"
      },
      {
        "childItems": [
          "40522229",
          "60523464"
        ],
        "code": "58909",
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "79443212",
        "rangeId": "viskafors",
        "widthInMillimeters": 1940,
        "legs": "birch"
      },
      {
        "childItems": [
          "30522239",
          "70525028"
        ],
        "code": "58910",
        "cover": "lejde-grey-green",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99443367",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "brown"
      },
      {
        "childItems": [
          "30522244",
          "70525028"
        ],
        "code": "58910",
        "cover": "lejde-light-beige",
        "hasSofabed": false,
        "hasRecliningBackrest": false,
        "hasStorage": false,
        "itemNo": "99443372",
        "rangeId": "viskafors",
        "widthInMillimeters": 2240,
        "legs": "brown"
      }
    ]
  },
  "vretstorp": {
    "coverProducts": [
      {
        "itemNo": "20545180",
        "name": "kilanda-dark-blue"
      },
      {
        "itemNo": "50544787",
        "name": "hakebo-dark-grey"
      },
      {
        "itemNo": "50545174",
        "name": "hakebo-grey-green"
      },
      {
        "itemNo": "90545186",
        "name": "kilanda-light-beige"
      },
      {
        "itemNo": "90547623",
        "name": "karlshov-beige-multicolour"
      }
    ],
    "covers": [
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00147.jpg",
        "name": "kilanda-dark-blue",
        "dotOverride": "#47525F"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00036.jpg",
        "name": "hakebo-dark-grey"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00035.jpg",
        "name": "hakebo-grey-green"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00040.jpg",
        "name": "kilanda-light-beige",
        "dotOverride": "#DED5C6"
      },
      {
        "dotUrl": "https://www.ikea.com/pimg/symbols/dots/00135.jpg",
        "name": "karlshov-beige-multicolour",
        "dotOverride": [
          "#AF9F92",
          "#4B4746",
          "#EFEAE9",
          "#878381"
        ]
      }
    ],
    "displayName": "VRETSTORP",
    "hasRemovableCover": true,
    "hasRecliningBackrest": false,
    "hasSofabed": true,
    "hasStorage": true,
    "legs": null,
    "mattresses": null,
    "sofas": [
      {
        "childItems": [
          "20472602",
          "90547623"
        ],
        "code": "49839",
        "cover": "karlshov-beige-multicolour",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09491230",
        "rangeId": "vretstorp",
        "widthInMillimeters": 2440
      },
      {
        "childItems": [
          "20472602",
          "50545174"
        ],
        "code": "49839",
        "cover": "hakebo-grey-green",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "09491254",
        "rangeId": "vretstorp",
        "widthInMillimeters": 2440
      },
      {
        "childItems": [
          "20472602",
          "50544787"
        ],
        "code": "49839",
        "cover": "hakebo-dark-grey",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "29491248",
        "rangeId": "vretstorp",
        "widthInMillimeters": 2440
      },
      {
        "childItems": [
          "20472602",
          "20545180"
        ],
        "code": "49839",
        "cover": "kilanda-dark-blue",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "59491242",
        "rangeId": "vretstorp",
        "widthInMillimeters": 2440
      },
      {
        "childItems": [
          "20472602",
          "90545186"
        ],
        "code": "49839",
        "cover": "kilanda-light-beige",
        "hasSofabed": true,
        "hasRecliningBackrest": false,
        "hasStorage": true,
        "itemNo": "79491236",
        "rangeId": "vretstorp",
        "widthInMillimeters": 2440
      }
    ]
  }
}